var regionData = [{
  "children": [{
    "value": "市辖区",
    "children": [{
      "value": "东城区",
      "code": "100001",
      "label": "东城区"
    }, {
      "value": "西城区",
      "code": "100017",
      "label": "西城区"
    }, {
      "value": "朝阳区",
      "code": "100012",
      "label": "朝阳区"
    }, {
      "value": "丰台区",
      "code": "100054",
      "label": "丰台区"
    }, {
      "value": "石景山区",
      "code": "100041",
      "label": "石景山区"
    }, {
      "value": "海淀区",
      "code": "100080",
      "label": "海淀区"
    }, {
      "value": "门头沟区",
      "code": "102300",
      "label": "门头沟区"
    }, {
      "value": "房山区",
      "code": "102400",
      "label": "房山区"
    }, {
      "value": "通州区",
      "code": "101100",
      "label": "通州区"
    }, {
      "value": "顺义区",
      "code": "101300",
      "label": "顺义区"
    }, {
      "value": "昌平区",
      "code": "102200",
      "label": "昌平区"
    }, {
      "value": "大兴区",
      "code": "102600",
      "label": "大兴区"
    }, {
      "value": "怀柔区",
      "code": "101400",
      "label": "怀柔区"
    }, {
      "value": "平谷区",
      "code": "101200",
      "label": "平谷区"
    }, {
      "value": "密云区",
      "code": "101500",
      "label": "密云区"
    }, {
      "value": "延庆区",
      "code": "102100",
      "label": "延庆区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "市辖区"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "北京市",
  "label": "北京市"
}, {
  "children": [{
    "value": "市辖区",
    "children": [{
      "value": "和平区",
      "code": "300021",
      "label": "和平区"
    }, {
      "value": "河东区",
      "code": "300010",
      "label": "河东区"
    }, {
      "value": "河西区",
      "code": "300060",
      "label": "河西区"
    }, {
      "value": "南开区",
      "code": "300021",
      "label": "南开区"
    }, {
      "value": "河北区",
      "code": "300010",
      "label": "河北区"
    }, {
      "value": "红桥区",
      "code": "300091",
      "label": "红桥区"
    }, {
      "value": "东丽区",
      "code": "300161",
      "label": "东丽区"
    }, {
      "value": "西青区",
      "code": "300382",
      "label": "西青区"
    }, {
      "value": "津南区",
      "code": "300352",
      "label": "津南区"
    }, {
      "value": "北辰区",
      "code": "300401",
      "label": "北辰区"
    }, {
      "value": "武清区",
      "code": "301700",
      "label": "武清区"
    }, {
      "value": "宝坻区",
      "code": "301800",
      "label": "宝坻区"
    }, {
      "value": "滨海新区",
      "code": "300270",
      "label": "滨海新区"
    }, {
      "value": "宁河区",
      "code": "301500",
      "label": "宁河区"
    }, {
      "value": "静海区",
      "code": "301600",
      "label": "静海区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "市辖区"
  }, {
    "value": "辖县",
    "children": [{
      "value": "蓟县",
      "code": "301900",
      "label": "蓟县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "辖县"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "天津市",
  "label": "天津市"
}, {
  "children": [{
    "value": "石家庄市",
    "children": [{
      "value": "长安区",
      "code": "050010",
      "label": "长安区"
    }, {
      "value": "桥西区",
      "code": "050001",
      "label": "桥西区"
    }, {
      "value": "新华区",
      "code": "050003",
      "label": "新华区"
    }, {
      "value": "井陉矿区",
      "code": "050100",
      "label": "井陉矿区"
    }, {
      "value": "裕华区",
      "code": "050013",
      "label": "裕华区"
    }, {
      "value": "藁城区",
      "code": "052166",
      "label": "藁城区"
    }, {
      "value": "鹿泉区",
      "code": "050200",
      "label": "鹿泉区"
    }, {
      "value": "栾城区",
      "code": "050027",
      "label": "栾城区"
    }, {
      "value": "井陉县",
      "code": "050300",
      "label": "井陉县"
    }, {
      "value": "正定县",
      "code": "050800",
      "label": "正定县"
    }, {
      "value": "行唐县",
      "code": "050600",
      "label": "行唐县"
    }, {
      "value": "灵寿县",
      "code": "050500",
      "label": "灵寿县"
    }, {
      "value": "高邑县",
      "code": "051330",
      "label": "高邑县"
    }, {
      "value": "深泽县",
      "code": "052560",
      "label": "深泽县"
    }, {
      "value": "赞皇县",
      "code": "051230",
      "label": "赞皇县"
    }, {
      "value": "无极县",
      "code": "052460",
      "label": "无极县"
    }, {
      "value": "平山县",
      "code": "050400",
      "label": "平山县"
    }, {
      "value": "元氏县",
      "code": "051130",
      "label": "元氏县"
    }, {
      "value": "赵县",
      "code": "051530",
      "label": "赵县"
    }, {
      "value": "辛集市",
      "code": "052360",
      "label": "辛集市"
    }, {
      "value": "晋州市",
      "code": "052260",
      "label": "晋州市"
    }, {
      "value": "新乐市",
      "code": "050700",
      "label": "新乐市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "石家庄市"
  }, {
    "value": "唐山市",
    "children": [{
      "value": "路南区",
      "code": "063001",
      "label": "路南区"
    }, {
      "value": "路北区",
      "code": "063004",
      "label": "路北区"
    }, {
      "value": "古冶区",
      "code": "063100",
      "label": "古冶区"
    }, {
      "value": "开平区",
      "code": "063021",
      "label": "开平区"
    }, {
      "value": "丰南区",
      "code": "063300",
      "label": "丰南区"
    }, {
      "value": "丰润区",
      "code": "064001",
      "label": "丰润区"
    }, {
      "value": "曹妃甸区",
      "code": "063200",
      "label": "曹妃甸区"
    }, {
      "value": "滦县",
      "code": "063700",
      "label": "滦县"
    }, {
      "value": "滦南县",
      "code": "063500",
      "label": "滦南县"
    }, {
      "value": "乐亭县",
      "code": "063600",
      "label": "乐亭县"
    }, {
      "value": "迁西县",
      "code": "064300",
      "label": "迁西县"
    }, {
      "value": "玉田县",
      "code": "064100",
      "label": "玉田县"
    }, {
      "value": "遵化市",
      "code": "064200",
      "label": "遵化市"
    }, {
      "value": "迁安市",
      "code": "064400",
      "label": "迁安市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "唐山市"
  }, {
    "value": "秦皇岛市",
    "children": [{
      "value": "海港区",
      "code": "066001",
      "label": "海港区"
    }, {
      "value": "山海关区",
      "code": "066200",
      "label": "山海关区"
    }, {
      "value": "北戴河区",
      "code": "066100",
      "label": "北戴河区"
    }, {
      "value": "抚宁区",
      "code": "066300",
      "label": "抚宁区"
    }, {
      "value": "青龙满族自治县",
      "code": "066500",
      "label": "青龙满族自治县"
    }, {
      "value": "昌黎县",
      "code": "066600",
      "label": "昌黎县"
    }, {
      "value": "卢龙县",
      "code": "066400",
      "label": "卢龙县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "秦皇岛市"
  }, {
    "value": "邯郸市",
    "children": [{
      "value": "邯山区",
      "code": "056001",
      "label": "邯山区"
    }, {
      "value": "丛台区",
      "code": "056008",
      "label": "丛台区"
    }, {
      "value": "复兴区",
      "code": "056003",
      "label": "复兴区"
    }, {
      "value": "峰峰矿区",
      "code": "056200",
      "label": "峰峰矿区"
    }, {
      "value": "邯郸县",
      "code": "056105",
      "label": "邯郸县"
    }, {
      "value": "临漳县",
      "code": "056600",
      "label": "临漳县"
    }, {
      "value": "成安县",
      "code": "056700",
      "label": "成安县"
    }, {
      "value": "大名县",
      "code": "056900",
      "label": "大名县"
    }, {
      "value": "涉县",
      "code": "056400",
      "label": "涉县"
    }, {
      "value": "磁县",
      "code": "056500",
      "label": "磁县"
    }, {
      "value": "肥乡县",
      "code": "057550",
      "label": "肥乡县"
    }, {
      "value": "永年县",
      "code": "057150",
      "label": "永年县"
    }, {
      "value": "邱县",
      "code": "057450",
      "label": "邱县"
    }, {
      "value": "鸡泽县",
      "code": "057350",
      "label": "鸡泽县"
    }, {
      "value": "广平县",
      "code": "057650",
      "label": "广平县"
    }, {
      "value": "馆陶县",
      "code": "057750",
      "label": "馆陶县"
    }, {
      "value": "魏县",
      "code": "056800",
      "label": "魏县"
    }, {
      "value": "曲周县",
      "code": "057250",
      "label": "曲周县"
    }, {
      "value": "武安市",
      "code": "056300",
      "label": "武安市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "邯郸市"
  }, {
    "value": "邢台市",
    "children": [{
      "value": "桥东区",
      "code": "054001",
      "label": "桥东区"
    }, {
      "value": "桥西区",
      "code": "054000",
      "label": "桥西区"
    }, {
      "value": "邢台县",
      "code": "054007",
      "label": "邢台县"
    }, {
      "value": "临城县",
      "code": "054300",
      "label": "临城县"
    }, {
      "value": "内丘县",
      "code": "054200",
      "label": "内丘县"
    }, {
      "value": "柏乡县",
      "code": "055450",
      "label": "柏乡县"
    }, {
      "value": "隆尧县",
      "code": "055350",
      "label": "隆尧县"
    }, {
      "value": "任县",
      "code": "055150",
      "label": "任县"
    }, {
      "value": "南和县",
      "code": "054400",
      "label": "南和县"
    }, {
      "value": "宁晋县",
      "code": "055550",
      "label": "宁晋县"
    }, {
      "value": "巨鹿县",
      "code": "055250",
      "label": "巨鹿县"
    }, {
      "value": "新河县",
      "code": "055650",
      "label": "新河县"
    }, {
      "value": "广宗县",
      "code": "054600",
      "label": "广宗县"
    }, {
      "value": "平乡县",
      "code": "054500",
      "label": "平乡县"
    }, {
      "value": "威县",
      "code": "054700",
      "label": "威县"
    }, {
      "value": "清河县",
      "code": "054800",
      "label": "清河县"
    }, {
      "value": "临西县",
      "code": "054900",
      "label": "临西县"
    }, {
      "value": "南宫市",
      "code": "055750",
      "label": "南宫市"
    }, {
      "value": "沙河市",
      "code": "054100",
      "label": "沙河市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "邢台市"
  }, {
    "value": "保定市",
    "children": [{
      "value": "新市区",
      "code": "071024",
      "label": "新市区"
    }, {
      "value": "莲池区",
      "code": "071000",
      "label": "莲池区"
    }, {
      "value": "满城区",
      "code": "072150",
      "label": "满城区"
    }, {
      "value": "清苑区",
      "code": "071100",
      "label": "清苑区"
    }, {
      "value": "徐水区",
      "code": "072550",
      "label": "徐水区"
    }, {
      "value": "涞水县",
      "code": "074100",
      "label": "涞水县"
    }, {
      "value": "阜平县",
      "code": "073200",
      "label": "阜平县"
    }, {
      "value": "定兴县",
      "code": "072650",
      "label": "定兴县"
    }, {
      "value": "唐县",
      "code": "072350",
      "label": "唐县"
    }, {
      "value": "高阳县",
      "code": "071500",
      "label": "高阳县"
    }, {
      "value": "容城县",
      "code": "071700",
      "label": "容城县"
    }, {
      "value": "涞源县",
      "code": "074300",
      "label": "涞源县"
    }, {
      "value": "望都县",
      "code": "072450",
      "label": "望都县"
    }, {
      "value": "安新县",
      "code": "071600",
      "label": "安新县"
    }, {
      "value": "易县",
      "code": "074200",
      "label": "易县"
    }, {
      "value": "曲阳县",
      "code": "073100",
      "label": "曲阳县"
    }, {
      "value": "蠡县",
      "code": "071400",
      "label": "蠡县"
    }, {
      "value": "顺平县",
      "code": "072250",
      "label": "顺平县"
    }, {
      "value": "博野县",
      "code": "071300",
      "label": "博野县"
    }, {
      "value": "雄县",
      "code": "071800",
      "label": "雄县"
    }, {
      "value": "涿州市",
      "code": "072750",
      "label": "涿州市"
    }, {
      "value": "定州市",
      "code": "073000",
      "label": "定州市"
    }, {
      "value": "安国市",
      "code": "071200",
      "label": "安国市"
    }, {
      "value": "高碑店市",
      "code": "074000",
      "label": "高碑店市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "保定市"
  }, {
    "value": "张家口市",
    "children": [{
      "value": "桥东区",
      "code": "075051",
      "label": "桥东区"
    }, {
      "value": "桥西区",
      "code": "075061",
      "label": "桥西区"
    }, {
      "value": "宣化区",
      "code": "075000",
      "label": "宣化区"
    }, {
      "value": "下花园区",
      "code": "075300",
      "label": "下花园区"
    }, {
      "value": "宣化县",
      "code": "075100",
      "label": "宣化县"
    }, {
      "value": "张北县",
      "code": "076450",
      "label": "张北县"
    }, {
      "value": "康保县",
      "code": "076650",
      "label": "康保县"
    }, {
      "value": "沽源县",
      "code": "076550",
      "label": "沽源县"
    }, {
      "value": "尚义县",
      "code": "076750",
      "label": "尚义县"
    }, {
      "value": "蔚县",
      "code": "075700",
      "label": "蔚县"
    }, {
      "value": "阳原县",
      "code": "075800",
      "label": "阳原县"
    }, {
      "value": "怀安县",
      "code": "076150",
      "label": "怀安县"
    }, {
      "value": "万全县",
      "code": "076250",
      "label": "万全县"
    }, {
      "value": "怀来县",
      "code": "075400",
      "label": "怀来县"
    }, {
      "value": "涿鹿县",
      "code": "075600",
      "label": "涿鹿县"
    }, {
      "value": "赤城县",
      "code": "075500",
      "label": "赤城县"
    }, {
      "value": "崇礼县",
      "code": "076350",
      "label": "崇礼县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "张家口市"
  }, {
    "value": "承德市",
    "children": [{
      "value": "双桥区",
      "code": "067000",
      "label": "双桥区"
    }, {
      "value": "双滦区",
      "code": "067110",
      "label": "双滦区"
    }, {
      "value": "鹰手营子矿区",
      "code": "067200",
      "label": "鹰手营子矿区"
    }, {
      "value": "承德县",
      "code": "067400",
      "label": "承德县"
    }, {
      "value": "兴隆县",
      "code": "067202",
      "label": "兴隆县"
    }, {
      "value": "平泉县",
      "code": "067500",
      "label": "平泉县"
    }, {
      "value": "滦平县",
      "code": "068250",
      "label": "滦平县"
    }, {
      "value": "隆化县",
      "code": "068150",
      "label": "隆化县"
    }, {
      "value": "丰宁满族自治县",
      "code": "068350",
      "label": "丰宁满族自治县"
    }, {
      "value": "宽城满族自治县",
      "code": "067600",
      "label": "宽城满族自治县"
    }, {
      "value": "围场满族蒙古族自治县",
      "code": "068450",
      "label": "围场满族蒙古族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "承德市"
  }, {
    "value": "沧州市",
    "children": [{
      "value": "新华区",
      "code": "061002",
      "label": "新华区"
    }, {
      "value": "运河区",
      "code": "061001",
      "label": "运河区"
    }, {
      "value": "沧县",
      "code": "061000",
      "label": "沧县"
    }, {
      "value": "青县",
      "code": "062650",
      "label": "青县"
    }, {
      "value": "东光县",
      "code": "061600",
      "label": "东光县"
    }, {
      "value": "海兴县",
      "code": "061200",
      "label": "海兴县"
    }, {
      "value": "盐山县",
      "code": "061300",
      "label": "盐山县"
    }, {
      "value": "肃宁县",
      "code": "062350",
      "label": "肃宁县"
    }, {
      "value": "南皮县",
      "code": "061500",
      "label": "南皮县"
    }, {
      "value": "吴桥县",
      "code": "061800",
      "label": "吴桥县"
    }, {
      "value": "献县",
      "code": "062250",
      "label": "献县"
    }, {
      "value": "孟村回族自治县",
      "code": "061400",
      "label": "孟村回族自治县"
    }, {
      "value": "泊头市",
      "code": "062150",
      "label": "泊头市"
    }, {
      "value": "任丘市",
      "code": "062550",
      "label": "任丘市"
    }, {
      "value": "黄骅市",
      "code": "061100",
      "label": "黄骅市"
    }, {
      "value": "河间市",
      "code": "062450",
      "label": "河间市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "沧州市"
  }, {
    "value": "廊坊市",
    "children": [{
      "value": "安次区",
      "code": "065003",
      "label": "安次区"
    }, {
      "value": "广阳区",
      "code": "065001",
      "label": "广阳区"
    }, {
      "value": "固安县",
      "code": "065500",
      "label": "固安县"
    }, {
      "value": "永清县",
      "code": "065600",
      "label": "永清县"
    }, {
      "value": "香河县",
      "code": "065400",
      "label": "香河县"
    }, {
      "value": "大城县",
      "code": "065900",
      "label": "大城县"
    }, {
      "value": "文安县",
      "code": "065800",
      "label": "文安县"
    }, {
      "value": "大厂回族自治县",
      "code": "065300",
      "label": "大厂回族自治县"
    }, {
      "value": "霸州市",
      "code": "065700",
      "label": "霸州市"
    }, {
      "value": "三河市",
      "code": "065200",
      "label": "三河市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "廊坊市"
  }, {
    "value": "衡水市",
    "children": [{
      "value": "桃城区",
      "code": "053000",
      "label": "桃城区"
    }, {
      "value": "枣强县",
      "code": "053100",
      "label": "枣强县"
    }, {
      "value": "武邑县",
      "code": "053400",
      "label": "武邑县"
    }, {
      "value": "武强县",
      "code": "053300",
      "label": "武强县"
    }, {
      "value": "饶阳县",
      "code": "053900",
      "label": "饶阳县"
    }, {
      "value": "安平县",
      "code": "053600",
      "label": "安平县"
    }, {
      "value": "故城县",
      "code": "253800",
      "label": "故城县"
    }, {
      "value": "景县",
      "code": "053500",
      "label": "景县"
    }, {
      "value": "阜城县",
      "code": "053700",
      "label": "阜城县"
    }, {
      "value": "冀州市",
      "code": "053200",
      "label": "冀州市"
    }, {
      "value": "深州市",
      "code": "053800",
      "label": "深州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "衡水市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "河北省",
  "label": "河北省"
}, {
  "children": [{
    "value": "太原市",
    "children": [{
      "value": "小店区",
      "code": "030006",
      "label": "小店区"
    }, {
      "value": "迎泽区",
      "code": "030044",
      "label": "迎泽区"
    }, {
      "value": "杏花岭区",
      "code": "030009",
      "label": "杏花岭区"
    }, {
      "value": "尖草坪区",
      "code": "030008",
      "label": "尖草坪区"
    }, {
      "value": "万柏林区",
      "code": "030022",
      "label": "万柏林区"
    }, {
      "value": "晋源区",
      "code": "030025",
      "label": "晋源区"
    }, {
      "value": "清徐县",
      "code": "030404",
      "label": "清徐县"
    }, {
      "value": "阳曲县",
      "code": "030100",
      "label": "阳曲县"
    }, {
      "value": "娄烦县",
      "code": "030300",
      "label": "娄烦县"
    }, {
      "value": "古交市",
      "code": "030200",
      "label": "古交市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "太原市"
  }, {
    "value": "大同市",
    "children": [{
      "value": "矿区",
      "code": "037016",
      "label": "矿区"
    }, {
      "value": "南郊区",
      "code": "037001",
      "label": "南郊区"
    }, {
      "value": "新荣区",
      "code": "037002",
      "label": "新荣区"
    }, {
      "value": "阳高县",
      "code": "038100",
      "label": "阳高县"
    }, {
      "value": "天镇县",
      "code": "038200",
      "label": "天镇县"
    }, {
      "value": "广灵县",
      "code": "037500",
      "label": "广灵县"
    }, {
      "value": "灵丘县",
      "code": "034400",
      "label": "灵丘县"
    }, {
      "value": "浑源县",
      "code": "037400",
      "label": "浑源县"
    }, {
      "value": "左云县",
      "code": "037100",
      "label": "左云县"
    }, {
      "value": "大同县",
      "code": "037300",
      "label": "大同县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "大同市"
  }, {
    "value": "阳泉市",
    "children": [{
      "value": "矿区",
      "code": "045008",
      "label": "矿区"
    }, {
      "value": "平定县",
      "code": "045200",
      "label": "平定县"
    }, {
      "value": "盂县",
      "code": "045100",
      "label": "盂县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "阳泉市"
  }, {
    "value": "长治市",
    "children": [{
      "value": "长治县",
      "code": "047100",
      "label": "长治县"
    }, {
      "value": "襄垣县",
      "code": "046200",
      "label": "襄垣县"
    }, {
      "value": "屯留县",
      "code": "046100",
      "label": "屯留县"
    }, {
      "value": "平顺县",
      "code": "047400",
      "label": "平顺县"
    }, {
      "value": "黎城县",
      "code": "047600",
      "label": "黎城县"
    }, {
      "value": "壶关县",
      "code": "047300",
      "label": "壶关县"
    }, {
      "value": "长子县",
      "code": "046600",
      "label": "长子县"
    }, {
      "value": "武乡县",
      "code": "046300",
      "label": "武乡县"
    }, {
      "value": "沁县",
      "code": "046400",
      "label": "沁县"
    }, {
      "value": "沁源县",
      "code": "046500",
      "label": "沁源县"
    }, {
      "value": "潞城市",
      "code": "047599",
      "label": "潞城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "长治市"
  }, {
    "value": "晋城市",
    "children": [{
      "value": "沁水县",
      "code": "048200",
      "label": "沁水县"
    }, {
      "value": "阳城县",
      "code": "048100",
      "label": "阳城县"
    }, {
      "value": "陵川县",
      "code": "048300",
      "label": "陵川县"
    }, {
      "value": "泽州县",
      "code": "048002",
      "label": "泽州县"
    }, {
      "value": "高平市",
      "code": "048400",
      "label": "高平市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "晋城市"
  }, {
    "value": "朔州市",
    "children": [{
      "value": "朔城区",
      "code": "036001",
      "label": "朔城区"
    }, {
      "value": "平鲁区",
      "code": "036800",
      "label": "平鲁区"
    }, {
      "value": "山阴县",
      "code": "036900",
      "label": "山阴县"
    }, {
      "value": "应县",
      "code": "037600",
      "label": "应县"
    }, {
      "value": "右玉县",
      "code": "037200",
      "label": "右玉县"
    }, {
      "value": "怀仁县",
      "code": "038300",
      "label": "怀仁县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "朔州市"
  }, {
    "value": "晋中市",
    "children": [{
      "value": "榆次区",
      "code": "030609",
      "label": "榆次区"
    }, {
      "value": "榆社县",
      "code": "031800",
      "label": "榆社县"
    }, {
      "value": "左权县",
      "code": "032600",
      "label": "左权县"
    }, {
      "value": "和顺县",
      "code": "032700",
      "label": "和顺县"
    }, {
      "value": "昔阳县",
      "code": "045300",
      "label": "昔阳县"
    }, {
      "value": "寿阳县",
      "code": "045400",
      "label": "寿阳县"
    }, {
      "value": "太谷县",
      "code": "030800",
      "label": "太谷县"
    }, {
      "value": "祁县",
      "code": "030900",
      "label": "祁县"
    }, {
      "value": "平遥县",
      "code": "031100",
      "label": "平遥县"
    }, {
      "value": "灵石县",
      "code": "031300",
      "label": "灵石县"
    }, {
      "value": "介休市",
      "code": "032000",
      "label": "介休市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "晋中市"
  }, {
    "value": "运城市",
    "children": [{
      "value": "盐湖区",
      "code": "044001",
      "label": "盐湖区"
    }, {
      "value": "临猗县",
      "code": "044100",
      "label": "临猗县"
    }, {
      "value": "万荣县",
      "code": "044200",
      "label": "万荣县"
    }, {
      "value": "闻喜县",
      "code": "043800",
      "label": "闻喜县"
    }, {
      "value": "稷山县",
      "code": "043200",
      "label": "稷山县"
    }, {
      "value": "新绛县",
      "code": "043100",
      "label": "新绛县"
    }, {
      "value": "绛县",
      "code": "043600",
      "label": "绛县"
    }, {
      "value": "垣曲县",
      "code": "043700",
      "label": "垣曲县"
    }, {
      "value": "夏县",
      "code": "044400",
      "label": "夏县"
    }, {
      "value": "平陆县",
      "code": "044300",
      "label": "平陆县"
    }, {
      "value": "芮城县",
      "code": "044600",
      "label": "芮城县"
    }, {
      "value": "永济市",
      "code": "044500",
      "label": "永济市"
    }, {
      "value": "河津市",
      "code": "043300",
      "label": "河津市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "运城市"
  }, {
    "value": "忻州市",
    "children": [{
      "value": "忻府区",
      "code": "034028",
      "label": "忻府区"
    }, {
      "value": "定襄县",
      "code": "035400",
      "label": "定襄县"
    }, {
      "value": "五台县",
      "code": "035500",
      "label": "五台县"
    }, {
      "value": "代县",
      "code": "034200",
      "label": "代县"
    }, {
      "value": "繁峙县",
      "code": "034300",
      "label": "繁峙县"
    }, {
      "value": "宁武县",
      "code": "036701",
      "label": "宁武县"
    }, {
      "value": "静乐县",
      "code": "035100",
      "label": "静乐县"
    }, {
      "value": "神池县",
      "code": "036100",
      "label": "神池县"
    }, {
      "value": "五寨县",
      "code": "036200",
      "label": "五寨县"
    }, {
      "value": "岢岚县",
      "code": "036300",
      "label": "岢岚县"
    }, {
      "value": "河曲县",
      "code": "036500",
      "label": "河曲县"
    }, {
      "value": "保德县",
      "code": "036600",
      "label": "保德县"
    }, {
      "value": "偏关县",
      "code": "036400",
      "label": "偏关县"
    }, {
      "value": "原平市",
      "code": "034100",
      "label": "原平市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "忻州市"
  }, {
    "value": "临汾市",
    "children": [{
      "value": "尧都区",
      "code": "041000",
      "label": "尧都区"
    }, {
      "value": "曲沃县",
      "code": "043400",
      "label": "曲沃县"
    }, {
      "value": "翼城县",
      "code": "043500",
      "label": "翼城县"
    }, {
      "value": "襄汾县",
      "code": "041500",
      "label": "襄汾县"
    }, {
      "value": "洪洞县",
      "code": "041602",
      "label": "洪洞县"
    }, {
      "value": "古县",
      "code": "042400",
      "label": "古县"
    }, {
      "value": "安泽县",
      "code": "042500",
      "label": "安泽县"
    }, {
      "value": "浮山县",
      "code": "042600",
      "label": "浮山县"
    }, {
      "value": "吉县",
      "code": "042200",
      "label": "吉县"
    }, {
      "value": "乡宁县",
      "code": "042100",
      "label": "乡宁县"
    }, {
      "value": "大宁县",
      "code": "042300",
      "label": "大宁县"
    }, {
      "value": "隰县",
      "code": "041300",
      "label": "隰县"
    }, {
      "value": "永和县",
      "code": "041400",
      "label": "永和县"
    }, {
      "value": "蒲县",
      "code": "041200",
      "label": "蒲县"
    }, {
      "value": "汾西县",
      "code": "031500",
      "label": "汾西县"
    }, {
      "value": "侯马市",
      "code": "043000",
      "label": "侯马市"
    }, {
      "value": "霍州市",
      "code": "031400",
      "label": "霍州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "临汾市"
  }, {
    "value": "吕梁市",
    "children": [{
      "value": "离石区",
      "code": "033000",
      "label": "离石区"
    }, {
      "value": "文水县",
      "code": "032100",
      "label": "文水县"
    }, {
      "value": "交城县",
      "code": "030500",
      "label": "交城县"
    }, {
      "value": "兴县",
      "code": "033600",
      "label": "兴县"
    }, {
      "value": "临县",
      "code": "033200",
      "label": "临县"
    }, {
      "value": "柳林县",
      "code": "033300",
      "label": "柳林县"
    }, {
      "value": "石楼县",
      "code": "032500",
      "label": "石楼县"
    }, {
      "value": "岚县",
      "code": "033599",
      "label": "岚县"
    }, {
      "value": "方山县",
      "code": "033100",
      "label": "方山县"
    }, {
      "value": "中阳县",
      "code": "033400",
      "label": "中阳县"
    }, {
      "value": "交口县",
      "code": "032400",
      "label": "交口县"
    }, {
      "value": "孝义市",
      "code": "032300",
      "label": "孝义市"
    }, {
      "value": "汾阳市",
      "code": "032200",
      "label": "汾阳市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "吕梁市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "山西省",
  "label": "山西省"
}, {
  "children": [{
    "value": "呼和浩特市",
    "children": [{
      "value": "新城区",
      "code": "010011",
      "label": "新城区"
    }, {
      "value": "回民区",
      "code": "010030",
      "label": "回民区"
    }, {
      "value": "玉泉区",
      "code": "010031",
      "label": "玉泉区"
    }, {
      "value": "赛罕区",
      "code": "010072",
      "label": "赛罕区"
    }, {
      "value": "土默特左旗",
      "code": "010100",
      "label": "土默特左旗"
    }, {
      "value": "托克托县",
      "code": "010200",
      "label": "托克托县"
    }, {
      "value": "和林格尔县",
      "code": "011500",
      "label": "和林格尔县"
    }, {
      "value": "清水河县",
      "code": "011600",
      "label": "清水河县"
    }, {
      "value": "武川县",
      "code": "011700",
      "label": "武川县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "呼和浩特市"
  }, {
    "value": "包头市",
    "children": [{
      "value": "东河区",
      "code": "014046",
      "label": "东河区"
    }, {
      "value": "昆都仑区",
      "code": "014010",
      "label": "昆都仑区"
    }, {
      "value": "青山区",
      "code": "014030",
      "label": "青山区"
    }, {
      "value": "石拐区",
      "code": "014070",
      "label": "石拐区"
    }, {
      "value": "白云鄂博矿区",
      "code": "014080",
      "label": "白云鄂博矿区"
    }, {
      "value": "九原区",
      "code": "014060",
      "label": "九原区"
    }, {
      "value": "土默特右旗",
      "code": "014100",
      "label": "土默特右旗"
    }, {
      "value": "固阳县",
      "code": "014200",
      "label": "固阳县"
    }, {
      "value": "达尔罕茂明安联合旗",
      "code": "014500",
      "label": "达尔罕茂明安联合旗"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "包头市"
  }, {
    "value": "乌海市",
    "children": [{
      "value": "海勃湾区",
      "code": "016011",
      "label": "海勃湾区"
    }, {
      "value": "海南区",
      "code": "016030",
      "label": "海南区"
    }, {
      "value": "乌达区",
      "code": "016040",
      "label": "乌达区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "乌海市"
  }, {
    "value": "赤峰市",
    "children": [{
      "value": "红山区",
      "code": "024000",
      "label": "红山区"
    }, {
      "value": "元宝山区",
      "code": "024070",
      "label": "元宝山区"
    }, {
      "value": "松山区",
      "code": "024005",
      "label": "松山区"
    }, {
      "value": "阿鲁科尔沁旗",
      "code": "025500",
      "label": "阿鲁科尔沁旗"
    }, {
      "value": "巴林左旗",
      "code": "025450",
      "label": "巴林左旗"
    }, {
      "value": "巴林右旗",
      "code": "025156",
      "label": "巴林右旗"
    }, {
      "value": "林西县",
      "code": "025250",
      "label": "林西县"
    }, {
      "value": "克什克腾旗",
      "code": "025350",
      "label": "克什克腾旗"
    }, {
      "value": "翁牛特旗",
      "code": "024535",
      "label": "翁牛特旗"
    }, {
      "value": "喀喇沁旗",
      "code": "024400",
      "label": "喀喇沁旗"
    }, {
      "value": "宁城县",
      "code": "024200",
      "label": "宁城县"
    }, {
      "value": "敖汉旗",
      "code": "024300",
      "label": "敖汉旗"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "赤峰市"
  }, {
    "value": "通辽市",
    "children": [{
      "value": "科尔沁区",
      "code": "028008",
      "label": "科尔沁区"
    }, {
      "value": "科尔沁左翼中旗",
      "code": "029300",
      "label": "科尔沁左翼中旗"
    }, {
      "value": "科尔沁左翼后旗",
      "code": "028100",
      "label": "科尔沁左翼后旗"
    }, {
      "value": "开鲁县",
      "code": "028400",
      "label": "开鲁县"
    }, {
      "value": "库伦旗",
      "code": "028200",
      "label": "库伦旗"
    }, {
      "value": "奈曼旗",
      "code": "028317",
      "label": "奈曼旗"
    }, {
      "value": "扎鲁特旗",
      "code": "029100",
      "label": "扎鲁特旗"
    }, {
      "value": "霍林郭勒市",
      "code": "029200",
      "label": "霍林郭勒市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "通辽市"
  }, {
    "value": "鄂尔多斯市",
    "children": [{
      "value": "东胜区",
      "code": "017006",
      "label": "东胜区"
    }, {
      "value": "达拉特旗",
      "code": "014306",
      "label": "达拉特旗"
    }, {
      "value": "准格尔旗",
      "code": "010308",
      "label": "准格尔旗"
    }, {
      "value": "鄂托克前旗",
      "code": "016200",
      "label": "鄂托克前旗"
    }, {
      "value": "鄂托克旗",
      "code": "016064",
      "label": "鄂托克旗"
    }, {
      "value": "杭锦旗",
      "code": "017400",
      "label": "杭锦旗"
    }, {
      "value": "乌审旗",
      "code": "017300",
      "label": "乌审旗"
    }, {
      "value": "伊金霍洛旗",
      "code": "017200",
      "label": "伊金霍洛旗"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "鄂尔多斯市"
  }, {
    "value": "呼伦贝尔市",
    "children": [{
      "value": "海拉尔区",
      "code": "021008",
      "label": "海拉尔区"
    }, {
      "value": "扎赉诺尔区",
      "code": "021410",
      "label": "扎赉诺尔区"
    }, {
      "value": "阿荣旗",
      "code": "162750",
      "label": "阿荣旗"
    }, {
      "value": "莫力达瓦达斡尔族自治旗",
      "code": "162850",
      "label": "莫力达瓦达斡尔族自治旗"
    }, {
      "value": "鄂伦春自治旗",
      "code": "165450",
      "label": "鄂伦春自治旗"
    }, {
      "value": "鄂温克族自治旗",
      "code": "021100",
      "label": "鄂温克族自治旗"
    }, {
      "value": "陈巴尔虎旗",
      "code": "021022",
      "label": "陈巴尔虎旗"
    }, {
      "value": "新巴尔虎左旗",
      "code": "021200",
      "label": "新巴尔虎左旗"
    }, {
      "value": "新巴尔虎右旗",
      "code": "021300",
      "label": "新巴尔虎右旗"
    }, {
      "value": "满洲里市",
      "code": "021400",
      "label": "满洲里市"
    }, {
      "value": "牙克石市",
      "code": "022150",
      "label": "牙克石市"
    }, {
      "value": "扎兰屯市",
      "code": "162650",
      "label": "扎兰屯市"
    }, {
      "value": "额尔古纳市",
      "code": "022191",
      "label": "额尔古纳市"
    }, {
      "value": "根河市",
      "code": "022350",
      "label": "根河市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "呼伦贝尔市"
  }, {
    "value": "巴彦淖尔市",
    "children": [{
      "value": "临河区",
      "code": "015014",
      "label": "临河区"
    }, {
      "value": "五原县",
      "code": "015100",
      "label": "五原县"
    }, {
      "value": "磴口县",
      "code": "015200",
      "label": "磴口县"
    }, {
      "value": "乌拉特前旗",
      "code": "014400",
      "label": "乌拉特前旗"
    }, {
      "value": "乌拉特中旗",
      "code": "015300",
      "label": "乌拉特中旗"
    }, {
      "value": "乌拉特后旗",
      "code": "015500",
      "label": "乌拉特后旗"
    }, {
      "value": "杭锦后旗",
      "code": "015400",
      "label": "杭锦后旗"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "巴彦淖尔市"
  }, {
    "value": "乌兰察布市",
    "children": [{
      "value": "集宁区",
      "code": "012000",
      "label": "集宁区"
    }, {
      "value": "卓资县",
      "code": "012300",
      "label": "卓资县"
    }, {
      "value": "化德县",
      "code": "013350",
      "label": "化德县"
    }, {
      "value": "商都县",
      "code": "013450",
      "label": "商都县"
    }, {
      "value": "兴和县",
      "code": "013650",
      "label": "兴和县"
    }, {
      "value": "凉城县",
      "code": "013750",
      "label": "凉城县"
    }, {
      "value": "察哈尔右翼前旗",
      "code": "012200",
      "label": "察哈尔右翼前旗"
    }, {
      "value": "察哈尔右翼中旗",
      "code": "013550",
      "label": "察哈尔右翼中旗"
    }, {
      "value": "察哈尔右翼后旗",
      "code": "012400",
      "label": "察哈尔右翼后旗"
    }, {
      "value": "四子王旗",
      "code": "011800",
      "label": "四子王旗"
    }, {
      "value": "丰镇市",
      "code": "012100",
      "label": "丰镇市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "乌兰察布市"
  }, {
    "value": "兴安盟",
    "children": [{
      "value": "乌兰浩特市",
      "code": "137499",
      "label": "乌兰浩特市"
    }, {
      "value": "阿尔山市",
      "code": "137801",
      "label": "阿尔山市"
    }, {
      "value": "科尔沁右翼前旗",
      "code": "137704",
      "label": "科尔沁右翼前旗"
    }, {
      "value": "科尔沁右翼中旗",
      "code": "029400",
      "label": "科尔沁右翼中旗"
    }, {
      "value": "扎赉特旗",
      "code": "137600",
      "label": "扎赉特旗"
    }, {
      "value": "突泉县",
      "code": "137500",
      "label": "突泉县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "兴安盟"
  }, {
    "value": "锡林郭勒盟",
    "children": [{
      "value": "二连浩特市",
      "code": "011199",
      "label": "二连浩特市"
    }, {
      "value": "锡林浩特市",
      "code": "026009",
      "label": "锡林浩特市"
    }, {
      "value": "阿巴嘎旗",
      "code": "011400",
      "label": "阿巴嘎旗"
    }, {
      "value": "苏尼特左旗",
      "code": "011300",
      "label": "苏尼特左旗"
    }, {
      "value": "苏尼特右旗",
      "code": "011200",
      "label": "苏尼特右旗"
    }, {
      "value": "东乌珠穆沁旗",
      "code": "026300",
      "label": "东乌珠穆沁旗"
    }, {
      "value": "西乌珠穆沁旗",
      "code": "026200",
      "label": "西乌珠穆沁旗"
    }, {
      "value": "太仆寺旗",
      "code": "027000",
      "label": "太仆寺旗"
    }, {
      "value": "镶黄旗",
      "code": "013250",
      "label": "镶黄旗"
    }, {
      "value": "正镶白旗",
      "code": "013800",
      "label": "正镶白旗"
    }, {
      "value": "正蓝旗",
      "code": "027215",
      "label": "正蓝旗"
    }, {
      "value": "多伦县",
      "code": "027300",
      "label": "多伦县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "锡林郭勒盟"
  }, {
    "value": "阿拉善盟",
    "children": [{
      "value": "阿拉善左旗",
      "code": "750306",
      "label": "阿拉善左旗"
    }, {
      "value": "阿拉善右旗",
      "code": "737300",
      "label": "阿拉善右旗"
    }, {
      "value": "额济纳旗",
      "code": "735400",
      "label": "额济纳旗"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "阿拉善盟"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "内蒙古自治区",
  "label": "内蒙古自治区"
}, {
  "children": [{
    "value": "沈阳市",
    "children": [{
      "value": "和平区",
      "code": "110001",
      "label": "和平区"
    }, {
      "value": "沈河区",
      "code": "110011",
      "label": "沈河区"
    }, {
      "value": "大东区",
      "code": "110041",
      "label": "大东区"
    }, {
      "value": "皇姑区",
      "code": "110030",
      "label": "皇姑区"
    }, {
      "value": "铁西区",
      "code": "110020",
      "label": "铁西区"
    }, {
      "value": "苏家屯区",
      "code": "110100",
      "label": "苏家屯区"
    }, {
      "value": "东陵区",
      "code": "110151",
      "label": "东陵区"
    }, {
      "value": "沈北新区",
      "code": "110122",
      "label": "沈北新区"
    }, {
      "value": "于洪区",
      "code": "110141",
      "label": "于洪区"
    }, {
      "value": "辽中县",
      "code": "110200",
      "label": "辽中县"
    }, {
      "value": "康平县",
      "code": "110500",
      "label": "康平县"
    }, {
      "value": "法库县",
      "code": "110400",
      "label": "法库县"
    }, {
      "value": "新民市",
      "code": "110300",
      "label": "新民市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "沈阳市"
  }, {
    "value": "大连市",
    "children": [{
      "value": "中山区",
      "code": "116007",
      "label": "中山区"
    }, {
      "value": "西岗区",
      "code": "116011",
      "label": "西岗区"
    }, {
      "value": "沙河口区",
      "code": "116023",
      "label": "沙河口区"
    }, {
      "value": "甘井子区",
      "code": "116031",
      "label": "甘井子区"
    }, {
      "value": "旅顺口区",
      "code": "116041",
      "label": "旅顺口区"
    }, {
      "value": "金州区",
      "code": "116101",
      "label": "金州区"
    }, {
      "value": "普兰店区",
      "code": "116200",
      "label": "普兰店区"
    }, {
      "value": "长海县",
      "code": "116500",
      "label": "长海县"
    }, {
      "value": "瓦房店市",
      "code": "116300",
      "label": "瓦房店市"
    }, {
      "value": "庄河市",
      "code": "116400",
      "label": "庄河市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "大连市"
  }, {
    "value": "鞍山市",
    "children": [{
      "value": "铁东区",
      "code": "114001",
      "label": "铁东区"
    }, {
      "value": "铁西区",
      "code": "114011",
      "label": "铁西区"
    }, {
      "value": "立山区",
      "code": "114031",
      "label": "立山区"
    }, {
      "value": "千山区",
      "code": "114045",
      "label": "千山区"
    }, {
      "value": "台安县",
      "code": "114100",
      "label": "台安县"
    }, {
      "value": "岫岩满族自治县",
      "code": "114300",
      "label": "岫岩满族自治县"
    }, {
      "value": "海城市",
      "code": "114200",
      "label": "海城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "鞍山市"
  }, {
    "value": "抚顺市",
    "children": [{
      "value": "新抚区",
      "code": "113005",
      "label": "新抚区"
    }, {
      "value": "东洲区",
      "code": "113003",
      "label": "东洲区"
    }, {
      "value": "望花区",
      "code": "113001",
      "label": "望花区"
    }, {
      "value": "顺城区",
      "code": "113006",
      "label": "顺城区"
    }, {
      "value": "抚顺县",
      "code": "113100",
      "label": "抚顺县"
    }, {
      "value": "新宾满族自治县",
      "code": "113200",
      "label": "新宾满族自治县"
    }, {
      "value": "清原满族自治县",
      "code": "113300",
      "label": "清原满族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "抚顺市"
  }, {
    "value": "本溪市",
    "children": [{
      "value": "平山区",
      "code": "117016",
      "label": "平山区"
    }, {
      "value": "溪湖区",
      "code": "117003",
      "label": "溪湖区"
    }, {
      "value": "明山区",
      "code": "117009",
      "label": "明山区"
    }, {
      "value": "南芬区",
      "code": "117013",
      "label": "南芬区"
    }, {
      "value": "本溪满族自治县",
      "code": "117100",
      "label": "本溪满族自治县"
    }, {
      "value": "桓仁满族自治县",
      "code": "117200",
      "label": "桓仁满族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "本溪市"
  }, {
    "value": "丹东市",
    "children": [{
      "value": "元宝区",
      "code": "118000",
      "label": "元宝区"
    }, {
      "value": "振兴区",
      "code": "118002",
      "label": "振兴区"
    }, {
      "value": "振安区",
      "code": "118005",
      "label": "振安区"
    }, {
      "value": "宽甸满族自治县",
      "code": "118200",
      "label": "宽甸满族自治县"
    }, {
      "value": "东港市",
      "code": "118300",
      "label": "东港市"
    }, {
      "value": "凤城市",
      "code": "118100",
      "label": "凤城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "丹东市"
  }, {
    "value": "锦州市",
    "children": [{
      "value": "古塔区",
      "code": "121012",
      "label": "古塔区"
    }, {
      "value": "凌河区",
      "code": "121002",
      "label": "凌河区"
    }, {
      "value": "太和区",
      "code": "121005",
      "label": "太和区"
    }, {
      "value": "黑山县",
      "code": "121400",
      "label": "黑山县"
    }, {
      "value": "义县",
      "code": "121100",
      "label": "义县"
    }, {
      "value": "凌海市",
      "code": "121200",
      "label": "凌海市"
    }, {
      "value": "北镇市",
      "code": "121300",
      "label": "北镇市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "锦州市"
  }, {
    "value": "营口市",
    "children": [{
      "value": "站前区",
      "code": "115001",
      "label": "站前区"
    }, {
      "value": "西市区",
      "code": "115004",
      "label": "西市区"
    }, {
      "value": "鲅鱼圈区",
      "code": "115007",
      "label": "鲅鱼圈区"
    }, {
      "value": "老边区",
      "code": "115005",
      "label": "老边区"
    }, {
      "value": "盖州市",
      "code": "115200",
      "label": "盖州市"
    }, {
      "value": "大石桥市",
      "code": "115100",
      "label": "大石桥市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "营口市"
  }, {
    "value": "阜新市",
    "children": [{
      "value": "海州区",
      "code": "123002",
      "label": "海州区"
    }, {
      "value": "新邱区",
      "code": "123005",
      "label": "新邱区"
    }, {
      "value": "太平区",
      "code": "123003",
      "label": "太平区"
    }, {
      "value": "清河门区",
      "code": "123006",
      "label": "清河门区"
    }, {
      "value": "细河区",
      "code": "123000",
      "label": "细河区"
    }, {
      "value": "阜新蒙古族自治县",
      "code": "123100",
      "label": "阜新蒙古族自治县"
    }, {
      "value": "彰武县",
      "code": "123200",
      "label": "彰武县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "阜新市"
  }, {
    "value": "辽阳市",
    "children": [{
      "value": "白塔区",
      "code": "111000",
      "label": "白塔区"
    }, {
      "value": "文圣区",
      "code": "111099",
      "label": "文圣区"
    }, {
      "value": "宏伟区",
      "code": "111003",
      "label": "宏伟区"
    }, {
      "value": "弓长岭区",
      "code": "111007",
      "label": "弓长岭区"
    }, {
      "value": "太子河区",
      "code": "111005",
      "label": "太子河区"
    }, {
      "value": "辽阳县",
      "code": "111200",
      "label": "辽阳县"
    }, {
      "value": "灯塔市",
      "code": "111300",
      "label": "灯塔市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "辽阳市"
  }, {
    "value": "盘锦市",
    "children": [{
      "value": "双台子区",
      "code": "124020",
      "label": "双台子区"
    }, {
      "value": "兴隆台区",
      "code": "124007",
      "label": "兴隆台区"
    }, {
      "value": "大洼县",
      "code": "124200",
      "label": "大洼县"
    }, {
      "value": "盘山县",
      "code": "124100",
      "label": "盘山县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "盘锦市"
  }, {
    "value": "铁岭市",
    "children": [{
      "value": "银州区",
      "code": "112001",
      "label": "银州区"
    }, {
      "value": "清河区",
      "code": "112003",
      "label": "清河区"
    }, {
      "value": "铁岭县",
      "code": "112600",
      "label": "铁岭县"
    }, {
      "value": "西丰县",
      "code": "112400",
      "label": "西丰县"
    }, {
      "value": "昌图县",
      "code": "112500",
      "label": "昌图县"
    }, {
      "value": "调兵山市",
      "code": "112701",
      "label": "调兵山市"
    }, {
      "value": "开原市",
      "code": "112300",
      "label": "开原市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "铁岭市"
  }, {
    "value": "朝阳市",
    "children": [{
      "value": "双塔区",
      "code": "122601",
      "label": "双塔区"
    }, {
      "value": "龙城区",
      "code": "122005",
      "label": "龙城区"
    }, {
      "value": "朝阳县",
      "code": "122602",
      "label": "朝阳县"
    }, {
      "value": "建平县",
      "code": "122400",
      "label": "建平县"
    }, {
      "value": "喀喇沁左翼蒙古族自治县",
      "code": "122300",
      "label": "喀喇沁左翼蒙古族自治县"
    }, {
      "value": "北票市",
      "code": "122100",
      "label": "北票市"
    }, {
      "value": "凌源市",
      "code": "122500",
      "label": "凌源市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "朝阳市"
  }, {
    "value": "葫芦岛市",
    "children": [{
      "value": "连山区",
      "code": "125007",
      "label": "连山区"
    }, {
      "value": "龙港区",
      "code": "125003",
      "label": "龙港区"
    }, {
      "value": "南票区",
      "code": "125027",
      "label": "南票区"
    }, {
      "value": "绥中县",
      "code": "125200",
      "label": "绥中县"
    }, {
      "value": "建昌县",
      "code": "125300",
      "label": "建昌县"
    }, {
      "value": "兴城市",
      "code": "125100",
      "label": "兴城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "葫芦岛市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "辽宁省",
  "label": "辽宁省"
}, {
  "children": [{
    "value": "长春市",
    "children": [{
      "value": "南关区",
      "code": "130028",
      "label": "南关区"
    }, {
      "value": "宽城区",
      "code": "130102",
      "label": "宽城区"
    }, {
      "value": "朝阳区",
      "code": "130015",
      "label": "朝阳区"
    }, {
      "value": "二道区",
      "code": "130031",
      "label": "二道区"
    }, {
      "value": "绿园区",
      "code": "130011",
      "label": "绿园区"
    }, {
      "value": "双阳区",
      "code": "130600",
      "label": "双阳区"
    }, {
      "value": "九台区",
      "code": "130500",
      "label": "九台区"
    }, {
      "value": "农安县",
      "code": "130200",
      "label": "农安县"
    }, {
      "value": "榆树市",
      "code": "130400",
      "label": "榆树市"
    }, {
      "value": "德惠市",
      "code": "130300",
      "label": "德惠市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "长春市"
  }, {
    "value": "吉林市",
    "children": [{
      "value": "昌邑区",
      "code": "132001",
      "label": "昌邑区"
    }, {
      "value": "龙潭区",
      "code": "132021",
      "label": "龙潭区"
    }, {
      "value": "船营区",
      "code": "132011",
      "label": "船营区"
    }, {
      "value": "丰满区",
      "code": "132105",
      "label": "丰满区"
    }, {
      "value": "永吉县",
      "code": "132100",
      "label": "永吉县"
    }, {
      "value": "蛟河市",
      "code": "132500",
      "label": "蛟河市"
    }, {
      "value": "桦甸市",
      "code": "132400",
      "label": "桦甸市"
    }, {
      "value": "舒兰市",
      "code": "132600",
      "label": "舒兰市"
    }, {
      "value": "磐石市",
      "code": "132300",
      "label": "磐石市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "吉林市"
  }, {
    "value": "四平市",
    "children": [{
      "value": "铁西区",
      "code": "136000",
      "label": "铁西区"
    }, {
      "value": "铁东区",
      "code": "136002",
      "label": "铁东区"
    }, {
      "value": "梨树县",
      "code": "136500",
      "label": "梨树县"
    }, {
      "value": "伊通满族自治县",
      "code": "130700",
      "label": "伊通满族自治县"
    }, {
      "value": "公主岭市",
      "code": "136100",
      "label": "公主岭市"
    }, {
      "value": "双辽市",
      "code": "136400",
      "label": "双辽市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "四平市"
  }, {
    "value": "辽源市",
    "children": [{
      "value": "龙山区",
      "code": "136299",
      "label": "龙山区"
    }, {
      "value": "西安区",
      "code": "136201",
      "label": "西安区"
    }, {
      "value": "东丰县",
      "code": "136300",
      "label": "东丰县"
    }, {
      "value": "东辽县",
      "code": "136600",
      "label": "东辽县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "辽源市"
  }, {
    "value": "通化市",
    "children": [{
      "value": "东昌区",
      "code": "134001",
      "label": "东昌区"
    }, {
      "value": "二道江区",
      "code": "134005",
      "label": "二道江区"
    }, {
      "value": "通化县",
      "code": "134100",
      "label": "通化县"
    }, {
      "value": "辉南县",
      "code": "135100",
      "label": "辉南县"
    }, {
      "value": "柳河县",
      "code": "135300",
      "label": "柳河县"
    }, {
      "value": "梅河口市",
      "code": "135000",
      "label": "梅河口市"
    }, {
      "value": "集安市",
      "code": "134200",
      "label": "集安市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "通化市"
  }, {
    "value": "白山市",
    "children": [{
      "value": "浑江区",
      "code": "134301",
      "label": "浑江区"
    }, {
      "value": "江源区",
      "code": "134700",
      "label": "江源区"
    }, {
      "value": "抚松县",
      "code": "134500",
      "label": "抚松县"
    }, {
      "value": "靖宇县",
      "code": "135200",
      "label": "靖宇县"
    }, {
      "value": "长白朝鲜族自治县",
      "code": "134400",
      "label": "长白朝鲜族自治县"
    }, {
      "value": "临江市",
      "code": "134600",
      "label": "临江市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "白山市"
  }, {
    "value": "松原市",
    "children": [{
      "value": "宁江区",
      "code": "138001",
      "label": "宁江区"
    }, {
      "value": "前郭尔罗斯蒙古族自治县",
      "code": "131100",
      "label": "前郭尔罗斯蒙古族自治县"
    }, {
      "value": "长岭县",
      "code": "131500",
      "label": "长岭县"
    }, {
      "value": "乾安县",
      "code": "131400",
      "label": "乾安县"
    }, {
      "value": "扶余市",
      "code": "131200",
      "label": "扶余市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "松原市"
  }, {
    "value": "白城市",
    "children": [{
      "value": "洮北区",
      "code": "137001",
      "label": "洮北区"
    }, {
      "value": "镇赉县",
      "code": "137300",
      "label": "镇赉县"
    }, {
      "value": "通榆县",
      "code": "137200",
      "label": "通榆县"
    }, {
      "value": "洮南市",
      "code": "137100",
      "label": "洮南市"
    }, {
      "value": "大安市",
      "code": "131300",
      "label": "大安市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "白城市"
  }, {
    "value": "延边朝鲜族自治州",
    "children": [{
      "value": "延吉市",
      "code": "133001",
      "label": "延吉市"
    }, {
      "value": "图们市",
      "code": "133100",
      "label": "图们市"
    }, {
      "value": "敦化市",
      "code": "133700",
      "label": "敦化市"
    }, {
      "value": "珲春市",
      "code": "133300",
      "label": "珲春市"
    }, {
      "value": "龙井市",
      "code": "133400",
      "label": "龙井市"
    }, {
      "value": "和龙市",
      "code": "133500",
      "label": "和龙市"
    }, {
      "value": "汪清县",
      "code": "133200",
      "label": "汪清县"
    }, {
      "value": "安图县",
      "code": "133600",
      "label": "安图县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "延边朝鲜族自治州"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "吉林省",
  "label": "吉林省"
}, {
  "children": [{
    "value": "哈尔滨市",
    "children": [{
      "value": "道里区",
      "code": "150010",
      "label": "道里区"
    }, {
      "value": "南岗区",
      "code": "150001",
      "label": "南岗区"
    }, {
      "value": "道外区",
      "code": "150020",
      "label": "道外区"
    }, {
      "value": "平房区",
      "code": "150060",
      "label": "平房区"
    }, {
      "value": "松北区",
      "code": "150021",
      "label": "松北区"
    }, {
      "value": "香坊区",
      "code": "150030",
      "label": "香坊区"
    }, {
      "value": "呼兰区",
      "code": "150500",
      "label": "呼兰区"
    }, {
      "value": "阿城区",
      "code": "150301",
      "label": "阿城区"
    }, {
      "value": "双城区",
      "code": "150100",
      "label": "双城区"
    }, {
      "value": "依兰县",
      "code": "154800",
      "label": "依兰县"
    }, {
      "value": "方正县",
      "code": "150800",
      "label": "方正县"
    }, {
      "value": "宾县",
      "code": "150400",
      "label": "宾县"
    }, {
      "value": "巴彦县",
      "code": "151800",
      "label": "巴彦县"
    }, {
      "value": "木兰县",
      "code": "151900",
      "label": "木兰县"
    }, {
      "value": "通河县",
      "code": "150900",
      "label": "通河县"
    }, {
      "value": "延寿县",
      "code": "150700",
      "label": "延寿县"
    }, {
      "value": "尚志市",
      "code": "150600",
      "label": "尚志市"
    }, {
      "value": "五常市",
      "code": "150200",
      "label": "五常市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "哈尔滨市"
  }, {
    "value": "齐齐哈尔市",
    "children": [{
      "value": "龙沙区",
      "code": "161007",
      "label": "龙沙区"
    }, {
      "value": "建华区",
      "code": "160006",
      "label": "建华区"
    }, {
      "value": "铁锋区",
      "code": "161002",
      "label": "铁锋区"
    }, {
      "value": "昂昂溪区",
      "code": "161031",
      "label": "昂昂溪区"
    }, {
      "value": "富拉尔基区",
      "code": "161042",
      "label": "富拉尔基区"
    }, {
      "value": "碾子山区",
      "code": "161046",
      "label": "碾子山区"
    }, {
      "value": "梅里斯达斡尔族区",
      "code": "161021",
      "label": "梅里斯达斡尔族区"
    }, {
      "value": "龙江县",
      "code": "161100",
      "label": "龙江县"
    }, {
      "value": "依安县",
      "code": "161500",
      "label": "依安县"
    }, {
      "value": "泰来县",
      "code": "162400",
      "label": "泰来县"
    }, {
      "value": "甘南县",
      "code": "162100",
      "label": "甘南县"
    }, {
      "value": "富裕县",
      "code": "161200",
      "label": "富裕县"
    }, {
      "value": "克山县",
      "code": "161600",
      "label": "克山县"
    }, {
      "value": "克东县",
      "code": "164800",
      "label": "克东县"
    }, {
      "value": "拜泉县",
      "code": "164700",
      "label": "拜泉县"
    }, {
      "value": "讷河市",
      "code": "161302",
      "label": "讷河市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "齐齐哈尔市"
  }, {
    "value": "鸡西市",
    "children": [{
      "value": "鸡冠区",
      "code": "158101",
      "label": "鸡冠区"
    }, {
      "value": "恒山区",
      "code": "158130",
      "label": "恒山区"
    }, {
      "value": "滴道区",
      "code": "158150",
      "label": "滴道区"
    }, {
      "value": "梨树区",
      "code": "158160",
      "label": "梨树区"
    }, {
      "value": "城子河区",
      "code": "158170",
      "label": "城子河区"
    }, {
      "value": "麻山区",
      "code": "158180",
      "label": "麻山区"
    }, {
      "value": "鸡东县",
      "code": "158200",
      "label": "鸡东县"
    }, {
      "value": "虎林市",
      "code": "158400",
      "label": "虎林市"
    }, {
      "value": "密山市",
      "code": "158300",
      "label": "密山市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "鸡西市"
  }, {
    "value": "鹤岗市",
    "children": [{
      "value": "向阳区",
      "code": "154199",
      "label": "向阳区"
    }, {
      "value": "工农区",
      "code": "154101",
      "label": "工农区"
    }, {
      "value": "南山区",
      "code": "154103",
      "label": "南山区"
    }, {
      "value": "兴安区",
      "code": "154111",
      "label": "兴安区"
    }, {
      "value": "东山区",
      "code": "154106",
      "label": "东山区"
    }, {
      "value": "兴山区",
      "code": "154105",
      "label": "兴山区"
    }, {
      "value": "萝北县",
      "code": "154200",
      "label": "萝北县"
    }, {
      "value": "绥滨县",
      "code": "156200",
      "label": "绥滨县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "鹤岗市"
  }, {
    "value": "双鸭山市",
    "children": [{
      "value": "尖山区",
      "code": "155199",
      "label": "尖山区"
    }, {
      "value": "岭东区",
      "code": "155120",
      "label": "岭东区"
    }, {
      "value": "四方台区",
      "code": "155113",
      "label": "四方台区"
    }, {
      "value": "宝山区",
      "code": "155131",
      "label": "宝山区"
    }, {
      "value": "集贤县",
      "code": "155900",
      "label": "集贤县"
    }, {
      "value": "友谊县",
      "code": "155800",
      "label": "友谊县"
    }, {
      "value": "宝清县",
      "code": "155600",
      "label": "宝清县"
    }, {
      "value": "饶河县",
      "code": "155700",
      "label": "饶河县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "双鸭山市"
  }, {
    "value": "大庆市",
    "children": [{
      "value": "萨尔图区",
      "code": "163001",
      "label": "萨尔图区"
    }, {
      "value": "龙凤区",
      "code": "163714",
      "label": "龙凤区"
    }, {
      "value": "让胡路区",
      "code": "163114",
      "label": "让胡路区"
    }, {
      "value": "红岗区",
      "code": "163355",
      "label": "红岗区"
    }, {
      "value": "大同区",
      "code": "163514",
      "label": "大同区"
    }, {
      "value": "肇州县",
      "code": "166400",
      "label": "肇州县"
    }, {
      "value": "肇源县",
      "code": "166500",
      "label": "肇源县"
    }, {
      "value": "林甸县",
      "code": "166300",
      "label": "林甸县"
    }, {
      "value": "杜尔伯特蒙古族自治县",
      "code": "166200",
      "label": "杜尔伯特蒙古族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "大庆市"
  }, {
    "value": "伊春市",
    "children": [{
      "value": "伊春区",
      "code": "153099",
      "label": "伊春区"
    }, {
      "value": "南岔区",
      "code": "153102",
      "label": "南岔区"
    }, {
      "value": "友好区",
      "code": "153031",
      "label": "友好区"
    }, {
      "value": "西林区",
      "code": "153024",
      "label": "西林区"
    }, {
      "value": "翠峦区",
      "code": "153013",
      "label": "翠峦区"
    }, {
      "value": "新青区",
      "code": "153036",
      "label": "新青区"
    }, {
      "value": "美溪区",
      "code": "153021",
      "label": "美溪区"
    }, {
      "value": "金山屯区",
      "code": "153026",
      "label": "金山屯区"
    }, {
      "value": "五营区",
      "code": "153033",
      "label": "五营区"
    }, {
      "value": "乌马河区",
      "code": "153011",
      "label": "乌马河区"
    }, {
      "value": "汤旺河区",
      "code": "153037",
      "label": "汤旺河区"
    }, {
      "value": "带岭区",
      "code": "153106",
      "label": "带岭区"
    }, {
      "value": "乌伊岭区",
      "code": "153038",
      "label": "乌伊岭区"
    }, {
      "value": "红星区",
      "code": "153035",
      "label": "红星区"
    }, {
      "value": "上甘岭区",
      "code": "153032",
      "label": "上甘岭区"
    }, {
      "value": "嘉荫县",
      "code": "153200",
      "label": "嘉荫县"
    }, {
      "value": "铁力市",
      "code": "152500",
      "label": "铁力市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "伊春市"
  }, {
    "value": "佳木斯市",
    "children": [{
      "value": "向阳区",
      "code": "154003",
      "label": "向阳区"
    }, {
      "value": "前进区",
      "code": "154000",
      "label": "前进区"
    }, {
      "value": "东风区",
      "code": "154005",
      "label": "东风区"
    }, {
      "value": "桦南县",
      "code": "154400",
      "label": "桦南县"
    }, {
      "value": "桦川县",
      "code": "154300",
      "label": "桦川县"
    }, {
      "value": "汤原县",
      "code": "154700",
      "label": "汤原县"
    }, {
      "value": "抚远县",
      "code": "156500",
      "label": "抚远县"
    }, {
      "value": "同江市",
      "code": "156400",
      "label": "同江市"
    }, {
      "value": "富锦市",
      "code": "156100",
      "label": "富锦市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "佳木斯市"
  }, {
    "value": "七台河市",
    "children": [{
      "value": "新兴区",
      "code": "154522",
      "label": "新兴区"
    }, {
      "value": "桃山区",
      "code": "154602",
      "label": "桃山区"
    }, {
      "value": "茄子河区",
      "code": "154623",
      "label": "茄子河区"
    }, {
      "value": "勃利县",
      "code": "154500",
      "label": "勃利县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "七台河市"
  }, {
    "value": "牡丹江市",
    "children": [{
      "value": "东安区",
      "code": "157006",
      "label": "东安区"
    }, {
      "value": "阳明区",
      "code": "157013",
      "label": "阳明区"
    }, {
      "value": "爱民区",
      "code": "157010",
      "label": "爱民区"
    }, {
      "value": "西安区",
      "code": "157001",
      "label": "西安区"
    }, {
      "value": "林口县",
      "code": "157600",
      "label": "林口县"
    }, {
      "value": "绥芬河市",
      "code": "157300",
      "label": "绥芬河市"
    }, {
      "value": "海林市",
      "code": "157100",
      "label": "海林市"
    }, {
      "value": "宁安市",
      "code": "157400",
      "label": "宁安市"
    }, {
      "value": "穆棱市",
      "code": "157500",
      "label": "穆棱市"
    }, {
      "value": "东宁市",
      "code": "157200",
      "label": "东宁市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "牡丹江市"
  }, {
    "value": "黑河市",
    "children": [{
      "value": "爱辉区",
      "code": "164311",
      "label": "爱辉区"
    }, {
      "value": "嫩江县",
      "code": "161400",
      "label": "嫩江县"
    }, {
      "value": "逊克县",
      "code": "164400",
      "label": "逊克县"
    }, {
      "value": "孙吴县",
      "code": "164200",
      "label": "孙吴县"
    }, {
      "value": "北安市",
      "code": "164000",
      "label": "北安市"
    }, {
      "value": "五大连池市",
      "code": "164100",
      "label": "五大连池市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "黑河市"
  }, {
    "value": "绥化市",
    "children": [{
      "value": "北林区",
      "code": "152001",
      "label": "北林区"
    }, {
      "value": "望奎县",
      "code": "152100",
      "label": "望奎县"
    }, {
      "value": "兰西县",
      "code": "151500",
      "label": "兰西县"
    }, {
      "value": "青冈县",
      "code": "151600",
      "label": "青冈县"
    }, {
      "value": "庆安县",
      "code": "151401",
      "label": "庆安县"
    }, {
      "value": "明水县",
      "code": "151700",
      "label": "明水县"
    }, {
      "value": "绥棱县",
      "code": "152200",
      "label": "绥棱县"
    }, {
      "value": "安达市",
      "code": "151400",
      "label": "安达市"
    }, {
      "value": "肇东市",
      "code": "151100",
      "label": "肇东市"
    }, {
      "value": "海伦市",
      "code": "152300",
      "label": "海伦市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "绥化市"
  }, {
    "value": "大兴安岭地区",
    "children": [{
      "value": "呼玛县",
      "code": "165100",
      "label": "呼玛县"
    }, {
      "value": "塔河县",
      "code": "165200",
      "label": "塔河县"
    }, {
      "value": "漠河��",
      "code": "165300",
      "label": "漠河��"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "大兴安岭地区"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "黑龙江省",
  "label": "黑龙江省"
}, {
  "children": [{
    "value": "市辖区",
    "children": [{
      "value": "黄浦区",
      "code": "200001",
      "label": "黄浦区"
    }, {
      "value": "徐汇区",
      "code": "200030",
      "label": "徐汇区"
    }, {
      "value": "长宁区",
      "code": "200050",
      "label": "长宁区"
    }, {
      "value": "静安区",
      "code": "200040",
      "label": "静安区"
    }, {
      "value": "普陀区",
      "code": "200060",
      "label": "普陀区"
    }, {
      "value": "虹口区",
      "code": "200071",
      "label": "虹口区"
    }, {
      "value": "杨浦区",
      "code": "200090",
      "label": "杨浦区"
    }, {
      "value": "闵行区",
      "code": "200240",
      "label": "闵行区"
    }, {
      "value": "宝山区",
      "code": "200431",
      "label": "宝山区"
    }, {
      "value": "嘉定区",
      "code": "201800",
      "label": "嘉定区"
    }, {
      "value": "浦东新区",
      "code": "200120",
      "label": "浦东新区"
    }, {
      "value": "金山区",
      "code": "200540",
      "label": "金山区"
    }, {
      "value": "松江区",
      "code": "201600",
      "label": "松江区"
    }, {
      "value": "青浦区",
      "code": "201700",
      "label": "青浦区"
    }, {
      "value": "奉贤区",
      "code": "201400",
      "label": "奉贤区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "市辖区"
  }, {
    "value": "辖县",
    "children": [{
      "value": "崇明县",
      "code": "201913",
      "label": "崇明县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "辖县"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "上海市",
  "label": "上海市"
}, {
  "children": [{
    "value": "南京市",
    "children": [{
      "value": "玄武区",
      "code": "210002",
      "label": "玄武区"
    }, {
      "value": "秦淮区",
      "code": "210001",
      "label": "秦淮区"
    }, {
      "value": "建邺区",
      "code": "210017",
      "label": "建邺区"
    }, {
      "value": "鼓楼区",
      "code": "210003",
      "label": "鼓楼区"
    }, {
      "value": "浦口区",
      "code": "210031",
      "label": "浦口区"
    }, {
      "value": "栖霞区",
      "code": "210033",
      "label": "栖霞区"
    }, {
      "value": "雨花台区",
      "code": "210039",
      "label": "雨花台区"
    }, {
      "value": "江宁区",
      "code": "211100",
      "label": "江宁区"
    }, {
      "value": "六合区",
      "code": "210048",
      "label": "六合区"
    }, {
      "value": "溧水区",
      "code": "211200",
      "label": "溧水区"
    }, {
      "value": "高淳区",
      "code": "211300",
      "label": "高淳区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "南京市"
  }, {
    "value": "无锡市",
    "children": [{
      "value": "锡山区",
      "code": "214104",
      "label": "锡山区"
    }, {
      "value": "惠山区",
      "code": "214153",
      "label": "惠山区"
    }, {
      "value": "滨湖区",
      "code": "214029",
      "label": "滨湖区"
    }, {
      "value": "梁溪区",
      "code": "214008",
      "label": "梁溪区"
    }, {
      "value": "新吴区",
      "code": "214028",
      "label": "新吴区"
    }, {
      "value": "江阴市",
      "code": "214400",
      "label": "江阴市"
    }, {
      "value": "宜兴市",
      "code": "214200",
      "label": "宜兴市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "无锡市"
  }, {
    "value": "徐州市",
    "children": [{
      "value": "鼓楼区",
      "code": "221121",
      "label": "鼓楼区"
    }, {
      "value": "云龙区",
      "code": "221018",
      "label": "云龙区"
    }, {
      "value": "贾汪区",
      "code": "221011",
      "label": "贾汪区"
    }, {
      "value": "泉山区",
      "code": "221006",
      "label": "泉山区"
    }, {
      "value": "铜山区",
      "code": "221112",
      "label": "铜山区"
    }, {
      "value": "丰县",
      "code": "221700",
      "label": "丰县"
    }, {
      "value": "沛县",
      "code": "221600",
      "label": "沛县"
    }, {
      "value": "睢宁县",
      "code": "221200",
      "label": "睢宁县"
    }, {
      "value": "新沂市",
      "code": "221400",
      "label": "新沂市"
    }, {
      "value": "邳州市",
      "code": "221300",
      "label": "邳州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "徐州市"
  }, {
    "value": "常州市",
    "children": [{
      "value": "天宁区",
      "code": "213018",
      "label": "天宁区"
    }, {
      "value": "钟楼区",
      "code": "213012",
      "label": "钟楼区"
    }, {
      "value": "新北区",
      "code": "213031",
      "label": "新北区"
    }, {
      "value": "武进区",
      "code": "213100",
      "label": "武进区"
    }, {
      "value": "金坛区",
      "code": "213200",
      "label": "金坛区"
    }, {
      "value": "溧阳市",
      "code": "213300",
      "label": "溧阳市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "常州市"
  }, {
    "value": "苏州市",
    "children": [{
      "value": "虎丘区",
      "code": "215011",
      "label": "虎丘区"
    }, {
      "value": "吴中区",
      "code": "215101",
      "label": "吴中区"
    }, {
      "value": "相城区",
      "code": "215131",
      "label": "相城区"
    }, {
      "value": "姑苏区",
      "code": "215001",
      "label": "姑苏区"
    }, {
      "value": "吴江区",
      "code": "215200",
      "label": "吴江区"
    }, {
      "value": "常熟市",
      "code": "215500",
      "label": "常熟市"
    }, {
      "value": "张家港市",
      "code": "215600",
      "label": "张家港市"
    }, {
      "value": "昆山市",
      "code": "215300",
      "label": "昆山市"
    }, {
      "value": "太仓市",
      "code": "215400",
      "label": "太仓市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "苏州市"
  }, {
    "value": "南通市",
    "children": [{
      "value": "崇川区",
      "code": "226004",
      "label": "崇川区"
    }, {
      "value": "港闸区",
      "code": "226003",
      "label": "港闸区"
    }, {
      "value": "通州区",
      "code": "226301",
      "label": "通州区"
    }, {
      "value": "海安县",
      "code": "226600",
      "label": "海安县"
    }, {
      "value": "如东县",
      "code": "226400",
      "label": "如东县"
    }, {
      "value": "启东市",
      "code": "226200",
      "label": "启东市"
    }, {
      "value": "如皋市",
      "code": "226500",
      "label": "如皋市"
    }, {
      "value": "海门市",
      "code": "226100",
      "label": "海门市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "南通市"
  }, {
    "value": "连云港市",
    "children": [{
      "value": "连云区",
      "code": "222041",
      "label": "连云区"
    }, {
      "value": "海州区",
      "code": "222021",
      "label": "海州区"
    }, {
      "value": "赣榆区",
      "code": "222100",
      "label": "赣榆区"
    }, {
      "value": "东海县",
      "code": "222300",
      "label": "东海县"
    }, {
      "value": "灌云县",
      "code": "222200",
      "label": "灌云县"
    }, {
      "value": "灌南县",
      "code": "222502",
      "label": "灌南县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "连云港市"
  }, {
    "value": "淮安市",
    "children": [{
      "value": "清河区",
      "code": "223005",
      "label": "清河区"
    }, {
      "value": "淮安区",
      "code": "223200",
      "label": "淮安区"
    }, {
      "value": "淮阴区",
      "code": "223300",
      "label": "淮阴区"
    }, {
      "value": "清浦区",
      "code": "223002",
      "label": "清浦区"
    }, {
      "value": "涟水县",
      "code": "223400",
      "label": "涟水县"
    }, {
      "value": "洪泽县",
      "code": "211706",
      "label": "洪泽县"
    }, {
      "value": "盱眙县",
      "code": "211700",
      "label": "盱眙县"
    }, {
      "value": "金湖县",
      "code": "211600",
      "label": "金湖县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "淮安市"
  }, {
    "value": "盐城市",
    "children": [{
      "value": "亭湖区",
      "code": "224001",
      "label": "亭湖区"
    }, {
      "value": "盐都区",
      "code": "224011",
      "label": "盐都区"
    }, {
      "value": "大丰区",
      "code": "224100",
      "label": "大丰区"
    }, {
      "value": "响水县",
      "code": "224600",
      "label": "响水县"
    }, {
      "value": "滨海县",
      "code": "224500",
      "label": "滨海县"
    }, {
      "value": "阜宁县",
      "code": "224400",
      "label": "阜宁县"
    }, {
      "value": "射阳县",
      "code": "224300",
      "label": "射阳县"
    }, {
      "value": "建湖县",
      "code": "224700",
      "label": "建湖县"
    }, {
      "value": "东台市",
      "code": "224200",
      "label": "东台市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "盐城市"
  }, {
    "value": "扬州市",
    "children": [{
      "value": "广陵区",
      "code": "225001",
      "label": "广陵区"
    }, {
      "value": "邗江区",
      "code": "225012",
      "label": "邗江区"
    }, {
      "value": "江都区",
      "code": "225200",
      "label": "江都区"
    }, {
      "value": "宝应县",
      "code": "225800",
      "label": "宝应县"
    }, {
      "value": "仪征市",
      "code": "211400",
      "label": "仪征市"
    }, {
      "value": "高邮市",
      "code": "225600",
      "label": "高邮市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "扬州市"
  }, {
    "value": "镇江市",
    "children": [{
      "value": "京口区",
      "code": "212008",
      "label": "京口区"
    }, {
      "value": "润州区",
      "code": "212002",
      "label": "润州区"
    }, {
      "value": "丹徒区",
      "code": "212028",
      "label": "丹徒区"
    }, {
      "value": "丹阳市",
      "code": "212300",
      "label": "丹阳市"
    }, {
      "value": "扬中市",
      "code": "212200",
      "label": "扬中市"
    }, {
      "value": "句容市",
      "code": "212400",
      "label": "句容市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "镇江市"
  }, {
    "value": "泰州市",
    "children": [{
      "value": "海陵区",
      "code": "225306",
      "label": "海陵区"
    }, {
      "value": "高港区",
      "code": "225321",
      "label": "高港区"
    }, {
      "value": "姜堰区",
      "code": "225500",
      "label": "姜堰区"
    }, {
      "value": "兴化市",
      "code": "225700",
      "label": "兴化市"
    }, {
      "value": "靖江市",
      "code": "214500",
      "label": "靖江市"
    }, {
      "value": "泰兴市",
      "code": "225400",
      "label": "泰兴市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "泰州市"
  }, {
    "value": "宿迁市",
    "children": [{
      "value": "宿城区",
      "code": "223802",
      "label": "宿城区"
    }, {
      "value": "宿豫区",
      "code": "223804",
      "label": "宿豫区"
    }, {
      "value": "沭阳县",
      "code": "223600",
      "label": "沭阳县"
    }, {
      "value": "泗阳县",
      "code": "223700",
      "label": "泗阳县"
    }, {
      "value": "泗洪县",
      "code": "223900",
      "label": "泗洪县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "宿迁市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "江苏省",
  "label": "江苏省"
}, {
  "children": [{
    "value": "杭州市",
    "children": [{
      "value": "上城区",
      "code": "310001",
      "label": "上城区"
    }, {
      "value": "下城区",
      "code": "310003",
      "label": "下城区"
    }, {
      "value": "江干区",
      "code": "310017",
      "label": "江干区"
    }, {
      "value": "拱墅区",
      "code": "310015",
      "label": "拱墅区"
    }, {
      "value": "西湖区",
      "code": "310007",
      "label": "西湖区"
    }, {
      "value": "滨江区",
      "code": "310051",
      "label": "滨江区"
    }, {
      "value": "萧山区",
      "code": "311200",
      "label": "萧山区"
    }, {
      "value": "余杭区",
      "code": "311100",
      "label": "余杭区"
    }, {
      "value": "富阳区",
      "code": "311400",
      "label": "富阳区"
    }, {
      "value": "桐庐县",
      "code": "311500",
      "label": "桐庐县"
    }, {
      "value": "淳安县",
      "code": "311700",
      "label": "淳安县"
    }, {
      "value": "建德市",
      "code": "311600",
      "label": "建德市"
    }, {
      "value": "临安市",
      "code": "311300",
      "label": "临安市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "杭州市"
  }, {
    "value": "宁波市",
    "children": [{
      "value": "海曙区",
      "code": "315010",
      "label": "海曙区"
    }, {
      "value": "江东区",
      "code": "315040",
      "label": "江东区"
    }, {
      "value": "江北区",
      "code": "315020",
      "label": "江北区"
    }, {
      "value": "北仑区",
      "code": "315800",
      "label": "北仑区"
    }, {
      "value": "镇海区",
      "code": "315200",
      "label": "镇海区"
    }, {
      "value": "鄞州区",
      "code": "315100",
      "label": "鄞州区"
    }, {
      "value": "象山县",
      "code": "315700",
      "label": "象山县"
    }, {
      "value": "宁海县",
      "code": "315600",
      "label": "宁海县"
    }, {
      "value": "余姚市",
      "code": "315400",
      "label": "余姚市"
    }, {
      "value": "慈溪市",
      "code": "315300",
      "label": "慈溪市"
    }, {
      "value": "奉化市",
      "code": "315500",
      "label": "奉化市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "宁波市"
  }, {
    "value": "温州市",
    "children": [{
      "value": "鹿城区",
      "code": "325001",
      "label": "鹿城区"
    }, {
      "value": "龙湾区",
      "code": "325011",
      "label": "龙湾区"
    }, {
      "value": "瓯海区",
      "code": "325006",
      "label": "瓯海区"
    }, {
      "value": "洞头区",
      "code": "325700",
      "label": "洞头区"
    }, {
      "value": "永嘉县",
      "code": "325100",
      "label": "永嘉县"
    }, {
      "value": "平阳县",
      "code": "325400",
      "label": "平阳县"
    }, {
      "value": "苍南县",
      "code": "325800",
      "label": "苍南县"
    }, {
      "value": "文成县",
      "code": "325300",
      "label": "文成县"
    }, {
      "value": "泰顺县",
      "code": "325500",
      "label": "泰顺县"
    }, {
      "value": "瑞安市",
      "code": "325200",
      "label": "瑞安市"
    }, {
      "value": "乐清市",
      "code": "325600",
      "label": "乐清市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "温州市"
  }, {
    "value": "嘉兴市",
    "children": [{
      "value": "南湖区",
      "code": "314002",
      "label": "南湖区"
    }, {
      "value": "秀洲区",
      "code": "314011",
      "label": "秀洲区"
    }, {
      "value": "嘉善县",
      "code": "314100",
      "label": "嘉善县"
    }, {
      "value": "海盐县",
      "code": "314300",
      "label": "海盐县"
    }, {
      "value": "海宁市",
      "code": "314400",
      "label": "海宁市"
    }, {
      "value": "平湖市",
      "code": "314200",
      "label": "平湖市"
    }, {
      "value": "桐乡市",
      "code": "314500",
      "label": "桐乡市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "嘉兴市"
  }, {
    "value": "湖州市",
    "children": [{
      "value": "吴兴区",
      "code": "313001",
      "label": "吴兴区"
    }, {
      "value": "南浔区",
      "code": "313009",
      "label": "南浔区"
    }, {
      "value": "德清县",
      "code": "313200",
      "label": "德清县"
    }, {
      "value": "长兴县",
      "code": "313100",
      "label": "长兴县"
    }, {
      "value": "安吉县",
      "code": "313300",
      "label": "安吉县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "湖州市"
  }, {
    "value": "绍兴市",
    "children": [{
      "value": "越城区",
      "code": "312001",
      "label": "越城区"
    }, {
      "value": "柯桥区",
      "code": "312025",
      "label": "柯桥区"
    }, {
      "value": "上虞区",
      "code": "312300",
      "label": "上虞区"
    }, {
      "value": "新昌县",
      "code": "312500",
      "label": "新昌县"
    }, {
      "value": "诸暨市",
      "code": "311800",
      "label": "诸暨市"
    }, {
      "value": "嵊州市",
      "code": "312400",
      "label": "嵊州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "绍兴市"
  }, {
    "value": "金华市",
    "children": [{
      "value": "婺城区",
      "code": "321001",
      "label": "婺城区"
    }, {
      "value": "金东区",
      "code": "321002",
      "label": "金东区"
    }, {
      "value": "武义县",
      "code": "321200",
      "label": "武义县"
    }, {
      "value": "浦江县",
      "code": "322200",
      "label": "浦江县"
    }, {
      "value": "磐安县",
      "code": "322300",
      "label": "磐安县"
    }, {
      "value": "兰溪市",
      "code": "321100",
      "label": "兰溪市"
    }, {
      "value": "义乌市",
      "code": "322000",
      "label": "义乌市"
    }, {
      "value": "东阳市",
      "code": "322100",
      "label": "东阳市"
    }, {
      "value": "永康市",
      "code": "321300",
      "label": "永康市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "金华市"
  }, {
    "value": "衢州市",
    "children": [{
      "value": "柯城区",
      "code": "324002",
      "label": "柯城区"
    }, {
      "value": "衢江区",
      "code": "324005",
      "label": "衢江区"
    }, {
      "value": "常山县",
      "code": "324200",
      "label": "常山县"
    }, {
      "value": "开化县",
      "code": "324300",
      "label": "开化县"
    }, {
      "value": "龙游县",
      "code": "324400",
      "label": "龙游县"
    }, {
      "value": "江山市",
      "code": "324100",
      "label": "江山市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "衢州市"
  }, {
    "value": "舟山市",
    "children": [{
      "value": "定海区",
      "code": "316001",
      "label": "定海区"
    }, {
      "value": "普陀区",
      "code": "316100",
      "label": "普陀区"
    }, {
      "value": "岱山县",
      "code": "316200",
      "label": "岱山县"
    }, {
      "value": "嵊泗县",
      "code": "202450",
      "label": "嵊泗县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "舟山市"
  }, {
    "value": "台州市",
    "children": [{
      "value": "椒江区",
      "code": "317700",
      "label": "椒江区"
    }, {
      "value": "黄岩区",
      "code": "318020",
      "label": "黄岩区"
    }, {
      "value": "路桥区",
      "code": "318050",
      "label": "路桥区"
    }, {
      "value": "玉环县",
      "code": "317600",
      "label": "玉环县"
    }, {
      "value": "三门县",
      "code": "317100",
      "label": "三门县"
    }, {
      "value": "天台县",
      "code": "317200",
      "label": "天台县"
    }, {
      "value": "仙居县",
      "code": "317300",
      "label": "仙居县"
    }, {
      "value": "温岭市",
      "code": "317500",
      "label": "温岭市"
    }, {
      "value": "临海市",
      "code": "317000",
      "label": "临海市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "台州市"
  }, {
    "value": "丽水市",
    "children": [{
      "value": "莲都区",
      "code": "323003",
      "label": "莲都区"
    }, {
      "value": "青田县",
      "code": "323900",
      "label": "青田县"
    }, {
      "value": "缙云县",
      "code": "321400",
      "label": "缙云县"
    }, {
      "value": "遂昌县",
      "code": "323300",
      "label": "遂昌县"
    }, {
      "value": "松阳县",
      "code": "323400",
      "label": "松阳县"
    }, {
      "value": "云和县",
      "code": "323600",
      "label": "云和县"
    }, {
      "value": "庆元县",
      "code": "323800",
      "label": "庆元县"
    }, {
      "value": "景宁畲族自治县",
      "code": "323500",
      "label": "景宁畲族自治县"
    }, {
      "value": "龙泉市",
      "code": "323700",
      "label": "龙泉市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "丽水市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "浙江省",
  "label": "浙江省"
}, {
  "children": [{
    "value": "合肥市",
    "children": [{
      "value": "瑶海区",
      "code": "230011",
      "label": "瑶海区"
    }, {
      "value": "庐阳区",
      "code": "230001",
      "label": "庐阳区"
    }, {
      "value": "蜀山区",
      "code": "230032",
      "label": "蜀山区"
    }, {
      "value": "包河区",
      "code": "230001",
      "label": "包河区"
    }, {
      "value": "长丰县",
      "code": "231100",
      "label": "长丰县"
    }, {
      "value": "肥东县",
      "code": "231602",
      "label": "肥东县"
    }, {
      "value": "肥西县",
      "code": "231200",
      "label": "肥西县"
    }, {
      "value": "庐江县",
      "code": "231500",
      "label": "庐江县"
    }, {
      "value": "巢湖市",
      "code": "238006",
      "label": "巢湖市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "合肥市"
  }, {
    "value": "芜湖市",
    "children": [{
      "value": "镜湖区",
      "code": "241001",
      "label": "镜湖区"
    }, {
      "value": "弋江区",
      "code": "241002",
      "label": "弋江区"
    }, {
      "value": "鸠江区",
      "code": "241007",
      "label": "鸠江区"
    }, {
      "value": "三山区",
      "code": "241080",
      "label": "三山区"
    }, {
      "value": "芜湖县",
      "code": "241100",
      "label": "芜湖县"
    }, {
      "value": "繁昌县",
      "code": "241200",
      "label": "繁昌县"
    }, {
      "value": "南陵县",
      "code": "241303",
      "label": "南陵县"
    }, {
      "value": "无为县",
      "code": "238300",
      "label": "无为县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "芜湖市"
  }, {
    "value": "蚌埠市",
    "children": [{
      "value": "龙子湖区",
      "code": "233004",
      "label": "龙子湖区"
    }, {
      "value": "蚌山区",
      "code": "233040",
      "label": "蚌山区"
    }, {
      "value": "禹会区",
      "code": "233010",
      "label": "禹会区"
    }, {
      "value": "淮上区",
      "code": "233020",
      "label": "淮上区"
    }, {
      "value": "怀远县",
      "code": "233400",
      "label": "怀远县"
    }, {
      "value": "五河县",
      "code": "233300",
      "label": "五河县"
    }, {
      "value": "固镇县",
      "code": "233700",
      "label": "固镇县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "蚌埠市"
  }, {
    "value": "淮南市",
    "children": [{
      "value": "大通区",
      "code": "232008",
      "label": "大通区"
    }, {
      "value": "田家庵区",
      "code": "232001",
      "label": "田家庵区"
    }, {
      "value": "谢家集区",
      "code": "232046",
      "label": "谢家集区"
    }, {
      "value": "八公山区",
      "code": "232072",
      "label": "八公山区"
    }, {
      "value": "潘集区",
      "code": "232082",
      "label": "潘集区"
    }, {
      "value": "凤台县",
      "code": "232100",
      "label": "凤台县"
    }, {
      "value": "寿县",
      "code": "232200",
      "label": "寿县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "淮南市"
  }, {
    "value": "马鞍山市",
    "children": [{
      "value": "花山区",
      "code": "243001",
      "label": "花山区"
    }, {
      "value": "雨山区",
      "code": "243003",
      "label": "雨山区"
    }, {
      "value": "博望区",
      "code": "243131",
      "label": "博望区"
    }, {
      "value": "当涂县",
      "code": "243100",
      "label": "当涂县"
    }, {
      "value": "含山县",
      "code": "238100",
      "label": "含山县"
    }, {
      "value": "和县",
      "code": "238200",
      "label": "和县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "马鞍山市"
  }, {
    "value": "淮北市",
    "children": [{
      "value": "杜集区",
      "code": "235037",
      "label": "杜集区"
    }, {
      "value": "相山区",
      "code": "235029",
      "label": "相山区"
    }, {
      "value": "烈山区",
      "code": "235065",
      "label": "烈山区"
    }, {
      "value": "濉溪县",
      "code": "235100",
      "label": "濉溪县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "淮北市"
  }, {
    "value": "铜陵市",
    "children": [{
      "value": "铜官山区",
      "code": "244002",
      "label": "铜官山区"
    }, {
      "value": "义安区",
      "code": "244041",
      "label": "义安区"
    }, {
      "value": "枞阳县",
      "code": "246700",
      "label": "枞阳县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "铜陵市"
  }, {
    "value": "安庆市",
    "children": [{
      "value": "迎江区",
      "code": "246008",
      "label": "迎江区"
    }, {
      "value": "大观区",
      "code": "246000",
      "label": "大观区"
    }, {
      "value": "宜秀区",
      "code": "246006",
      "label": "宜秀区"
    }, {
      "value": "怀宁县",
      "code": "246100",
      "label": "怀宁县"
    }, {
      "value": "潜山县",
      "code": "246300",
      "label": "潜山县"
    }, {
      "value": "太湖县",
      "code": "246400",
      "label": "太湖县"
    }, {
      "value": "宿松县",
      "code": "246500",
      "label": "宿松县"
    }, {
      "value": "望江县",
      "code": "246200",
      "label": "望江县"
    }, {
      "value": "岳西县",
      "code": "246600",
      "label": "岳西县"
    }, {
      "value": "桐城市",
      "code": "231400",
      "label": "桐城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "安庆市"
  }, {
    "value": "黄山市",
    "children": [{
      "value": "屯溪区",
      "code": "245000",
      "label": "屯溪区"
    }, {
      "value": "黄山区",
      "code": "245701",
      "label": "黄山区"
    }, {
      "value": "徽州区",
      "code": "245902",
      "label": "徽州区"
    }, {
      "value": "歙县",
      "code": "245200",
      "label": "歙县"
    }, {
      "value": "休宁县",
      "code": "245400",
      "label": "休宁县"
    }, {
      "value": "黟县",
      "code": "245500",
      "label": "黟县"
    }, {
      "value": "祁门县",
      "code": "245600",
      "label": "祁门县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "黄山市"
  }, {
    "value": "滁州市",
    "children": [{
      "value": "琅琊区",
      "code": "239004",
      "label": "琅琊区"
    }, {
      "value": "南谯区",
      "code": "239050",
      "label": "南谯区"
    }, {
      "value": "来安县",
      "code": "239200",
      "label": "来安县"
    }, {
      "value": "全椒县",
      "code": "239500",
      "label": "全椒县"
    }, {
      "value": "定远县",
      "code": "233200",
      "label": "定远县"
    }, {
      "value": "凤阳县",
      "code": "233100",
      "label": "凤阳县"
    }, {
      "value": "天长市",
      "code": "239300",
      "label": "天长市"
    }, {
      "value": "明光市",
      "code": "239400",
      "label": "明光市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "滁州市"
  }, {
    "value": "阜阳市",
    "children": [{
      "value": "颍州区",
      "code": "236004",
      "label": "颍州区"
    }, {
      "value": "颍东区",
      "code": "236050",
      "label": "颍东区"
    }, {
      "value": "颍泉区",
      "code": "236002",
      "label": "颍泉区"
    }, {
      "value": "临泉县",
      "code": "236400",
      "label": "临泉县"
    }, {
      "value": "太和县",
      "code": "236600",
      "label": "太和县"
    }, {
      "value": "阜南县",
      "code": "236300",
      "label": "阜南县"
    }, {
      "value": "颍上县",
      "code": "236200",
      "label": "颍上县"
    }, {
      "value": "界首市",
      "code": "236500",
      "label": "界首市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "阜阳市"
  }, {
    "value": "宿州市",
    "children": [{
      "value": "埇桥区",
      "code": "234001",
      "label": "埇桥区"
    }, {
      "value": "砀山县",
      "code": "235300",
      "label": "砀山县"
    }, {
      "value": "萧县",
      "code": "235200",
      "label": "萧县"
    }, {
      "value": "灵璧县",
      "code": "234200",
      "label": "灵璧县"
    }, {
      "value": "泗县",
      "code": "234300",
      "label": "泗县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "宿州市"
  }, {
    "value": "六安市",
    "children": [{
      "value": "金安区",
      "code": "237001",
      "label": "金安区"
    }, {
      "value": "裕安区",
      "code": "237004",
      "label": "裕安区"
    }, {
      "value": "叶集区",
      "code": "237431",
      "label": "叶集区"
    }, {
      "value": "霍邱县",
      "code": "237400",
      "label": "霍邱县"
    }, {
      "value": "舒城县",
      "code": "231300",
      "label": "舒城县"
    }, {
      "value": "金寨县",
      "code": "237300",
      "label": "金寨县"
    }, {
      "value": "霍山县",
      "code": "237200",
      "label": "霍山县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "六安市"
  }, {
    "value": "亳州市",
    "children": [{
      "value": "谯城区",
      "code": "236800",
      "label": "谯城区"
    }, {
      "value": "涡阳县",
      "code": "233600",
      "label": "涡阳县"
    }, {
      "value": "蒙城县",
      "code": "233500",
      "label": "蒙城县"
    }, {
      "value": "利辛县",
      "code": "236700",
      "label": "利辛县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "亳州市"
  }, {
    "value": "池州市",
    "children": [{
      "value": "贵池区",
      "code": "247001",
      "label": "贵池区"
    }, {
      "value": "东至县",
      "code": "247200",
      "label": "东至县"
    }, {
      "value": "石台县",
      "code": "245100",
      "label": "石台县"
    }, {
      "value": "青阳县",
      "code": "242800",
      "label": "青阳县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "池州市"
  }, {
    "value": "宣城市",
    "children": [{
      "value": "宣州区",
      "code": "242034",
      "label": "宣州区"
    }, {
      "value": "郎溪县",
      "code": "242100",
      "label": "郎溪县"
    }, {
      "value": "广德县",
      "code": "242200",
      "label": "广德县"
    }, {
      "value": "泾县",
      "code": "242500",
      "label": "泾县"
    }, {
      "value": "绩溪县",
      "code": "245300",
      "label": "绩溪县"
    }, {
      "value": "旌德县",
      "code": "242600",
      "label": "旌德县"
    }, {
      "value": "宁国市",
      "code": "242300",
      "label": "宁国市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "宣城市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "安徽省",
  "label": "安徽省"
}, {
  "children": [{
    "value": "福州市",
    "children": [{
      "value": "鼓楼区",
      "code": "350025",
      "label": "鼓楼区"
    }, {
      "value": "台江区",
      "code": "350001",
      "label": "台江区"
    }, {
      "value": "仓山区",
      "code": "350007",
      "label": "仓山区"
    }, {
      "value": "马尾区",
      "code": "350015",
      "label": "马尾区"
    }, {
      "value": "晋安区",
      "code": "350011",
      "label": "晋安区"
    }, {
      "value": "闽侯县",
      "code": "350100",
      "label": "闽侯县"
    }, {
      "value": "连江县",
      "code": "350500",
      "label": "连江县"
    }, {
      "value": "罗源县",
      "code": "350600",
      "label": "罗源县"
    }, {
      "value": "闽清县",
      "code": "350800",
      "label": "闽清县"
    }, {
      "value": "永泰县",
      "code": "350700",
      "label": "永泰县"
    }, {
      "value": "平潭县",
      "code": "350400",
      "label": "平潭县"
    }, {
      "value": "福清市",
      "code": "350300",
      "label": "福清市"
    }, {
      "value": "长乐市",
      "code": "350200",
      "label": "长乐市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "福州市"
  }, {
    "value": "厦门市",
    "children": [{
      "value": "思明区",
      "code": "361001",
      "label": "思明区"
    }, {
      "value": "海沧区",
      "code": "361026",
      "label": "海沧区"
    }, {
      "value": "湖里区",
      "code": "361006",
      "label": "湖里区"
    }, {
      "value": "集美区",
      "code": "361021",
      "label": "集美区"
    }, {
      "value": "同安区",
      "code": "361106",
      "label": "同安区"
    }, {
      "value": "翔安区",
      "code": "361101",
      "label": "翔安区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "厦门市"
  }, {
    "value": "莆田市",
    "children": [{
      "value": "城厢区",
      "code": "351137",
      "label": "城厢区"
    }, {
      "value": "涵江区",
      "code": "351111",
      "label": "涵江区"
    }, {
      "value": "荔城区",
      "code": "351131",
      "label": "荔城区"
    }, {
      "value": "秀屿区",
      "code": "351146",
      "label": "秀屿区"
    }, {
      "value": "仙游县",
      "code": "351200",
      "label": "仙游县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "莆田市"
  }, {
    "value": "三明市",
    "children": [{
      "value": "梅列区",
      "code": "365009",
      "label": "梅列区"
    }, {
      "value": "三元区",
      "code": "365001",
      "label": "三元区"
    }, {
      "value": "明溪县",
      "code": "365200",
      "label": "明溪县"
    }, {
      "value": "清流县",
      "code": "365300",
      "label": "清流县"
    }, {
      "value": "宁化县",
      "code": "365400",
      "label": "宁化县"
    }, {
      "value": "大田县",
      "code": "366100",
      "label": "大田县"
    }, {
      "value": "尤溪县",
      "code": "365100",
      "label": "尤溪县"
    }, {
      "value": "沙县",
      "code": "365500",
      "label": "沙县"
    }, {
      "value": "将乐县",
      "code": "353300",
      "label": "将乐县"
    }, {
      "value": "泰宁县",
      "code": "354400",
      "label": "泰宁县"
    }, {
      "value": "建宁县",
      "code": "354500",
      "label": "建宁县"
    }, {
      "value": "永安市",
      "code": "366000",
      "label": "永安市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "三明市"
  }, {
    "value": "泉州市",
    "children": [{
      "value": "鲤城区",
      "code": "362001",
      "label": "鲤城区"
    }, {
      "value": "丰泽区",
      "code": "362011",
      "label": "丰泽区"
    }, {
      "value": "洛江区",
      "code": "362010",
      "label": "洛江区"
    }, {
      "value": "泉港区",
      "code": "362800",
      "label": "泉港区"
    }, {
      "value": "惠安县",
      "code": "362100",
      "label": "惠安县"
    }, {
      "value": "安溪县",
      "code": "362400",
      "label": "安溪县"
    }, {
      "value": "永春县",
      "code": "362600",
      "label": "永春县"
    }, {
      "value": "德化县",
      "code": "362500",
      "label": "德化县"
    }, {
      "value": "金门县",
      "code": "362001",
      "label": "金门县"
    }, {
      "value": "石狮市",
      "code": "362700",
      "label": "石狮市"
    }, {
      "value": "晋江市",
      "code": "362200",
      "label": "晋江市"
    }, {
      "value": "南安市",
      "code": "362300",
      "label": "南安市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "泉州市"
  }, {
    "value": "漳州市",
    "children": [{
      "value": "芗城区",
      "code": "363001",
      "label": "芗城区"
    }, {
      "value": "龙文区",
      "code": "363005",
      "label": "龙文区"
    }, {
      "value": "云霄县",
      "code": "363300",
      "label": "云霄县"
    }, {
      "value": "漳浦县",
      "code": "363200",
      "label": "漳浦县"
    }, {
      "value": "诏安县",
      "code": "363500",
      "label": "诏安县"
    }, {
      "value": "长泰县",
      "code": "363900",
      "label": "长泰县"
    }, {
      "value": "东山县",
      "code": "363400",
      "label": "东山县"
    }, {
      "value": "南靖县",
      "code": "363600",
      "label": "南靖县"
    }, {
      "value": "平和县",
      "code": "363700",
      "label": "平和县"
    }, {
      "value": "华安县",
      "code": "363800",
      "label": "华安县"
    }, {
      "value": "龙海市",
      "code": "363100",
      "label": "龙海市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "漳州市"
  }, {
    "value": "南平市",
    "children": [{
      "value": "延平区",
      "code": "353001",
      "label": "延平区"
    }, {
      "value": "建阳区",
      "code": "354200",
      "label": "建阳区"
    }, {
      "value": "顺昌县",
      "code": "353200",
      "label": "顺昌县"
    }, {
      "value": "浦城县",
      "code": "353400",
      "label": "浦城县"
    }, {
      "value": "光泽县",
      "code": "354100",
      "label": "光泽县"
    }, {
      "value": "松溪县",
      "code": "353500",
      "label": "松溪县"
    }, {
      "value": "政和县",
      "code": "353600",
      "label": "政和县"
    }, {
      "value": "邵武市",
      "code": "354000",
      "label": "邵武市"
    }, {
      "value": "武夷山市",
      "code": "354300",
      "label": "武夷山市"
    }, {
      "value": "建瓯市",
      "code": "353100",
      "label": "建瓯市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "南平市"
  }, {
    "value": "龙岩市",
    "children": [{
      "value": "新罗区",
      "code": "364001",
      "label": "新罗区"
    }, {
      "value": "永定区",
      "code": "364100",
      "label": "永定区"
    }, {
      "value": "长汀县",
      "code": "366300",
      "label": "长汀县"
    }, {
      "value": "上杭县",
      "code": "364200",
      "label": "上杭县"
    }, {
      "value": "武平县",
      "code": "364300",
      "label": "武平县"
    }, {
      "value": "连城县",
      "code": "366200",
      "label": "连城县"
    }, {
      "value": "漳平市",
      "code": "364400",
      "label": "漳平市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "龙岩市"
  }, {
    "value": "宁德市",
    "children": [{
      "value": "蕉城区",
      "code": "352101",
      "label": "蕉城区"
    }, {
      "value": "霞浦县",
      "code": "355100",
      "label": "霞浦县"
    }, {
      "value": "古田县",
      "code": "352200",
      "label": "古田县"
    }, {
      "value": "屏南县",
      "code": "352300",
      "label": "屏南县"
    }, {
      "value": "寿宁县",
      "code": "355500",
      "label": "寿宁县"
    }, {
      "value": "周宁县",
      "code": "355400",
      "label": "周宁县"
    }, {
      "value": "柘荣县",
      "code": "355300",
      "label": "柘荣县"
    }, {
      "value": "福安市",
      "code": "355000",
      "label": "福安市"
    }, {
      "value": "福鼎市",
      "code": "355200",
      "label": "福鼎市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "宁德市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "福建省",
  "label": "福建省"
}, {
  "children": [{
    "value": "南昌市",
    "children": [{
      "value": "东湖区",
      "code": "330006",
      "label": "东湖区"
    }, {
      "value": "西湖区",
      "code": "330003",
      "label": "西湖区"
    }, {
      "value": "青云谱区",
      "code": "330001",
      "label": "青云谱区"
    }, {
      "value": "湾里区",
      "code": "330004",
      "label": "湾里区"
    }, {
      "value": "青山湖区",
      "code": "330012",
      "label": "青山湖区"
    }, {
      "value": "新建区",
      "code": "330100",
      "label": "新建区"
    }, {
      "value": "南昌县",
      "code": "330200",
      "label": "南昌县"
    }, {
      "value": "安义县",
      "code": "330500",
      "label": "安义县"
    }, {
      "value": "进贤县",
      "code": "331700",
      "label": "进贤县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "南昌市"
  }, {
    "value": "景德镇市",
    "children": [{
      "value": "昌江区",
      "code": "333003",
      "label": "昌江区"
    }, {
      "value": "珠山区",
      "code": "333001",
      "label": "珠山区"
    }, {
      "value": "浮梁县",
      "code": "333039",
      "label": "浮梁县"
    }, {
      "value": "乐平市",
      "code": "333300",
      "label": "乐平市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "景德镇市"
  }, {
    "value": "萍乡市",
    "children": [{
      "value": "安源区",
      "code": "337014",
      "label": "安源区"
    }, {
      "value": "湘东区",
      "code": "337016",
      "label": "湘东区"
    }, {
      "value": "莲花县",
      "code": "337100",
      "label": "莲花县"
    }, {
      "value": "上栗县",
      "code": "337004",
      "label": "上栗县"
    }, {
      "value": "芦溪县",
      "code": "337237",
      "label": "芦溪县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "萍乡市"
  }, {
    "value": "九江市",
    "children": [{
      "value": "庐山区",
      "code": "332009",
      "label": "庐山区"
    }, {
      "value": "浔阳区",
      "code": "332001",
      "label": "浔阳区"
    }, {
      "value": "九江县",
      "code": "332100",
      "label": "九江县"
    }, {
      "value": "武宁县",
      "code": "332300",
      "label": "武宁县"
    }, {
      "value": "修水县",
      "code": "332400",
      "label": "修水县"
    }, {
      "value": "永修县",
      "code": "330300",
      "label": "永修县"
    }, {
      "value": "德安县",
      "code": "330400",
      "label": "德安县"
    }, {
      "value": "星子县",
      "code": "332800",
      "label": "星子县"
    }, {
      "value": "都昌县",
      "code": "332600",
      "label": "都昌县"
    }, {
      "value": "湖口县",
      "code": "332500",
      "label": "湖口县"
    }, {
      "value": "彭泽县",
      "code": "332700",
      "label": "彭泽县"
    }, {
      "value": "瑞昌市",
      "code": "332200",
      "label": "瑞昌市"
    }, {
      "value": "共青城市",
      "code": "332020",
      "label": "共青城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "九江市"
  }, {
    "value": "新余市",
    "children": [{
      "value": "渝水区",
      "code": "338001",
      "label": "渝水区"
    }, {
      "value": "分宜县",
      "code": "336600",
      "label": "分宜县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "新余市"
  }, {
    "value": "鹰潭市",
    "children": [{
      "value": "月湖区",
      "code": "335003",
      "label": "月湖区"
    }, {
      "value": "余江县",
      "code": "335200",
      "label": "余江县"
    }, {
      "value": "贵溪市",
      "code": "335400",
      "label": "贵溪市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "鹰潭市"
  }, {
    "value": "赣州市",
    "children": [{
      "value": "章贡区",
      "code": "341001",
      "label": "章贡区"
    }, {
      "value": "南康区",
      "code": "341400",
      "label": "南康区"
    }, {
      "value": "赣县",
      "code": "341100",
      "label": "赣县"
    }, {
      "value": "信丰县",
      "code": "341600",
      "label": "信丰县"
    }, {
      "value": "大余县",
      "code": "341500",
      "label": "大余县"
    }, {
      "value": "上犹县",
      "code": "341200",
      "label": "上犹县"
    }, {
      "value": "崇义县",
      "code": "341300",
      "label": "崇义县"
    }, {
      "value": "安远县",
      "code": "342100",
      "label": "安远县"
    }, {
      "value": "龙南县",
      "code": "341700",
      "label": "龙南县"
    }, {
      "value": "定南县",
      "code": "341900",
      "label": "定南县"
    }, {
      "value": "全南县",
      "code": "341800",
      "label": "全南县"
    }, {
      "value": "宁都县",
      "code": "342800",
      "label": "宁都县"
    }, {
      "value": "于都县",
      "code": "342300",
      "label": "于都县"
    }, {
      "value": "兴国县",
      "code": "342400",
      "label": "兴国县"
    }, {
      "value": "会昌县",
      "code": "342600",
      "label": "会昌县"
    }, {
      "value": "寻乌县",
      "code": "342200",
      "label": "寻乌县"
    }, {
      "value": "石城县",
      "code": "342700",
      "label": "石城县"
    }, {
      "value": "瑞金市",
      "code": "342500",
      "label": "瑞金市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "赣州市"
  }, {
    "value": "吉安市",
    "children": [{
      "value": "吉州区",
      "code": "343006",
      "label": "吉州区"
    }, {
      "value": "青原区",
      "code": "343009",
      "label": "青原区"
    }, {
      "value": "吉安县",
      "code": "343100",
      "label": "吉安县"
    }, {
      "value": "吉水县",
      "code": "331600",
      "label": "吉水县"
    }, {
      "value": "峡江县",
      "code": "331400",
      "label": "峡江县"
    }, {
      "value": "新干县",
      "code": "331300",
      "label": "新干县"
    }, {
      "value": "永丰县",
      "code": "331500",
      "label": "永丰县"
    }, {
      "value": "泰和县",
      "code": "343700",
      "label": "泰和县"
    }, {
      "value": "遂川县",
      "code": "343900",
      "label": "遂川县"
    }, {
      "value": "万安县",
      "code": "343800",
      "label": "万安县"
    }, {
      "value": "安福县",
      "code": "343200",
      "label": "安福县"
    }, {
      "value": "永新县",
      "code": "343400",
      "label": "永新县"
    }, {
      "value": "井冈山市",
      "code": "343600",
      "label": "井冈山市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "吉安市"
  }, {
    "value": "宜春市",
    "children": [{
      "value": "袁州区",
      "code": "336002",
      "label": "袁州区"
    }, {
      "value": "奉新县",
      "code": "330700",
      "label": "奉新县"
    }, {
      "value": "万载县",
      "code": "336100",
      "label": "万载县"
    }, {
      "value": "上高县",
      "code": "336400",
      "label": "上高县"
    }, {
      "value": "宜丰县",
      "code": "336300",
      "label": "宜丰县"
    }, {
      "value": "靖安县",
      "code": "330600",
      "label": "靖安县"
    }, {
      "value": "铜鼓县",
      "code": "336200",
      "label": "铜鼓县"
    }, {
      "value": "丰城市",
      "code": "331100",
      "label": "丰城市"
    }, {
      "value": "樟树市",
      "code": "331200",
      "label": "樟树市"
    }, {
      "value": "高安市",
      "code": "330800",
      "label": "高安市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "宜春市"
  }, {
    "value": "抚州市",
    "children": [{
      "value": "临川区",
      "code": "344100",
      "label": "临川区"
    }, {
      "value": "南城县",
      "code": "344700",
      "label": "南城县"
    }, {
      "value": "黎川县",
      "code": "344600",
      "label": "黎川县"
    }, {
      "value": "南丰县",
      "code": "344500",
      "label": "南丰县"
    }, {
      "value": "崇仁县",
      "code": "344200",
      "label": "崇仁县"
    }, {
      "value": "乐安县",
      "code": "344300",
      "label": "乐安县"
    }, {
      "value": "宜黄县",
      "code": "344400",
      "label": "宜黄县"
    }, {
      "value": "金溪县",
      "code": "344800",
      "label": "金溪县"
    }, {
      "value": "资溪县",
      "code": "335300",
      "label": "资溪县"
    }, {
      "value": "东乡县",
      "code": "331800",
      "label": "东乡县"
    }, {
      "value": "广昌县",
      "code": "344900",
      "label": "广昌县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "抚州市"
  }, {
    "value": "上饶市",
    "children": [{
      "value": "信州区",
      "code": "334001",
      "label": "信州区"
    }, {
      "value": "广丰区",
      "code": "334600",
      "label": "广丰区"
    }, {
      "value": "上饶县",
      "code": "334100",
      "label": "上饶县"
    }, {
      "value": "玉山县",
      "code": "334700",
      "label": "玉山县"
    }, {
      "value": "铅山县",
      "code": "334500",
      "label": "铅山县"
    }, {
      "value": "横峰县",
      "code": "334300",
      "label": "横峰县"
    }, {
      "value": "弋阳县",
      "code": "334400",
      "label": "弋阳县"
    }, {
      "value": "余干县",
      "code": "335100",
      "label": "余干县"
    }, {
      "value": "鄱阳县",
      "code": "333100",
      "label": "鄱阳县"
    }, {
      "value": "万年县",
      "code": "335500",
      "label": "万年县"
    }, {
      "value": "婺源县",
      "code": "333200",
      "label": "婺源县"
    }, {
      "value": "德兴市",
      "code": "334200",
      "label": "德兴市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "上饶市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "江西省",
  "label": "江西省"
}, {
  "children": [{
    "value": "济南市",
    "children": [{
      "value": "历下区",
      "code": "250061",
      "label": "历下区"
    }, {
      "value": "市中区",
      "code": "250004",
      "label": "市中区"
    }, {
      "value": "槐荫区",
      "code": "250029",
      "label": "槐荫区"
    }, {
      "value": "天桥区",
      "code": "250031",
      "label": "天桥区"
    }, {
      "value": "历城区",
      "code": "250099",
      "label": "历城区"
    }, {
      "value": "高新区",
      "code": "250101",
      "label": "高新区"
    }, {
      "value": "长清区",
      "code": "250300",
      "label": "长清区"
    }, {
      "value": "平阴县",
      "code": "250400",
      "label": "平阴县"
    }, {
      "value": "济阳县",
      "code": "251400",
      "label": "济阳县"
    }, {
      "value": "商河县",
      "code": "251600",
      "label": "商河县"
    }, {
      "value": "章丘市",
      "code": "250200",
      "label": "章丘市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "济南市"
  }, {
    "value": "青岛市",
    "children": [{
      "value": "市南区",
      "code": "266001",
      "label": "市南区"
    }, {
      "value": "市北区",
      "code": "266012",
      "label": "市北区"
    }, {
      "value": "黄岛区",
      "code": "266426",
      "label": "黄岛区"
    }, {
      "value": "崂山区",
      "code": "266061",
      "label": "崂山区"
    }, {
      "value": "李沧区",
      "code": "266041",
      "label": "李沧区"
    }, {
      "value": "城阳区",
      "code": "266106",
      "label": "城阳区"
    }, {
      "value": "胶州市",
      "code": "266300",
      "label": "胶州市"
    }, {
      "value": "即墨市",
      "code": "266200",
      "label": "即墨市"
    }, {
      "value": "平度市",
      "code": "266700",
      "label": "平度市"
    }, {
      "value": "莱西市",
      "code": "266600",
      "label": "莱西市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "青岛市"
  }, {
    "value": "淄博市",
    "children": [{
      "value": "淄川区",
      "code": "255100",
      "label": "淄川区"
    }, {
      "value": "张店区",
      "code": "255020",
      "label": "张店区"
    }, {
      "value": "博山区",
      "code": "255200",
      "label": "博山区"
    }, {
      "value": "临淄区",
      "code": "255400",
      "label": "临淄区"
    }, {
      "value": "周村区",
      "code": "255300",
      "label": "周村区"
    }, {
      "value": "桓台县",
      "code": "256400",
      "label": "桓台县"
    }, {
      "value": "高青县",
      "code": "256300",
      "label": "高青县"
    }, {
      "value": "沂源县",
      "code": "256100",
      "label": "沂源县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "淄博市"
  }, {
    "value": "枣庄市",
    "children": [{
      "value": "市中区",
      "code": "277102",
      "label": "市中区"
    }, {
      "value": "薛城区",
      "code": "277011",
      "label": "薛城区"
    }, {
      "value": "峄城区",
      "code": "277300",
      "label": "峄城区"
    }, {
      "value": "台儿庄区",
      "code": "277400",
      "label": "台儿庄区"
    }, {
      "value": "山亭区",
      "code": "277200",
      "label": "山亭区"
    }, {
      "value": "滕州市",
      "code": "277500",
      "label": "滕州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "枣庄市"
  }, {
    "value": "东营市",
    "children": [{
      "value": "东营区",
      "code": "257045",
      "label": "东营区"
    }, {
      "value": "河口区",
      "code": "257200",
      "label": "河口区"
    }, {
      "value": "垦利县",
      "code": "257041",
      "label": "垦利县"
    }, {
      "value": "利津县",
      "code": "257400",
      "label": "利津县"
    }, {
      "value": "广饶县",
      "code": "257300",
      "label": "广饶县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "东营市"
  }, {
    "value": "烟台市",
    "children": [{
      "value": "芝罘区",
      "code": "264001",
      "label": "芝罘区"
    }, {
      "value": "福山区",
      "code": "265500",
      "label": "福山区"
    }, {
      "value": "牟平区",
      "code": "264100",
      "label": "牟平区"
    }, {
      "value": "莱山区",
      "code": "264003",
      "label": "莱山区"
    }, {
      "value": "长岛县",
      "code": "265800",
      "label": "长岛县"
    }, {
      "value": "龙口市",
      "code": "265700",
      "label": "龙口市"
    }, {
      "value": "莱阳市",
      "code": "265200",
      "label": "莱阳市"
    }, {
      "value": "莱州市",
      "code": "261400",
      "label": "莱州市"
    }, {
      "value": "蓬莱市",
      "code": "265600",
      "label": "蓬莱市"
    }, {
      "value": "招远市",
      "code": "265400",
      "label": "招远市"
    }, {
      "value": "栖霞市",
      "code": "265300",
      "label": "栖霞市"
    }, {
      "value": "海阳市",
      "code": "265100",
      "label": "海阳市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "烟台市"
  }, {
    "value": "潍坊市",
    "children": [{
      "value": "潍城区",
      "code": "261011",
      "label": "潍城区"
    }, {
      "value": "寒亭区",
      "code": "261100",
      "label": "寒亭区"
    }, {
      "value": "坊子区",
      "code": "261200",
      "label": "坊子区"
    }, {
      "value": "奎文区",
      "code": "261031",
      "label": "奎文区"
    }, {
      "value": "临朐县",
      "code": "262600",
      "label": "临朐县"
    }, {
      "value": "昌乐县",
      "code": "262400",
      "label": "昌乐县"
    }, {
      "value": "青州市",
      "code": "262500",
      "label": "青州市"
    }, {
      "value": "诸城市",
      "code": "262200",
      "label": "诸城市"
    }, {
      "value": "寿光市",
      "code": "262700",
      "label": "寿光市"
    }, {
      "value": "安丘市",
      "code": "262100",
      "label": "安丘市"
    }, {
      "value": "高密市",
      "code": "261500",
      "label": "高密市"
    }, {
      "value": "昌邑市",
      "code": "261300",
      "label": "昌邑市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "潍坊市"
  }, {
    "value": "济宁市",
    "children": [{
      "value": "任城区",
      "code": "272009",
      "label": "任城区"
    }, {
      "value": "兖州区",
      "code": "272100",
      "label": "兖州区"
    }, {
      "value": "微山县",
      "code": "272191",
      "label": "微山县"
    }, {
      "value": "鱼台县",
      "code": "272300",
      "label": "鱼台县"
    }, {
      "value": "金乡县",
      "code": "272200",
      "label": "金乡县"
    }, {
      "value": "嘉祥县",
      "code": "272400",
      "label": "嘉祥县"
    }, {
      "value": "汶上县",
      "code": "272500",
      "label": "汶上县"
    }, {
      "value": "泗水县",
      "code": "273200",
      "label": "泗水县"
    }, {
      "value": "梁山县",
      "code": "272600",
      "label": "梁山县"
    }, {
      "value": "曲阜市",
      "code": "272099",
      "label": "曲阜市"
    }, {
      "value": "邹城市",
      "code": "273500",
      "label": "邹城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "济宁市"
  }, {
    "value": "泰安市",
    "children": [{
      "value": "泰山区",
      "code": "271001",
      "label": "泰山区"
    }, {
      "value": "岱岳区",
      "code": "271022",
      "label": "岱岳区"
    }, {
      "value": "宁阳县",
      "code": "271400",
      "label": "宁阳县"
    }, {
      "value": "东平县",
      "code": "271500",
      "label": "东平县"
    }, {
      "value": "新泰市",
      "code": "271200",
      "label": "新泰市"
    }, {
      "value": "肥城市",
      "code": "271600",
      "label": "肥城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "泰安市"
  }, {
    "value": "威海市",
    "children": [{
      "value": "环翠区",
      "code": "264201",
      "label": "环翠区"
    }, {
      "value": "文登区",
      "code": "264400",
      "label": "文登区"
    }, {
      "value": "文登市",
      "code": "264402",
      "label": "文登市"
    }, {
      "value": "荣成市",
      "code": "264300",
      "label": "荣成市"
    }, {
      "value": "乳山市",
      "code": "264500",
      "label": "乳山市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "威海市"
  }, {
    "value": "日照市",
    "children": [{
      "value": "东港区",
      "code": "276801",
      "label": "东港区"
    }, {
      "value": "岚山区",
      "code": "276806",
      "label": "岚山区"
    }, {
      "value": "五莲县",
      "code": "262300",
      "label": "五莲县"
    }, {
      "value": "莒县",
      "code": "276500",
      "label": "莒县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "日照市"
  }, {
    "value": "莱芜市",
    "children": [{
      "value": "莱城区",
      "code": "271102",
      "label": "莱城区"
    }, {
      "value": "钢城区",
      "code": "271103",
      "label": "钢城区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "莱芜市"
  }, {
    "value": "临沂市",
    "children": [{
      "value": "兰山区",
      "code": "276001",
      "label": "兰山区"
    }, {
      "value": "罗庄区",
      "code": "276014",
      "label": "罗庄区"
    }, {
      "value": "河东区",
      "code": "276023",
      "label": "河东区"
    }, {
      "value": "沂南县",
      "code": "276300",
      "label": "沂南县"
    }, {
      "value": "郯城县",
      "code": "276100",
      "label": "郯城县"
    }, {
      "value": "沂水县",
      "code": "276400",
      "label": "沂水县"
    }, {
      "value": "苍山县",
      "code": "277700",
      "label": "苍山县"
    }, {
      "value": "费县",
      "code": "273400",
      "label": "费县"
    }, {
      "value": "平邑县",
      "code": "273300",
      "label": "平邑县"
    }, {
      "value": "莒南县",
      "code": "276600",
      "label": "莒南县"
    }, {
      "value": "蒙阴县",
      "code": "276200",
      "label": "蒙阴县"
    }, {
      "value": "临沭县",
      "code": "276700",
      "label": "临沭县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "临沂市"
  }, {
    "value": "德州市",
    "children": [{
      "value": "德城区",
      "code": "253001",
      "label": "德城区"
    }, {
      "value": "陵城区",
      "code": "253500",
      "label": "陵城区"
    }, {
      "value": "宁津县",
      "code": "253400",
      "label": "宁津县"
    }, {
      "value": "庆云县",
      "code": "253700",
      "label": "庆云县"
    }, {
      "value": "临邑县",
      "code": "251500",
      "label": "临邑县"
    }, {
      "value": "齐河县",
      "code": "251100",
      "label": "齐河县"
    }, {
      "value": "平原县",
      "code": "253100",
      "label": "平原县"
    }, {
      "value": "夏津县",
      "code": "253200",
      "label": "夏津县"
    }, {
      "value": "武城县",
      "code": "253300",
      "label": "武城县"
    }, {
      "value": "乐陵市",
      "code": "253600",
      "label": "乐陵市"
    }, {
      "value": "禹城市",
      "code": "251200",
      "label": "禹城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "德州市"
  }, {
    "value": "聊城市",
    "children": [{
      "value": "东昌府区",
      "code": "252001",
      "label": "东昌府区"
    }, {
      "value": "阳谷县",
      "code": "252300",
      "label": "阳谷县"
    }, {
      "value": "莘县",
      "code": "252400",
      "label": "莘县"
    }, {
      "value": "茌平县",
      "code": "252100",
      "label": "茌平县"
    }, {
      "value": "东阿县",
      "code": "252200",
      "label": "东阿县"
    }, {
      "value": "冠县",
      "code": "252500",
      "label": "冠县"
    }, {
      "value": "高唐县",
      "code": "252800",
      "label": "高唐县"
    }, {
      "value": "临清市",
      "code": "252099",
      "label": "临清市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "聊城市"
  }, {
    "value": "滨州市",
    "children": [{
      "value": "滨城区",
      "code": "256601",
      "label": "滨城区"
    }, {
      "value": "沾化区",
      "code": "256800",
      "label": "沾化区"
    }, {
      "value": "惠民县",
      "code": "251700",
      "label": "惠民县"
    }, {
      "value": "阳信县",
      "code": "251800",
      "label": "阳信县"
    }, {
      "value": "无棣县",
      "code": "251900",
      "label": "无棣县"
    }, {
      "value": "博兴县",
      "code": "256500",
      "label": "博兴县"
    }, {
      "value": "邹平县",
      "code": "256200",
      "label": "邹平县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "滨州市"
  }, {
    "value": "菏泽市",
    "children": [{
      "value": "牡丹区",
      "code": "274001",
      "label": "牡丹区"
    }, {
      "value": "曹县",
      "code": "274400",
      "label": "曹县"
    }, {
      "value": "单县",
      "code": "274300",
      "label": "单县"
    }, {
      "value": "成武县",
      "code": "274200",
      "label": "成武县"
    }, {
      "value": "巨野县",
      "code": "274900",
      "label": "巨野县"
    }, {
      "value": "郓城县",
      "code": "274700",
      "label": "郓城县"
    }, {
      "value": "鄄城县",
      "code": "274600",
      "label": "鄄城县"
    }, {
      "value": "定陶县",
      "code": "274100",
      "label": "定陶县"
    }, {
      "value": "东明县",
      "code": "274500",
      "label": "东明县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "菏泽市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "山东省",
  "label": "山东省"
}, {
  "children": [{
    "value": "郑州市",
    "children": [{
      "value": "中原区",
      "code": "450007",
      "label": "中原区"
    }, {
      "value": "二七区",
      "code": "450005",
      "label": "二七区"
    }, {
      "value": "管城回族区",
      "code": "450009",
      "label": "管城回族区"
    }, {
      "value": "金水区",
      "code": "450003",
      "label": "金水区"
    }, {
      "value": "上街区",
      "code": "450041",
      "label": "上街区"
    }, {
      "value": "惠济区",
      "code": "450049",
      "label": "惠济区"
    }, {
      "value": "中牟县",
      "code": "451450",
      "label": "中牟县"
    }, {
      "value": "巩义市",
      "code": "451200",
      "label": "巩义市"
    }, {
      "value": "荥阳市",
      "code": "450100",
      "label": "荥阳市"
    }, {
      "value": "新密市",
      "code": "452370",
      "label": "新密市"
    }, {
      "value": "新郑市",
      "code": "451100",
      "label": "新郑市"
    }, {
      "value": "登封市",
      "code": "452471",
      "label": "登封市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "郑州市"
  }, {
    "value": "开封市",
    "children": [{
      "value": "龙亭区",
      "code": "475005",
      "label": "龙亭区"
    }, {
      "value": "顺河回族区",
      "code": "475000",
      "label": "顺河回族区"
    }, {
      "value": "鼓楼区",
      "code": "475007",
      "label": "鼓楼区"
    }, {
      "value": "禹王台区",
      "code": "475002",
      "label": "禹王台区"
    }, {
      "value": "祥符区",
      "code": "475100",
      "label": "祥符区"
    }, {
      "value": "杞县",
      "code": "475200",
      "label": "杞县"
    }, {
      "value": "通许县",
      "code": "475470",
      "label": "通许县"
    }, {
      "value": "尉氏县",
      "code": "475500",
      "label": "尉氏县"
    }, {
      "value": "兰考县",
      "code": "475300",
      "label": "兰考县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "开封市"
  }, {
    "value": "洛阳市",
    "children": [{
      "value": "老城区",
      "code": "471000",
      "label": "老城区"
    }, {
      "value": "西工区",
      "code": "471041",
      "label": "西工区"
    }, {
      "value": "瀍河回族区",
      "code": "471002",
      "label": "瀍河回族区"
    }, {
      "value": "涧西区",
      "code": "471003",
      "label": "涧西区"
    }, {
      "value": "吉利区",
      "code": "471012",
      "label": "吉利区"
    }, {
      "value": "洛龙区",
      "code": "471013",
      "label": "洛龙区"
    }, {
      "value": "孟津县",
      "code": "471100",
      "label": "孟津县"
    }, {
      "value": "新安县",
      "code": "471800",
      "label": "新安县"
    }, {
      "value": "栾川县",
      "code": "471500",
      "label": "栾川县"
    }, {
      "value": "嵩县",
      "code": "471400",
      "label": "嵩县"
    }, {
      "value": "汝阳县",
      "code": "471200",
      "label": "汝阳县"
    }, {
      "value": "宜阳县",
      "code": "471600",
      "label": "宜阳县"
    }, {
      "value": "洛宁县",
      "code": "471700",
      "label": "洛宁县"
    }, {
      "value": "伊川县",
      "code": "471300",
      "label": "伊川县"
    }, {
      "value": "偃师市",
      "code": "471900",
      "label": "偃师市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "洛阳市"
  }, {
    "value": "平顶山市",
    "children": [{
      "value": "新华区",
      "code": "467036",
      "label": "新华区"
    }, {
      "value": "卫东区",
      "code": "467011",
      "label": "卫东区"
    }, {
      "value": "石龙区",
      "code": "467000",
      "label": "石龙区"
    }, {
      "value": "湛河区",
      "code": "467001",
      "label": "湛河区"
    }, {
      "value": "宝丰县",
      "code": "467400",
      "label": "宝丰县"
    }, {
      "value": "叶县",
      "code": "467200",
      "label": "叶县"
    }, {
      "value": "鲁山县",
      "code": "467300",
      "label": "鲁山县"
    }, {
      "value": "郏县",
      "code": "467100",
      "label": "郏县"
    }, {
      "value": "舞钢市",
      "code": "462500",
      "label": "舞钢市"
    }, {
      "value": "汝州市",
      "code": "467500",
      "label": "汝州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "平顶山市"
  }, {
    "value": "安阳市",
    "children": [{
      "value": "文峰区",
      "code": "455008",
      "label": "文峰区"
    }, {
      "value": "北关区",
      "code": "455000",
      "label": "北关区"
    }, {
      "value": "殷都区",
      "code": "455000",
      "label": "殷都区"
    }, {
      "value": "龙安区",
      "code": "455003",
      "label": "龙安区"
    }, {
      "value": "安阳县",
      "code": "455009",
      "label": "安阳县"
    }, {
      "value": "汤阴县",
      "code": "456150",
      "label": "汤阴县"
    }, {
      "value": "滑县",
      "code": "456400",
      "label": "滑县"
    }, {
      "value": "内黄县",
      "code": "456300",
      "label": "内黄县"
    }, {
      "value": "林州市",
      "code": "456500",
      "label": "林州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "安阳市"
  }, {
    "value": "鹤壁市",
    "children": [{
      "value": "鹤山区",
      "code": "458010",
      "label": "鹤山区"
    }, {
      "value": "山城区",
      "code": "458007",
      "label": "山城区"
    }, {
      "value": "淇滨区",
      "code": "458030",
      "label": "淇滨区"
    }, {
      "value": "浚县",
      "code": "456250",
      "label": "浚县"
    }, {
      "value": "淇县",
      "code": "456750",
      "label": "淇县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "鹤壁市"
  }, {
    "value": "新乡市",
    "children": [{
      "value": "红旗区",
      "code": "453006",
      "label": "红旗区"
    }, {
      "value": "卫滨区",
      "code": "453001",
      "label": "卫滨区"
    }, {
      "value": "凤泉区",
      "code": "453011",
      "label": "凤泉区"
    }, {
      "value": "牧野区",
      "code": "453001",
      "label": "牧野区"
    }, {
      "value": "新乡县",
      "code": "453014",
      "label": "新乡县"
    }, {
      "value": "获嘉县",
      "code": "453800",
      "label": "获嘉县"
    }, {
      "value": "原阳县",
      "code": "453500",
      "label": "原阳县"
    }, {
      "value": "延津县",
      "code": "453200",
      "label": "延津县"
    }, {
      "value": "封丘县",
      "code": "453300",
      "label": "封丘县"
    }, {
      "value": "长垣县",
      "code": "453400",
      "label": "长垣县"
    }, {
      "value": "卫辉市",
      "code": "453100",
      "label": "卫辉市"
    }, {
      "value": "辉县市",
      "code": "453600",
      "label": "辉县市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "新乡市"
  }, {
    "value": "焦作市",
    "children": [{
      "value": "解放区",
      "code": "454099",
      "label": "解放区"
    }, {
      "value": "中站区",
      "code": "454006",
      "label": "中站区"
    }, {
      "value": "马村区",
      "code": "454005",
      "label": "马村区"
    }, {
      "value": "山阳区",
      "code": "454171",
      "label": "山阳区"
    }, {
      "value": "修武县",
      "code": "454350",
      "label": "修武县"
    }, {
      "value": "博爱县",
      "code": "454450",
      "label": "博爱县"
    }, {
      "value": "武陟县",
      "code": "454950",
      "label": "武陟县"
    }, {
      "value": "温县",
      "code": "454850",
      "label": "温县"
    }, {
      "value": "沁阳市",
      "code": "454550",
      "label": "沁阳市"
    }, {
      "value": "孟州市",
      "code": "454750",
      "label": "孟州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "焦作市"
  }, {
    "value": "濮阳市",
    "children": [{
      "value": "华龙区",
      "code": "457001",
      "label": "华龙区"
    }, {
      "value": "清丰县",
      "code": "457300",
      "label": "清丰县"
    }, {
      "value": "南乐县",
      "code": "457400",
      "label": "南乐县"
    }, {
      "value": "范县",
      "code": "457500",
      "label": "范县"
    }, {
      "value": "台前县",
      "code": "457600",
      "label": "台前县"
    }, {
      "value": "濮阳县",
      "code": "457100",
      "label": "濮阳县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "濮阳市"
  }, {
    "value": "许昌市",
    "children": [{
      "value": "魏都区",
      "code": "461001",
      "label": "魏都区"
    }, {
      "value": "许昌县",
      "code": "461100",
      "label": "许昌县"
    }, {
      "value": "鄢陵县",
      "code": "461200",
      "label": "鄢陵县"
    }, {
      "value": "襄城县",
      "code": "452670",
      "label": "襄城县"
    }, {
      "value": "禹州市",
      "code": "461671",
      "label": "禹州市"
    }, {
      "value": "长葛市",
      "code": "461500",
      "label": "长葛市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "许昌市"
  }, {
    "value": "漯河市",
    "children": [{
      "value": "源汇区",
      "code": "462002",
      "label": "源汇区"
    }, {
      "value": "郾城区",
      "code": "462007",
      "label": "郾城区"
    }, {
      "value": "召陵区",
      "code": "462003",
      "label": "召陵区"
    }, {
      "value": "舞阳县",
      "code": "462400",
      "label": "舞阳县"
    }, {
      "value": "临颍县",
      "code": "462600",
      "label": "临颍县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "漯河市"
  }, {
    "value": "三门峡市",
    "children": [{
      "value": "湖滨区",
      "code": "472001",
      "label": "湖滨区"
    }, {
      "value": "陕州区",
      "code": "472100",
      "label": "陕州区"
    }, {
      "value": "渑池县",
      "code": "472400",
      "label": "渑池县"
    }, {
      "value": "卢氏县",
      "code": "472200",
      "label": "卢氏县"
    }, {
      "value": "义马市",
      "code": "472300",
      "label": "义马市"
    }, {
      "value": "灵宝市",
      "code": "472500",
      "label": "灵宝市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "三门峡市"
  }, {
    "value": "南阳市",
    "children": [{
      "value": "宛城区",
      "code": "473004",
      "label": "宛城区"
    }, {
      "value": "卧龙区",
      "code": "473001",
      "label": "卧龙区"
    }, {
      "value": "南召县",
      "code": "474650",
      "label": "南召县"
    }, {
      "value": "方城县",
      "code": "473200",
      "label": "方城县"
    }, {
      "value": "西峡县",
      "code": "474550",
      "label": "西峡县"
    }, {
      "value": "镇平县",
      "code": "474250",
      "label": "镇平县"
    }, {
      "value": "内乡县",
      "code": "474350",
      "label": "内乡县"
    }, {
      "value": "淅川县",
      "code": "474405",
      "label": "淅川县"
    }, {
      "value": "社旗县",
      "code": "473300",
      "label": "社旗县"
    }, {
      "value": "唐河县",
      "code": "473400",
      "label": "唐河县"
    }, {
      "value": "新野县",
      "code": "473500",
      "label": "新野县"
    }, {
      "value": "桐柏县",
      "code": "474705",
      "label": "桐柏县"
    }, {
      "value": "邓州市",
      "code": "474150",
      "label": "邓州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "南阳市"
  }, {
    "value": "商丘市",
    "children": [{
      "value": "梁园区",
      "code": "476001",
      "label": "梁园区"
    }, {
      "value": "睢阳区",
      "code": "476011",
      "label": "睢阳区"
    }, {
      "value": "民权县",
      "code": "476800",
      "label": "民权县"
    }, {
      "value": "睢县",
      "code": "476900",
      "label": "睢县"
    }, {
      "value": "宁陵县",
      "code": "476700",
      "label": "宁陵县"
    }, {
      "value": "柘城县",
      "code": "476200",
      "label": "柘城县"
    }, {
      "value": "虞城县",
      "code": "476300",
      "label": "虞城县"
    }, {
      "value": "夏邑县",
      "code": "476400",
      "label": "夏邑县"
    }, {
      "value": "永城市",
      "code": "476600",
      "label": "永城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "商丘市"
  }, {
    "value": "信阳市",
    "children": [{
      "value": "浉河区",
      "code": "464001",
      "label": "浉河区"
    }, {
      "value": "平桥区",
      "code": "464006",
      "label": "平桥区"
    }, {
      "value": "罗山县",
      "code": "464200",
      "label": "罗山县"
    }, {
      "value": "光山县",
      "code": "465421",
      "label": "光山县"
    }, {
      "value": "新县",
      "code": "465511",
      "label": "新县"
    }, {
      "value": "商城县",
      "code": "465311",
      "label": "商城县"
    }, {
      "value": "固始县",
      "code": "465200",
      "label": "固始县"
    }, {
      "value": "潢川县",
      "code": "465111",
      "label": "潢川县"
    }, {
      "value": "淮滨县",
      "code": "464400",
      "label": "淮滨县"
    }, {
      "value": "息县",
      "code": "464300",
      "label": "息县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "信阳市"
  }, {
    "value": "周口市",
    "children": [{
      "value": "川汇区",
      "code": "466001",
      "label": "川汇区"
    }, {
      "value": "扶沟县",
      "code": "461300",
      "label": "扶沟县"
    }, {
      "value": "西华县",
      "code": "466600",
      "label": "西华县"
    }, {
      "value": "商水县",
      "code": "466100",
      "label": "商水县"
    }, {
      "value": "沈丘县",
      "code": "466300",
      "label": "沈丘县"
    }, {
      "value": "郸城县",
      "code": "477161",
      "label": "郸城县"
    }, {
      "value": "淮阳县",
      "code": "466700",
      "label": "淮阳县"
    }, {
      "value": "太康县",
      "code": "461411",
      "label": "太康县"
    }, {
      "value": "鹿邑县",
      "code": "477200",
      "label": "鹿邑县"
    }, {
      "value": "项城市",
      "code": "466200",
      "label": "项城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "周口市"
  }, {
    "value": "驻马店市",
    "children": [{
      "value": "驿城区",
      "code": "463001",
      "label": "驿城区"
    }, {
      "value": "西平县",
      "code": "463900",
      "label": "西平县"
    }, {
      "value": "上蔡县",
      "code": "463800",
      "label": "上蔡县"
    }, {
      "value": "平舆县",
      "code": "463400",
      "label": "平舆县"
    }, {
      "value": "正阳县",
      "code": "463600",
      "label": "正阳县"
    }, {
      "value": "确山县",
      "code": "463200",
      "label": "确山县"
    }, {
      "value": "泌阳县",
      "code": "463700",
      "label": "泌阳县"
    }, {
      "value": "汝南县",
      "code": "463300",
      "label": "汝南县"
    }, {
      "value": "遂平县",
      "code": "463100",
      "label": "遂平县"
    }, {
      "value": "新蔡县",
      "code": "463500",
      "label": "新蔡县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "驻马店市"
  }, {
    "value": "省直辖县级行政区划",
    "children": [{
      "value": "济源市",
      "code": "454650",
      "label": "济源市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "省直辖县级行政区划"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "河南省",
  "label": "河南省"
}, {
  "children": [{
    "value": "武汉市",
    "children": [{
      "value": "江岸区",
      "code": "430010",
      "label": "江岸区"
    }, {
      "value": "江汉区",
      "code": "430013",
      "label": "江汉区"
    }, {
      "value": "硚口区",
      "code": "430030",
      "label": "硚口区"
    }, {
      "value": "汉阳区",
      "code": "430050",
      "label": "汉阳区"
    }, {
      "value": "武昌区",
      "code": "430060",
      "label": "武昌区"
    }, {
      "value": "青山区",
      "code": "430080",
      "label": "青山区"
    }, {
      "value": "洪山区",
      "code": "430070",
      "label": "洪山区"
    }, {
      "value": "东西湖区",
      "code": "430040",
      "label": "东西湖区"
    }, {
      "value": "汉南区",
      "code": "430090",
      "label": "汉南区"
    }, {
      "value": "蔡甸区",
      "code": "430058",
      "label": "蔡甸区"
    }, {
      "value": "江夏区",
      "code": "430200",
      "label": "江夏区"
    }, {
      "value": "黄陂区",
      "code": "430301",
      "label": "黄陂区"
    }, {
      "value": "新洲区",
      "code": "430402",
      "label": "新洲区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "武汉市"
  }, {
    "value": "黄石市",
    "children": [{
      "value": "黄石港区",
      "code": "435000",
      "label": "黄石港区"
    }, {
      "value": "西塞山区",
      "code": "435001",
      "label": "西塞山区"
    }, {
      "value": "下陆区",
      "code": "435004",
      "label": "下陆区"
    }, {
      "value": "铁山区",
      "code": "435006",
      "label": "铁山区"
    }, {
      "value": "阳新县",
      "code": "435200",
      "label": "阳新县"
    }, {
      "value": "大冶市",
      "code": "435100",
      "label": "大冶市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "黄石市"
  }, {
    "value": "十堰市",
    "children": [{
      "value": "茅箭区",
      "code": "442006",
      "label": "茅箭区"
    }, {
      "value": "张湾区",
      "code": "442002",
      "label": "张湾区"
    }, {
      "value": "郧阳区",
      "code": "442500",
      "label": "郧阳区"
    }, {
      "value": "郧西县",
      "code": "442600",
      "label": "郧西县"
    }, {
      "value": "竹山县",
      "code": "442200",
      "label": "竹山县"
    }, {
      "value": "竹溪县",
      "code": "442300",
      "label": "竹溪县"
    }, {
      "value": "房县",
      "code": "442100",
      "label": "房县"
    }, {
      "value": "丹江口市",
      "code": "442700",
      "label": "丹江口市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "十堰市"
  }, {
    "value": "宜昌市",
    "children": [{
      "value": "西陵区",
      "code": "443002",
      "label": "西陵区"
    }, {
      "value": "伍家岗区",
      "code": "443001",
      "label": "伍家岗区"
    }, {
      "value": "点军区",
      "code": "443004",
      "label": "点军区"
    }, {
      "value": "猇亭区",
      "code": "443007",
      "label": "猇亭区"
    }, {
      "value": "夷陵区",
      "code": "443100",
      "label": "夷陵区"
    }, {
      "value": "远安县",
      "code": "444200",
      "label": "远安县"
    }, {
      "value": "兴山县",
      "code": "443700",
      "label": "兴山县"
    }, {
      "value": "秭归县",
      "code": "443600",
      "label": "秭归县"
    }, {
      "value": "长阳土家族自治县",
      "code": "443500",
      "label": "长阳土家族自治县"
    }, {
      "value": "五峰土家族自治县",
      "code": "443400",
      "label": "五峰土家族自治县"
    }, {
      "value": "宜都市",
      "code": "443301",
      "label": "宜都市"
    }, {
      "value": "当阳市",
      "code": "444100",
      "label": "当阳市"
    }, {
      "value": "枝江市",
      "code": "443200",
      "label": "枝江市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "宜昌市"
  }, {
    "value": "襄阳市",
    "children": [{
      "value": "襄城区",
      "code": "441021",
      "label": "襄城区"
    }, {
      "value": "樊城区",
      "code": "441001",
      "label": "樊城区"
    }, {
      "value": "襄州区",
      "code": "441104",
      "label": "襄州区"
    }, {
      "value": "南漳县",
      "code": "441500",
      "label": "南漳县"
    }, {
      "value": "谷城县",
      "code": "441700",
      "label": "谷城县"
    }, {
      "value": "保康县",
      "code": "441600",
      "label": "保康县"
    }, {
      "value": "老河口市",
      "code": "441800",
      "label": "老河口市"
    }, {
      "value": "枣阳市",
      "code": "441200",
      "label": "枣阳市"
    }, {
      "value": "宜城市",
      "code": "441400",
      "label": "宜城市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "襄阳市"
  }, {
    "value": "鄂州市",
    "children": [{
      "value": "梁子湖区",
      "code": "436045",
      "label": "梁子湖区"
    }, {
      "value": "华容区",
      "code": "436030",
      "label": "华容区"
    }, {
      "value": "鄂城区",
      "code": "436008",
      "label": "鄂城区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "鄂州市"
  }, {
    "value": "荆门市",
    "children": [{
      "value": "东宝区",
      "code": "448121",
      "label": "东宝区"
    }, {
      "value": "掇刀区",
      "code": "448124",
      "label": "掇刀区"
    }, {
      "value": "京山县",
      "code": "431800",
      "label": "京山县"
    }, {
      "value": "沙洋县",
      "code": "448200",
      "label": "沙洋县"
    }, {
      "value": "钟祥市",
      "code": "431900",
      "label": "钟祥市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "荆门市"
  }, {
    "value": "孝感市",
    "children": [{
      "value": "孝南区",
      "code": "432001",
      "label": "孝南区"
    }, {
      "value": "孝昌县",
      "code": "432900",
      "label": "孝昌县"
    }, {
      "value": "大悟县",
      "code": "432800",
      "label": "大悟县"
    }, {
      "value": "云梦县",
      "code": "432500",
      "label": "云梦县"
    }, {
      "value": "应城市",
      "code": "432400",
      "label": "应城市"
    }, {
      "value": "安陆市",
      "code": "432600",
      "label": "安陆市"
    }, {
      "value": "汉川市",
      "code": "431602",
      "label": "汉川市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "孝感市"
  }, {
    "value": "荆州市",
    "children": [{
      "value": "沙市区",
      "code": "434001",
      "label": "沙市区"
    }, {
      "value": "荆州区",
      "code": "434020",
      "label": "荆州区"
    }, {
      "value": "公安县",
      "code": "434300",
      "label": "公安县"
    }, {
      "value": "监利县",
      "code": "433300",
      "label": "监利县"
    }, {
      "value": "江陵县",
      "code": "434100",
      "label": "江陵县"
    }, {
      "value": "石首市",
      "code": "434400",
      "label": "石首市"
    }, {
      "value": "洪湖市",
      "code": "433200",
      "label": "洪湖市"
    }, {
      "value": "松滋市",
      "code": "434200",
      "label": "松滋市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "荆州市"
  }, {
    "value": "黄冈市",
    "children": [{
      "value": "黄州区",
      "code": "438002",
      "label": "黄州区"
    }, {
      "value": "团风县",
      "code": "438802",
      "label": "团风县"
    }, {
      "value": "红安县",
      "code": "438400",
      "label": "红安县"
    }, {
      "value": "罗田县",
      "code": "438600",
      "label": "罗田县"
    }, {
      "value": "英山县",
      "code": "438700",
      "label": "英山县"
    }, {
      "value": "浠水县",
      "code": "438200",
      "label": "浠水县"
    }, {
      "value": "蕲春县",
      "code": "435300",
      "label": "蕲春县"
    }, {
      "value": "黄梅县",
      "code": "435500",
      "label": "黄梅县"
    }, {
      "value": "麻城市",
      "code": "438300",
      "label": "麻城市"
    }, {
      "value": "武穴市",
      "code": "435400",
      "label": "武穴市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "黄冈市"
  }, {
    "value": "咸宁市",
    "children": [{
      "value": "咸安区",
      "code": "437011",
      "label": "咸安区"
    }, {
      "value": "嘉鱼县",
      "code": "437200",
      "label": "嘉鱼县"
    }, {
      "value": "通城县",
      "code": "437400",
      "label": "通城县"
    }, {
      "value": "崇阳县",
      "code": "437500",
      "label": "崇阳县"
    }, {
      "value": "通山县",
      "code": "437600",
      "label": "通山县"
    }, {
      "value": "赤壁市",
      "code": "437300",
      "label": "赤壁市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "咸宁市"
  }, {
    "value": "随州市",
    "children": [{
      "value": "曾都区",
      "code": "441301",
      "label": "曾都区"
    }, {
      "value": "随县",
      "code": "441303",
      "label": "随县"
    }, {
      "value": "广水市",
      "code": "432700",
      "label": "广水市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "随州市"
  }, {
    "value": "恩施土家族苗族自治州",
    "children": [{
      "value": "恩施市",
      "code": "445002",
      "label": "恩施市"
    }, {
      "value": "利川市",
      "code": "445400",
      "label": "利川市"
    }, {
      "value": "建始县",
      "code": "445300",
      "label": "建始县"
    }, {
      "value": "巴东县",
      "code": "444300",
      "label": "巴东县"
    }, {
      "value": "宣恩县",
      "code": "445500",
      "label": "宣恩县"
    }, {
      "value": "咸丰县",
      "code": "445600",
      "label": "咸丰县"
    }, {
      "value": "来凤县",
      "code": "445700",
      "label": "来凤县"
    }, {
      "value": "鹤峰县",
      "code": "445800",
      "label": "鹤峰县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "恩施土家族苗族自治州"
  }, {
    "value": "省直辖县级行政区划",
    "children": [{
      "value": "仙桃市",
      "code": "433000",
      "label": "仙桃市"
    }, {
      "value": "潜江市",
      "code": "433100",
      "label": "潜江市"
    }, {
      "value": "天门市",
      "code": "431700",
      "label": "天门市"
    }, {
      "value": "神农架林区",
      "code": "442400",
      "label": "神农架林区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "省直辖县级行政区划"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "湖北省",
  "label": "湖北省"
}, {
  "children": [{
    "value": "长沙市",
    "children": [{
      "value": "芙蓉区",
      "code": "410125",
      "label": "芙蓉区"
    }, {
      "value": "天心区",
      "code": "410111",
      "label": "天心区"
    }, {
      "value": "岳麓区",
      "code": "410006",
      "label": "岳麓区"
    }, {
      "value": "开福区",
      "code": "410153",
      "label": "开福区"
    }, {
      "value": "雨花区",
      "code": "410007",
      "label": "雨花区"
    }, {
      "value": "望城区",
      "code": "410200",
      "label": "望城区"
    }, {
      "value": "长沙县",
      "code": "410100",
      "label": "长沙县"
    }, {
      "value": "宁乡县",
      "code": "410600",
      "label": "宁乡县"
    }, {
      "value": "浏阳市",
      "code": "410300",
      "label": "浏阳市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "长沙市"
  }, {
    "value": "株洲市",
    "children": [{
      "value": "荷塘区",
      "code": "412003",
      "label": "荷塘区"
    }, {
      "value": "芦淞区",
      "code": "412002",
      "label": "芦淞区"
    }, {
      "value": "石峰区",
      "code": "412001",
      "label": "石峰区"
    }, {
      "value": "天元区",
      "code": "412007",
      "label": "天元区"
    }, {
      "value": "株洲县",
      "code": "412101",
      "label": "株洲县"
    }, {
      "value": "攸县",
      "code": "412300",
      "label": "攸县"
    }, {
      "value": "茶陵县",
      "code": "412400",
      "label": "茶陵县"
    }, {
      "value": "炎陵县",
      "code": "412500",
      "label": "炎陵县"
    }, {
      "value": "醴陵市",
      "code": "412200",
      "label": "醴陵市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "株洲市"
  }, {
    "value": "湘潭市",
    "children": [{
      "value": "雨湖区",
      "code": "411105",
      "label": "雨湖区"
    }, {
      "value": "岳塘区",
      "code": "411101",
      "label": "岳塘区"
    }, {
      "value": "湘潭县",
      "code": "411200",
      "label": "湘潭县"
    }, {
      "value": "湘乡市",
      "code": "411400",
      "label": "湘乡市"
    }, {
      "value": "韶山市",
      "code": "411300",
      "label": "韶山市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "湘潭市"
  }, {
    "value": "衡阳市",
    "children": [{
      "value": "珠晖区",
      "code": "421002",
      "label": "珠晖区"
    }, {
      "value": "雁峰区",
      "code": "421007",
      "label": "雁峰区"
    }, {
      "value": "石鼓区",
      "code": "421001",
      "label": "石鼓区"
    }, {
      "value": "蒸湘区",
      "code": "421000",
      "label": "蒸湘区"
    }, {
      "value": "南岳区",
      "code": "421999",
      "label": "南岳区"
    }, {
      "value": "衡阳县",
      "code": "421200",
      "label": "衡阳县"
    }, {
      "value": "衡南县",
      "code": "421100",
      "label": "衡南县"
    }, {
      "value": "衡山县",
      "code": "421300",
      "label": "衡山县"
    }, {
      "value": "衡东县",
      "code": "421400",
      "label": "衡东县"
    }, {
      "value": "祁东县",
      "code": "421600",
      "label": "祁东县"
    }, {
      "value": "耒阳市",
      "code": "421800",
      "label": "耒阳市"
    }, {
      "value": "常宁市",
      "code": "421500",
      "label": "常宁市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "衡阳市"
  }, {
    "value": "邵阳市",
    "children": [{
      "value": "双清区",
      "code": "422001",
      "label": "双清区"
    }, {
      "value": "大祥区",
      "code": "422004",
      "label": "大祥区"
    }, {
      "value": "北塔区",
      "code": "422006",
      "label": "北塔区"
    }, {
      "value": "邵东县",
      "code": "422800",
      "label": "邵东县"
    }, {
      "value": "新邵县",
      "code": "422900",
      "label": "新邵县"
    }, {
      "value": "邵阳县",
      "code": "422100",
      "label": "邵阳县"
    }, {
      "value": "隆回县",
      "code": "422200",
      "label": "隆回县"
    }, {
      "value": "洞口县",
      "code": "422300",
      "label": "洞口县"
    }, {
      "value": "绥宁县",
      "code": "422600",
      "label": "绥宁县"
    }, {
      "value": "新宁县",
      "code": "422700",
      "label": "新宁县"
    }, {
      "value": "城步苗族自治县",
      "code": "422500",
      "label": "城步苗族自治县"
    }, {
      "value": "武冈市",
      "code": "422400",
      "label": "武冈市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "邵阳市"
  }, {
    "value": "岳阳市",
    "children": [{
      "value": "岳阳楼区",
      "code": "414015",
      "label": "岳阳楼区"
    }, {
      "value": "云溪区",
      "code": "414009",
      "label": "云溪区"
    }, {
      "value": "君山区",
      "code": "414005",
      "label": "君山区"
    }, {
      "value": "岳阳县",
      "code": "414100",
      "label": "岳阳县"
    }, {
      "value": "华容县",
      "code": "414200",
      "label": "华容县"
    }, {
      "value": "湘阴县",
      "code": "410500",
      "label": "湘阴县"
    }, {
      "value": "平江县",
      "code": "410400",
      "label": "平江县"
    }, {
      "value": "汨罗市",
      "code": "414400",
      "label": "汨罗市"
    }, {
      "value": "临湘市",
      "code": "414300",
      "label": "临湘市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "岳阳市"
  }, {
    "value": "常德市",
    "children": [{
      "value": "武陵区",
      "code": "415001",
      "label": "武陵区"
    }, {
      "value": "鼎城区",
      "code": "415100",
      "label": "鼎城区"
    }, {
      "value": "安乡县",
      "code": "415600",
      "label": "安乡县"
    }, {
      "value": "汉寿县",
      "code": "415900",
      "label": "汉寿县"
    }, {
      "value": "澧县",
      "code": "415500",
      "label": "澧县"
    }, {
      "value": "临澧县",
      "code": "415200",
      "label": "临澧县"
    }, {
      "value": "桃源���",
      "code": "415700",
      "label": "桃源���"
    }, {
      "value": "石门县",
      "code": "415300",
      "label": "石门县"
    }, {
      "value": "津市市",
      "code": "415400",
      "label": "津市市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "常德市"
  }, {
    "value": "张家界市",
    "children": [{
      "value": "永定区",
      "code": "427302",
      "label": "永定区"
    }, {
      "value": "武陵源区",
      "code": "427400",
      "label": "武陵源区"
    }, {
      "value": "慈利县",
      "code": "427200",
      "label": "慈利县"
    }, {
      "value": "桑植县",
      "code": "427100",
      "label": "桑植县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "张家界市"
  }, {
    "value": "益阳市",
    "children": [{
      "value": "资阳区",
      "code": "413048",
      "label": "资阳区"
    }, {
      "value": "赫山区",
      "code": "413041",
      "label": "赫山区"
    }, {
      "value": "南县",
      "code": "413119",
      "label": "南县"
    }, {
      "value": "桃江县",
      "code": "413400",
      "label": "桃江县"
    }, {
      "value": "安化县",
      "code": "413500",
      "label": "安化县"
    }, {
      "value": "沅江市",
      "code": "413100",
      "label": "沅江市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "益阳市"
  }, {
    "value": "郴州市",
    "children": [{
      "value": "北湖区",
      "code": "423003",
      "label": "北湖区"
    }, {
      "value": "苏仙区",
      "code": "423015",
      "label": "苏仙区"
    }, {
      "value": "桂阳县",
      "code": "424400",
      "label": "桂阳县"
    }, {
      "value": "宜章县",
      "code": "424200",
      "label": "宜章县"
    }, {
      "value": "永兴县",
      "code": "423300",
      "label": "永兴县"
    }, {
      "value": "嘉禾县",
      "code": "424500",
      "label": "嘉禾县"
    }, {
      "value": "临武县",
      "code": "424300",
      "label": "临武县"
    }, {
      "value": "汝城县",
      "code": "424100",
      "label": "汝城县"
    }, {
      "value": "桂东县",
      "code": "423500",
      "label": "桂东县"
    }, {
      "value": "安仁县",
      "code": "423600",
      "label": "安仁县"
    }, {
      "value": "资兴市",
      "code": "423400",
      "label": "资兴市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "郴州市"
  }, {
    "value": "永州市",
    "children": [{
      "value": "零陵区",
      "code": "425101",
      "label": "零陵区"
    }, {
      "value": "冷水滩区",
      "code": "425001",
      "label": "冷水滩区"
    }, {
      "value": "祁阳县",
      "code": "426100",
      "label": "祁阳县"
    }, {
      "value": "东安县",
      "code": "425900",
      "label": "东安县"
    }, {
      "value": "双牌县",
      "code": "425200",
      "label": "双牌县"
    }, {
      "value": "道县",
      "code": "425300",
      "label": "道县"
    }, {
      "value": "江永县",
      "code": "425400",
      "label": "江永县"
    }, {
      "value": "宁远县",
      "code": "425600",
      "label": "宁远县"
    }, {
      "value": "蓝山县",
      "code": "425800",
      "label": "蓝山县"
    }, {
      "value": "新田县",
      "code": "425700",
      "label": "新田县"
    }, {
      "value": "江华瑶族自治县",
      "code": "425500",
      "label": "江华瑶族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "永州市"
  }, {
    "value": "怀化市",
    "children": [{
      "value": "鹤城区",
      "code": "418009",
      "label": "鹤城区"
    }, {
      "value": "中方县",
      "code": "418001",
      "label": "中方县"
    }, {
      "value": "沅陵县",
      "code": "419600",
      "label": "沅陵县"
    }, {
      "value": "辰溪县",
      "code": "419500",
      "label": "辰溪县"
    }, {
      "value": "溆浦县",
      "code": "419300",
      "label": "溆浦县"
    }, {
      "value": "会同县",
      "code": "418300",
      "label": "会同县"
    }, {
      "value": "麻阳苗族自治县",
      "code": "419400",
      "label": "麻阳苗族自治县"
    }, {
      "value": "新晃侗族自治县",
      "code": "419200",
      "label": "新晃侗族自治县"
    }, {
      "value": "芷江侗族自治县",
      "code": "419100",
      "label": "芷江侗族自治县"
    }, {
      "value": "靖州苗族侗族自治县",
      "code": "418400",
      "label": "靖州苗族侗族自治县"
    }, {
      "value": "通道侗族自治县",
      "code": "418500",
      "label": "通道侗族自治县"
    }, {
      "value": "洪江市",
      "code": "418101",
      "label": "洪江市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "怀化市"
  }, {
    "value": "娄底市",
    "children": [{
      "value": "娄星区",
      "code": "417001",
      "label": "娄星区"
    }, {
      "value": "双峰县",
      "code": "417700",
      "label": "双峰县"
    }, {
      "value": "新化县",
      "code": "417600",
      "label": "新化县"
    }, {
      "value": "冷水江市",
      "code": "417500",
      "label": "冷水江市"
    }, {
      "value": "涟源市",
      "code": "417100",
      "label": "涟源市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "娄底市"
  }, {
    "value": "湘西土家族苗族自治州",
    "children": [{
      "value": "吉首市",
      "code": "416007",
      "label": "吉首市"
    }, {
      "value": "泸溪县",
      "code": "416100",
      "label": "泸溪县"
    }, {
      "value": "凤凰县",
      "code": "416200",
      "label": "凤凰县"
    }, {
      "value": "花垣县",
      "code": "416400",
      "label": "花垣县"
    }, {
      "value": "保靖县",
      "code": "416500",
      "label": "保靖县"
    }, {
      "value": "古丈县",
      "code": "416300",
      "label": "古丈县"
    }, {
      "value": "永顺县",
      "code": "416700",
      "label": "永顺县"
    }, {
      "value": "龙山县",
      "code": "416800",
      "label": "龙山县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "湘西土家族苗族自治州"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "湖南省",
  "label": "湖南省"
}, {
  "children": [{
    "value": "广州市",
    "children": [{
      "value": "荔湾区",
      "code": "510123",
      "label": "荔湾区"
    }, {
      "value": "越秀区",
      "code": "510003",
      "label": "越秀区"
    }, {
      "value": "海珠区",
      "code": "510220",
      "label": "海珠区"
    }, {
      "value": "天河区",
      "code": "510507",
      "label": "天河区"
    }, {
      "value": "白云区",
      "code": "510168",
      "label": "白云区"
    }, {
      "value": "黄埔区",
      "code": "510336",
      "label": "黄埔区"
    }, {
      "value": "番禺区",
      "code": "510434",
      "label": "番禺区"
    }, {
      "value": "花都区",
      "code": "510800",
      "label": "花都区"
    }, {
      "value": "南沙区",
      "code": "511455",
      "label": "南沙区"
    }, {
      "value": "从化区",
      "code": "510900",
      "label": "从化区"
    }, {
      "value": "增城区",
      "code": "511300",
      "label": "增城区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "广州市"
  }, {
    "value": "韶关市",
    "children": [{
      "value": "武江区",
      "code": "512026",
      "label": "武江区"
    }, {
      "value": "浈江区",
      "code": "512005",
      "label": "浈江区"
    }, {
      "value": "曲江区",
      "code": "512100",
      "label": "曲江区"
    }, {
      "value": "始兴县",
      "code": "512500",
      "label": "始兴县"
    }, {
      "value": "仁化县",
      "code": "512300",
      "label": "仁化县"
    }, {
      "value": "翁源县",
      "code": "512621",
      "label": "翁源县"
    }, {
      "value": "乳源瑶族自治县",
      "code": "512721",
      "label": "乳源瑶族自治县"
    }, {
      "value": "新丰县",
      "code": "511100",
      "label": "新丰县"
    }, {
      "value": "乐昌市",
      "code": "512200",
      "label": "乐昌市"
    }, {
      "value": "南雄市",
      "code": "512400",
      "label": "南雄市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "韶关市"
  }, {
    "value": "深圳市",
    "children": [{
      "value": "罗湖区",
      "code": "518001",
      "label": "罗湖区"
    }, {
      "value": "福田区",
      "code": "518013",
      "label": "福田区"
    }, {
      "value": "南山区",
      "code": "518051",
      "label": "南山区"
    }, {
      "value": "宝安区",
      "code": "518102",
      "label": "宝安区"
    }, {
      "value": "龙岗区",
      "code": "518112",
      "label": "龙岗区"
    }, {
      "value": "盐田区",
      "code": "518081",
      "label": "盐田区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "深圳市"
  }, {
    "value": "珠海市",
    "children": [{
      "value": "香洲区",
      "code": "519001",
      "label": "香洲区"
    }, {
      "value": "斗门区",
      "code": "519100",
      "label": "斗门区"
    }, {
      "value": "金湾区",
      "code": "519040",
      "label": "金湾区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "珠海市"
  }, {
    "value": "汕头市",
    "children": [{
      "value": "龙湖区",
      "code": "515022",
      "label": "龙湖区"
    }, {
      "value": "金平区",
      "code": "515011",
      "label": "金平区"
    }, {
      "value": "濠江区",
      "code": "515071",
      "label": "濠江区"
    }, {
      "value": "潮阳区",
      "code": "515132",
      "label": "潮阳区"
    }, {
      "value": "潮南区",
      "code": "515133",
      "label": "潮南区"
    }, {
      "value": "澄海区",
      "code": "515800",
      "label": "澄海区"
    }, {
      "value": "南澳县",
      "code": "515900",
      "label": "南澳县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "汕头市"
  }, {
    "value": "佛山市",
    "children": [{
      "value": "禅城区",
      "code": "528004",
      "label": "禅城区"
    }, {
      "value": "南海区",
      "code": "528200",
      "label": "南海区"
    }, {
      "value": "顺德区",
      "code": "528305",
      "label": "顺德区"
    }, {
      "value": "三水区",
      "code": "528100",
      "label": "三水区"
    }, {
      "value": "高明区",
      "code": "528500",
      "label": "高明区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "佛山市"
  }, {
    "value": "江门市",
    "children": [{
      "value": "蓬江区",
      "code": "529020",
      "label": "蓬江区"
    }, {
      "value": "江海区",
      "code": "529040",
      "label": "江海区"
    }, {
      "value": "新会区",
      "code": "529100",
      "label": "新会区"
    }, {
      "value": "台山市",
      "code": "529200",
      "label": "台山市"
    }, {
      "value": "开平市",
      "code": "529300",
      "label": "开平市"
    }, {
      "value": "鹤山市",
      "code": "529700",
      "label": "鹤山市"
    }, {
      "value": "恩平市",
      "code": "529400",
      "label": "恩平市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "江门市"
  }, {
    "value": "湛江市",
    "children": [{
      "value": "赤坎区",
      "code": "524022",
      "label": "赤坎区"
    }, {
      "value": "霞山区",
      "code": "524001",
      "label": "霞山区"
    }, {
      "value": "坡头区",
      "code": "524051",
      "label": "坡头区"
    }, {
      "value": "麻章区",
      "code": "524084",
      "label": "麻章区"
    }, {
      "value": "遂溪县",
      "code": "524096",
      "label": "遂溪县"
    }, {
      "value": "徐闻县",
      "code": "524100",
      "label": "徐闻县"
    }, {
      "value": "廉江市",
      "code": "524400",
      "label": "廉江市"
    }, {
      "value": "雷州市",
      "code": "524200",
      "label": "雷州市"
    }, {
      "value": "吴川市",
      "code": "524500",
      "label": "吴川市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "湛江市"
  }, {
    "value": "茂名市",
    "children": [{
      "value": "茂南区",
      "code": "525011",
      "label": "茂南区"
    }, {
      "value": "电白区",
      "code": "525400",
      "label": "电白区"
    }, {
      "value": "高州市",
      "code": "525200",
      "label": "高州市"
    }, {
      "value": "化州市",
      "code": "525100",
      "label": "化州市"
    }, {
      "value": "信宜市",
      "code": "525300",
      "label": "信宜市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "茂名市"
  }, {
    "value": "肇庆市",
    "children": [{
      "value": "端州区",
      "code": "526020",
      "label": "端州区"
    }, {
      "value": "鼎湖区",
      "code": "526071",
      "label": "鼎湖区"
    }, {
      "value": "高要区",
      "code": "526100",
      "label": "高要区"
    }, {
      "value": "广宁县",
      "code": "526300",
      "label": "广宁县"
    }, {
      "value": "怀集县",
      "code": "526400",
      "label": "怀集县"
    }, {
      "value": "封开县",
      "code": "526500",
      "label": "封开县"
    }, {
      "value": "德庆县",
      "code": "526600",
      "label": "德庆县"
    }, {
      "value": "四会市",
      "code": "526200",
      "label": "四会市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "肇庆市"
  }, {
    "value": "惠州市",
    "children": [{
      "value": "惠城区",
      "code": "516001",
      "label": "惠城区"
    }, {
      "value": "惠阳区",
      "code": "516200",
      "label": "惠阳区"
    }, {
      "value": "博罗县",
      "code": "516100",
      "label": "博罗县"
    }, {
      "value": "惠东县",
      "code": "516300",
      "label": "惠东县"
    }, {
      "value": "龙门县",
      "code": "516800",
      "label": "龙门县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "惠州市"
  }, {
    "value": "梅州市",
    "children": [{
      "value": "梅江区",
      "code": "514011",
      "label": "梅江区"
    }, {
      "value": "梅县区",
      "code": "514700",
      "label": "梅县区"
    }, {
      "value": "大埔县",
      "code": "514200",
      "label": "大埔县"
    }, {
      "value": "丰顺县",
      "code": "514300",
      "label": "丰顺县"
    }, {
      "value": "五华县",
      "code": "514400",
      "label": "五华县"
    }, {
      "value": "平远县",
      "code": "514600",
      "label": "平远县"
    }, {
      "value": "蕉岭县",
      "code": "514100",
      "label": "蕉岭县"
    }, {
      "value": "兴宁市",
      "code": "514500",
      "label": "兴宁市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "梅州市"
  }, {
    "value": "汕尾市",
    "children": [{
      "value": "海丰县",
      "code": "516400",
      "label": "海丰县"
    }, {
      "value": "陆河县",
      "code": "516700",
      "label": "陆河县"
    }, {
      "value": "陆丰市",
      "code": "516500",
      "label": "陆丰市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "汕尾市"
  }, {
    "value": "河源市",
    "children": [{
      "value": "源城区",
      "code": "517001",
      "label": "源城区"
    }, {
      "value": "紫金县",
      "code": "517400",
      "label": "紫金县"
    }, {
      "value": "龙川县",
      "code": "517300",
      "label": "龙川县"
    }, {
      "value": "连平县",
      "code": "517100",
      "label": "连平县"
    }, {
      "value": "和平县",
      "code": "517200",
      "label": "和平县"
    }, {
      "value": "东源县",
      "code": "517500",
      "label": "东源县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "河源市"
  }, {
    "value": "阳江市",
    "children": [{
      "value": "江城区",
      "code": "529536",
      "label": "江城区"
    }, {
      "value": "阳东区",
      "code": "529900",
      "label": "阳东区"
    }, {
      "value": "阳西县",
      "code": "529800",
      "label": "阳西县"
    }, {
      "value": "阳春市",
      "code": "529600",
      "label": "阳春市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "阳江市"
  }, {
    "value": "清远市",
    "children": [{
      "value": "清城区",
      "code": "511510",
      "label": "清城区"
    }, {
      "value": "清新区",
      "code": "511800",
      "label": "清新区"
    }, {
      "value": "佛冈县",
      "code": "511600",
      "label": "佛冈县"
    }, {
      "value": "阳山县",
      "code": "513100",
      "label": "阳山县"
    }, {
      "value": "连山壮族瑶族自治县",
      "code": "513200",
      "label": "连山壮族瑶族自治县"
    }, {
      "value": "连南瑶族自治县",
      "code": "513300",
      "label": "连南瑶族自治县"
    }, {
      "value": "英德市",
      "code": "513000",
      "label": "英德市"
    }, {
      "value": "连州市",
      "code": "513400",
      "label": "连州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "清远市"
  }, {
    "value": "东莞市",
    "children": [{
      "value": "莞城街道",
      "code": "523001",
      "label": "莞城街道"
    }, {
      "value": "南城街道",
      "code": "523073",
      "label": "南城街道"
    }, {
      "value": "东城街道",
      "code": "523122",
      "label": "东城街道"
    }, {
      "value": "万江街道",
      "code": "523039",
      "label": "万江街道"
    }, {
      "value": "石龙镇",
      "code": "523326",
      "label": "石龙镇"
    }, {
      "value": "石排镇",
      "code": "523331",
      "label": "石排镇"
    }, {
      "value": "茶山镇",
      "code": "523378",
      "label": "茶山镇"
    }, {
      "value": "企石镇",
      "code": "523551",
      "label": "企石镇"
    }, {
      "value": "桥头镇",
      "code": "523539",
      "label": "桥头镇"
    }, {
      "value": "东坑镇",
      "code": "523451",
      "label": "东坑镇"
    }, {
      "value": "横沥镇",
      "code": "523461",
      "label": "横沥镇"
    }, {
      "value": "常平镇",
      "code": "523571",
      "label": "常平镇"
    }, {
      "value": "虎门镇",
      "code": "523899",
      "label": "虎门镇"
    }, {
      "value": "长安镇",
      "code": "523843",
      "label": "长安镇"
    }, {
      "value": "沙田镇",
      "code": "523981",
      "label": "沙田镇"
    }, {
      "value": "厚街镇",
      "code": "523961",
      "label": "厚街镇"
    }, {
      "value": "寮步镇",
      "code": "523431",
      "label": "寮步镇"
    }, {
      "value": "大岭山镇",
      "code": "523820",
      "label": "大岭山镇"
    }, {
      "value": "大朗镇",
      "code": "523771",
      "label": "大朗镇"
    }, {
      "value": "黄江镇",
      "code": "523751",
      "label": "黄江镇"
    }, {
      "value": "樟木头镇",
      "code": "523622",
      "label": "樟木头镇"
    }, {
      "value": "谢岗镇",
      "code": "523591",
      "label": "谢岗镇"
    }, {
      "value": "塘厦镇",
      "code": "523711",
      "label": "塘厦镇"
    }, {
      "value": "清溪镇",
      "code": "523661",
      "label": "清溪镇"
    }, {
      "value": "凤岗镇",
      "code": "523691",
      "label": "凤岗镇"
    }, {
      "value": "麻涌镇",
      "code": "523133",
      "label": "麻涌镇"
    }, {
      "value": "中堂镇",
      "code": "523221",
      "label": "中堂镇"
    }, {
      "value": "高埗镇",
      "code": "523275",
      "label": "高埗镇"
    }, {
      "value": "石碣镇",
      "code": "523291",
      "label": "石碣镇"
    }, {
      "value": "望牛墩镇",
      "code": "523208",
      "label": "望牛墩镇"
    }, {
      "value": "洪梅镇",
      "code": "523161",
      "label": "洪梅镇"
    }, {
      "value": "道滘镇",
      "code": "523171",
      "label": "道滘镇"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "东莞市"
  }, {
    "value": "中山市",
    "children": [{
      "value": "石岐街道",
      "code": "528499",
      "label": "石岐街道"
    }, {
      "value": "东区街道",
      "code": "528403",
      "label": "东区街道"
    }, {
      "value": "西区街道",
      "code": "528401",
      "label": "西区街道"
    }, {
      "value": "南区街道",
      "code": "528455",
      "label": "南区街道"
    }, {
      "value": "五桂山街道",
      "code": "528458",
      "label": "五桂山街道"
    }, {
      "value": "火炬高技术产业开发区",
      "code": "528437",
      "label": "火炬高技术产业开发区"
    }, {
      "value": "黄圃镇",
      "code": "528429",
      "label": "黄圃镇"
    }, {
      "value": "南头镇",
      "code": "528427",
      "label": "南头镇"
    }, {
      "value": "东凤镇",
      "code": "528425",
      "label": "东凤镇"
    }, {
      "value": "阜沙镇",
      "code": "528434",
      "label": "阜沙镇"
    }, {
      "value": "小榄镇",
      "code": "528415",
      "label": "小榄镇"
    }, {
      "value": "东升镇",
      "code": "528414",
      "label": "东升镇"
    }, {
      "value": "古镇镇",
      "code": "5284321",
      "label": "古镇镇"
    }, {
      "value": "横栏镇",
      "code": "528478",
      "label": "横栏镇"
    }, {
      "value": "三角镇",
      "code": "528445",
      "label": "三角镇"
    }, {
      "value": "民众镇",
      "code": "528437",
      "label": "民众镇"
    }, {
      "value": "南朗镇",
      "code": "528449",
      "label": "南朗镇"
    }, {
      "value": "港口镇",
      "code": "528447",
      "label": "港口镇"
    }, {
      "value": "大涌镇",
      "code": "528476",
      "label": "大涌镇"
    }, {
      "value": "沙溪镇",
      "code": "528471",
      "label": "沙溪镇"
    }, {
      "value": "三乡镇",
      "code": "528463",
      "label": "三乡镇"
    }, {
      "value": "板芙镇",
      "code": "528459",
      "label": "板芙镇"
    }, {
      "value": "神湾镇",
      "code": "528462",
      "label": "神湾镇"
    }, {
      "value": "坦洲镇",
      "code": "528467",
      "label": "坦洲镇"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "中山市"
  }, {
    "value": "潮州市",
    "children": [{
      "value": "湘桥区",
      "code": "521011",
      "label": "湘桥区"
    }, {
      "value": "潮安区",
      "code": "515600",
      "label": "潮安区"
    }, {
      "value": "饶平县",
      "code": "515700",
      "label": "饶平县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "潮州市"
  }, {
    "value": "揭阳市",
    "children": [{
      "value": "榕城区",
      "code": "522021",
      "label": "榕城区"
    }, {
      "value": "揭东区",
      "code": "515500",
      "label": "揭东区"
    }, {
      "value": "揭西县",
      "code": "515400",
      "label": "揭西县"
    }, {
      "value": "惠来县",
      "code": "515200",
      "label": "惠来县"
    }, {
      "value": "普宁市",
      "code": "515300",
      "label": "普宁市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "揭阳市"
  }, {
    "value": "云浮市",
    "children": [{
      "value": "云城区",
      "code": "527322",
      "label": "云城区"
    }, {
      "value": "云安区",
      "code": "527500",
      "label": "云安区"
    }, {
      "value": "新兴县",
      "code": "527400",
      "label": "新兴县"
    }, {
      "value": "郁南县",
      "code": "527100",
      "label": "郁南县"
    }, {
      "value": "罗定市",
      "code": "527200",
      "label": "罗定市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "云浮市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "广东省",
  "label": "广东省"
}, {
  "children": [{
    "value": "南宁市",
    "children": [{
      "value": "兴宁区",
      "code": "530024",
      "label": "兴宁区"
    }, {
      "value": "青秀区",
      "code": "530021",
      "label": "青秀区"
    }, {
      "value": "江南区",
      "code": "530031",
      "label": "江南区"
    }, {
      "value": "西乡塘区",
      "code": "530003",
      "label": "西乡塘区"
    }, {
      "value": "良庆区",
      "code": "530201",
      "label": "良庆区"
    }, {
      "value": "邕宁区",
      "code": "530203",
      "label": "邕宁区"
    }, {
      "value": "武鸣区",
      "code": "530100",
      "label": "武鸣区"
    }, {
      "value": "隆安县",
      "code": "532700",
      "label": "隆安县"
    }, {
      "value": "马山县",
      "code": "530600",
      "label": "马山县"
    }, {
      "value": "上林县",
      "code": "530500",
      "label": "上林县"
    }, {
      "value": "宾阳县",
      "code": "530400",
      "label": "宾阳县"
    }, {
      "value": "横县",
      "code": "530300",
      "label": "横县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "南宁市"
  }, {
    "value": "柳州市",
    "children": [{
      "value": "城中区",
      "code": "545000",
      "label": "城中区"
    }, {
      "value": "鱼峰区",
      "code": "545036",
      "label": "鱼峰区"
    }, {
      "value": "柳南区",
      "code": "545008",
      "label": "柳南区"
    }, {
      "value": "柳北区",
      "code": "545002",
      "label": "柳北区"
    }, {
      "value": "柳江县",
      "code": "545100",
      "label": "柳江县"
    }, {
      "value": "柳城县",
      "code": "545200",
      "label": "柳城县"
    }, {
      "value": "鹿寨县",
      "code": "545600",
      "label": "鹿寨县"
    }, {
      "value": "融安县",
      "code": "545400",
      "label": "融安县"
    }, {
      "value": "融水苗族自治县",
      "code": "545300",
      "label": "融水苗族自治县"
    }, {
      "value": "三江侗族自治县",
      "code": "545500",
      "label": "三江侗族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "柳州市"
  }, {
    "value": "桂林市",
    "children": [{
      "value": "秀峰区",
      "code": "541000",
      "label": "秀峰区"
    }, {
      "value": "叠彩区",
      "code": "541000",
      "label": "叠彩区"
    }, {
      "value": "象山区",
      "code": "541002",
      "label": "象山区"
    }, {
      "value": "七星区",
      "code": "541007",
      "label": "七星区"
    }, {
      "value": "雁山区",
      "code": "541005",
      "label": "雁山区"
    }, {
      "value": "临桂区",
      "code": "541100",
      "label": "临桂区"
    }, {
      "value": "阳朔县",
      "code": "541900",
      "label": "阳朔县"
    }, {
      "value": "灵川县",
      "code": "541200",
      "label": "灵川县"
    }, {
      "value": "全州县",
      "code": "541500",
      "label": "全州县"
    }, {
      "value": "兴安县",
      "code": "541300",
      "label": "兴安县"
    }, {
      "value": "永福县",
      "code": "541800",
      "label": "永福县"
    }, {
      "value": "灌阳县",
      "code": "541600",
      "label": "灌阳县"
    }, {
      "value": "龙胜各族自治县",
      "code": "541700",
      "label": "龙胜各族自治县"
    }, {
      "value": "资源县",
      "code": "541400",
      "label": "资源县"
    }, {
      "value": "平乐县",
      "code": "542400",
      "label": "平乐县"
    }, {
      "value": "荔浦县",
      "code": "546600",
      "label": "荔浦县"
    }, {
      "value": "恭城瑶族自治县",
      "code": "542500",
      "label": "恭城瑶族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "桂林市"
  }, {
    "value": "梧州市",
    "children": [{
      "value": "万秀区",
      "code": "543004",
      "label": "万秀区"
    }, {
      "value": "长洲区",
      "code": "543002",
      "label": "长洲区"
    }, {
      "value": "龙圩区",
      "code": "543199",
      "label": "龙圩区"
    }, {
      "value": "苍梧县",
      "code": "543100",
      "label": "苍梧县"
    }, {
      "value": "藤县",
      "code": "543300",
      "label": "藤县"
    }, {
      "value": "蒙山县",
      "code": "546700",
      "label": "蒙山县"
    }, {
      "value": "岑溪市",
      "code": "543200",
      "label": "岑溪市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "梧州市"
  }, {
    "value": "北海市",
    "children": [{
      "value": "海城区",
      "code": "536001",
      "label": "海城区"
    }, {
      "value": "银海区",
      "code": "536002",
      "label": "银海区"
    }, {
      "value": "铁山港区",
      "code": "536016",
      "label": "铁山港区"
    }, {
      "value": "合浦县",
      "code": "536100",
      "label": "合浦县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "北海市"
  }, {
    "value": "防城港市",
    "children": [{
      "value": "港口区",
      "code": "538001",
      "label": "港口区"
    }, {
      "value": "防城区",
      "code": "538021",
      "label": "防城区"
    }, {
      "value": "上思县",
      "code": "535500",
      "label": "上思县"
    }, {
      "value": "东兴市",
      "code": "538100",
      "label": "东兴市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "防城港市"
  }, {
    "value": "钦州市",
    "children": [{
      "value": "钦南区",
      "code": "535008",
      "label": "钦南区"
    }, {
      "value": "钦北区",
      "code": "535018",
      "label": "钦北区"
    }, {
      "value": "灵山县",
      "code": "535400",
      "label": "灵山县"
    }, {
      "value": "浦北县",
      "code": "535300",
      "label": "浦北县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "钦州市"
  }, {
    "value": "贵港市",
    "children": [{
      "value": "港北区",
      "code": "537101",
      "label": "港北区"
    }, {
      "value": "港南区",
      "code": "537106",
      "label": "港南区"
    }, {
      "value": "覃塘区",
      "code": "537115",
      "label": "覃塘区"
    }, {
      "value": "平南县",
      "code": "537300",
      "label": "平南县"
    }, {
      "value": "桂平市",
      "code": "537200",
      "label": "桂平市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "贵港市"
  }, {
    "value": "玉林市",
    "children": [{
      "value": "玉州区",
      "code": "537001",
      "label": "玉州区"
    }, {
      "value": "福绵区",
      "code": "537023",
      "label": "福绵区"
    }, {
      "value": "容县",
      "code": "537500",
      "label": "容县"
    }, {
      "value": "陆川县",
      "code": "537700",
      "label": "陆川县"
    }, {
      "value": "博白县",
      "code": "537600",
      "label": "博白县"
    }, {
      "value": "兴业县",
      "code": "537800",
      "label": "兴业县"
    }, {
      "value": "北流市",
      "code": "537400",
      "label": "北流市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "玉林市"
  }, {
    "value": "百色市",
    "children": [{
      "value": "右江区",
      "code": "533001",
      "label": "右江区"
    }, {
      "value": "田阳县",
      "code": "533600",
      "label": "田阳县"
    }, {
      "value": "田东县",
      "code": "531500",
      "label": "田东县"
    }, {
      "value": "平果县",
      "code": "531400",
      "label": "平果县"
    }, {
      "value": "德保县",
      "code": "533700",
      "label": "德保县"
    }, {
      "value": "那坡县",
      "code": "533900",
      "label": "那坡县"
    }, {
      "value": "凌云县",
      "code": "533100",
      "label": "凌云县"
    }, {
      "value": "乐业县",
      "code": "533200",
      "label": "乐业县"
    }, {
      "value": "田林县",
      "code": "533300",
      "label": "田林县"
    }, {
      "value": "西林县",
      "code": "533500",
      "label": "西林县"
    }, {
      "value": "隆林各族自治县",
      "code": "533400",
      "label": "隆林各族自治县"
    }, {
      "value": "靖西市",
      "code": "533800",
      "label": "靖西市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "百色市"
  }, {
    "value": "贺州市",
    "children": [{
      "value": "八步区",
      "code": "542802",
      "label": "八步区"
    }, {
      "value": "平桂管理区",
      "code": "542827",
      "label": "平桂管理区"
    }, {
      "value": "昭平县",
      "code": "546800",
      "label": "昭平县"
    }, {
      "value": "钟山县",
      "code": "542600",
      "label": "钟山县"
    }, {
      "value": "富川瑶族自治县",
      "code": "542700",
      "label": "富川瑶族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "贺州市"
  }, {
    "value": "河池市",
    "children": [{
      "value": "金城江区",
      "code": "547001",
      "label": "金城江区"
    }, {
      "value": "南丹县",
      "code": "547200",
      "label": "南丹县"
    }, {
      "value": "天峨县",
      "code": "547300",
      "label": "天峨县"
    }, {
      "value": "凤山县",
      "code": "547600",
      "label": "凤山县"
    }, {
      "value": "东兰县",
      "code": "547400",
      "label": "东兰县"
    }, {
      "value": "罗城仫佬族自治县",
      "code": "546400",
      "label": "罗城仫佬族自治县"
    }, {
      "value": "环江毛南族自治县",
      "code": "547100",
      "label": "环江毛南族自治县"
    }, {
      "value": "巴马瑶族自治县",
      "code": "547500",
      "label": "巴马瑶族自治县"
    }, {
      "value": "都安瑶族自治县",
      "code": "530700",
      "label": "都安瑶族自治县"
    }, {
      "value": "大化瑶族自治县",
      "code": "530800",
      "label": "大化瑶族自治县"
    }, {
      "value": "宜州市",
      "code": "546300",
      "label": "宜州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "河池市"
  }, {
    "value": "来宾市",
    "children": [{
      "value": "兴宾区",
      "code": "546101",
      "label": "兴宾区"
    }, {
      "value": "忻城县",
      "code": "546200",
      "label": "忻城县"
    }, {
      "value": "象州县",
      "code": "545800",
      "label": "象州县"
    }, {
      "value": "武宣县",
      "code": "545900",
      "label": "武宣县"
    }, {
      "value": "金秀瑶族自治县",
      "code": "545700",
      "label": "金秀瑶族自治县"
    }, {
      "value": "合山市",
      "code": "546500",
      "label": "合山市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "来宾市"
  }, {
    "value": "崇左市",
    "children": [{
      "value": "江洲区",
      "code": "532201",
      "label": "江洲区"
    }, {
      "value": "扶绥县",
      "code": "532100",
      "label": "扶绥县"
    }, {
      "value": "宁明县",
      "code": "532500",
      "label": "宁明县"
    }, {
      "value": "龙州县",
      "code": "532400",
      "label": "龙州县"
    }, {
      "value": "大新县",
      "code": "532300",
      "label": "大新县"
    }, {
      "value": "天等县",
      "code": "532800",
      "label": "天等县"
    }, {
      "value": "凭祥市",
      "code": "532600",
      "label": "凭祥市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "崇左市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "广西壮族自治区",
  "label": "广西壮族自治区"
}, {
  "children": [{
    "value": "海口市",
    "children": [{
      "value": "秀英区",
      "code": "570312",
      "label": "秀英区"
    }, {
      "value": "龙华区",
      "code": "570101",
      "label": "龙华区"
    }, {
      "value": "琼山区",
      "code": "571100",
      "label": "琼山区"
    }, {
      "value": "美兰区",
      "code": "570203",
      "label": "美兰区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "海口市"
  }, {
    "value": "三亚市",
    "children": [{
      "value": "海棠区",
      "code": "572013",
      "label": "海棠区"
    }, {
      "value": "吉阳区",
      "code": "572011",
      "label": "吉阳区"
    }, {
      "value": "天涯区",
      "code": "572029",
      "label": "天涯区"
    }, {
      "value": "崖州区",
      "code": "572024",
      "label": "崖州区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "三亚市"
  }, {
    "value": "三沙市",
    "children": [{
      "value": "西沙群岛",
      "code": "573199",
      "label": "西沙群岛"
    }, {
      "value": "南沙群岛",
      "code": "573199",
      "label": "南沙群岛"
    }, {
      "value": "中沙群岛",
      "code": "573199",
      "label": "中沙群岛"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "三沙市"
  }, {
    "value": "儋州市",
    "children": [{
      "value": "那大镇",
      "code": "571799",
      "label": "那大镇"
    }, {
      "value": "和庆镇",
      "code": "571721",
      "label": "和庆镇"
    }, {
      "value": "南丰镇",
      "code": "571724",
      "label": "南丰镇"
    }, {
      "value": "大成镇",
      "code": "571736",
      "label": "大成镇"
    }, {
      "value": "雅星镇",
      "code": "571729",
      "label": "雅星镇"
    }, {
      "value": "兰洋镇",
      "code": "571722",
      "label": "兰洋镇"
    }, {
      "value": "光村镇",
      "code": "571752",
      "label": "光村镇"
    }, {
      "value": "木棠镇",
      "code": "571746",
      "label": "木棠镇"
    }, {
      "value": "海头镇",
      "code": "571732",
      "label": "海头镇"
    }, {
      "value": "峨蔓镇",
      "code": "571745",
      "label": "峨蔓镇"
    }, {
      "value": "三都镇",
      "code": "571744",
      "label": "三都镇"
    }, {
      "value": "王五镇",
      "code": "571739",
      "label": "王五镇"
    }, {
      "value": "白马井镇",
      "code": "571742",
      "label": "白马井镇"
    }, {
      "value": "中和镇",
      "code": "571747",
      "label": "中和镇"
    }, {
      "value": "排浦镇",
      "code": "571741",
      "label": "排浦镇"
    }, {
      "value": "东成镇",
      "code": "571763",
      "label": "东成镇"
    }, {
      "value": "新州镇",
      "code": "571749",
      "label": "新州镇"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "儋州市"
  }, {
    "value": "省直辖县级行政区划",
    "children": [{
      "value": "五指山市",
      "code": "572200",
      "label": "五指山市"
    }, {
      "value": "琼海市",
      "code": "571400",
      "label": "琼海市"
    }, {
      "value": "文昌市",
      "code": "571300",
      "label": "文昌市"
    }, {
      "value": "万宁市",
      "code": "571500",
      "label": "万宁市"
    }, {
      "value": "东方市",
      "code": "572600",
      "label": "东方市"
    }, {
      "value": "定安县",
      "code": "571221",
      "label": "定安县"
    }, {
      "value": "屯昌县",
      "code": "571621",
      "label": "屯昌县"
    }, {
      "value": "澄迈县",
      "code": "571921",
      "label": "澄迈县"
    }, {
      "value": "临高县",
      "code": "571821",
      "label": "临高县"
    }, {
      "value": "白沙黎族自治县",
      "code": "572811",
      "label": "白沙黎族自治县"
    }, {
      "value": "昌江黎族自治县",
      "code": "572722",
      "label": "昌江黎族自治县"
    }, {
      "value": "乐东黎族自治县",
      "code": "572501",
      "label": "乐东黎族自治县"
    }, {
      "value": "陵水黎族自治县",
      "code": "572421",
      "label": "陵水黎族自治县"
    }, {
      "value": "保亭黎族苗族自治县",
      "code": "572311",
      "label": "保亭黎族苗族自治县"
    }, {
      "value": "琼中黎族苗族自治县",
      "code": "572911",
      "label": "琼中黎族苗族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "省直辖县级行政区划"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "海南省",
  "label": "海南省"
}, {
  "children": [{
    "value": "市辖区",
    "children": [{
      "value": "万州区",
      "code": "404001",
      "label": "万州区"
    }, {
      "value": "涪陵区",
      "code": "408000",
      "label": "涪陵区"
    }, {
      "value": "渝中区",
      "code": "400010",
      "label": "渝中区"
    }, {
      "value": "大渡口区",
      "code": "400082",
      "label": "大渡口区"
    }, {
      "value": "江北区",
      "code": "400020",
      "label": "江北区"
    }, {
      "value": "沙坪坝区",
      "code": "400030",
      "label": "沙坪坝区"
    }, {
      "value": "九龙坡区",
      "code": "400041",
      "label": "九龙坡区"
    }, {
      "value": "南岸区",
      "code": "400060",
      "label": "南岸区"
    }, {
      "value": "北碚区",
      "code": "400700",
      "label": "北碚区"
    }, {
      "value": "綦江区",
      "code": "400800",
      "label": "綦江区"
    }, {
      "value": "大足区",
      "code": "400900",
      "label": "大足区"
    }, {
      "value": "渝北区",
      "code": "401120",
      "label": "渝北区"
    }, {
      "value": "巴南区",
      "code": "400054",
      "label": "巴南区"
    }, {
      "value": "黔江区",
      "code": "409000",
      "label": "黔江区"
    }, {
      "value": "长寿区",
      "code": "401220",
      "label": "长寿区"
    }, {
      "value": "江津区",
      "code": "402201",
      "label": "江津区"
    }, {
      "value": "合川区",
      "code": "401501",
      "label": "合川区"
    }, {
      "value": "永川区",
      "code": "402101",
      "label": "永川区"
    }, {
      "value": "南川区",
      "code": "408400",
      "label": "南川区"
    }, {
      "value": "璧山区",
      "code": "402700",
      "label": "璧山区"
    }, {
      "value": "铜梁区",
      "code": "402552",
      "label": "铜梁区"
    }, {
      "value": "潼南区",
      "code": "402660",
      "label": "潼南区"
    }, {
      "value": "荣昌区",
      "code": "402460",
      "label": "荣昌区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "市辖区"
  }, {
    "value": "辖县",
    "children": [{
      "value": "梁平县",
      "code": "405200",
      "label": "梁平县"
    }, {
      "value": "城口县",
      "code": "405900",
      "label": "城口县"
    }, {
      "value": "丰都县",
      "code": "408200",
      "label": "丰都县"
    }, {
      "value": "垫江县",
      "code": "408300",
      "label": "垫江县"
    }, {
      "value": "武隆县",
      "code": "408500",
      "label": "武隆县"
    }, {
      "value": "忠县",
      "code": "404300",
      "label": "忠县"
    }, {
      "value": "开县",
      "code": "405400",
      "label": "开县"
    }, {
      "value": "云阳县",
      "code": "404500",
      "label": "云阳县"
    }, {
      "value": "奉节县",
      "code": "404600",
      "label": "奉节县"
    }, {
      "value": "巫山县",
      "code": "404700",
      "label": "巫山县"
    }, {
      "value": "巫溪县",
      "code": "405800",
      "label": "巫溪县"
    }, {
      "value": "石柱土家族自治县",
      "code": "409100",
      "label": "石柱土家族自治县"
    }, {
      "value": "秀山土家族苗族自治县",
      "code": "409900",
      "label": "秀山土家族苗族自治县"
    }, {
      "value": "酉阳土家族苗族自治县",
      "code": "409801",
      "label": "酉阳土家族苗族自治县"
    }, {
      "value": "彭水苗族土家族自治县",
      "code": "409600",
      "label": "彭水苗族土家族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "辖县"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "重庆市",
  "label": "重庆市"
}, {
  "children": [{
    "value": "成都市",
    "children": [{
      "value": "锦江区",
      "code": "610021",
      "label": "锦江区"
    }, {
      "value": "青羊区",
      "code": "610014",
      "label": "青羊区"
    }, {
      "value": "金牛区",
      "code": "610031",
      "label": "金牛区"
    }, {
      "value": "武侯区",
      "code": "610041",
      "label": "武侯区"
    }, {
      "value": "成华区",
      "code": "610051",
      "label": "成华区"
    }, {
      "value": "龙泉驿区",
      "code": "610100",
      "label": "龙泉驿区"
    }, {
      "value": "青白江区",
      "code": "610300",
      "label": "青白江区"
    }, {
      "value": "新都区",
      "code": "610500",
      "label": "新都区"
    }, {
      "value": "温江区",
      "code": "611130",
      "label": "温江区"
    }, {
      "value": "双流区",
      "code": "610200",
      "label": "双流区"
    }, {
      "value": "金堂县",
      "code": "610400",
      "label": "金堂县"
    }, {
      "value": "郫县",
      "code": "610039",
      "label": "郫县"
    }, {
      "value": "大邑县",
      "code": "611300",
      "label": "大邑县"
    }, {
      "value": "蒲江县",
      "code": "611600",
      "label": "蒲江县"
    }, {
      "value": "新津县",
      "code": "611400",
      "label": "新津县"
    }, {
      "value": "都江堰市",
      "code": "611800",
      "label": "都江堰市"
    }, {
      "value": "彭州市",
      "code": "611900",
      "label": "彭州市"
    }, {
      "value": "邛崃市",
      "code": "611500",
      "label": "邛崃市"
    }, {
      "value": "崇州市",
      "code": "611200",
      "label": "崇州市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "成都市"
  }, {
    "value": "自贡市",
    "children": [{
      "value": "自流井区",
      "code": "643035",
      "label": "自流井区"
    }, {
      "value": "贡井区",
      "code": "643101",
      "label": "贡井区"
    }, {
      "value": "大安区",
      "code": "643010",
      "label": "大安区"
    }, {
      "value": "沿滩区",
      "code": "643003",
      "label": "沿滩区"
    }, {
      "value": "荣县",
      "code": "643100",
      "label": "荣县"
    }, {
      "value": "富顺县",
      "code": "643200",
      "label": "富顺县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "自贡市"
  }, {
    "value": "攀枝花市",
    "children": [{
      "value": "东区",
      "code": "617009",
      "label": "东区"
    }, {
      "value": "西区",
      "code": "617004",
      "label": "西区"
    }, {
      "value": "仁和区",
      "code": "617001",
      "label": "仁和区"
    }, {
      "value": "米易县",
      "code": "617200",
      "label": "米易县"
    }, {
      "value": "盐边县",
      "code": "617100",
      "label": "盐边县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "攀枝花市"
  }, {
    "value": "泸州市",
    "children": [{
      "value": "江阳区",
      "code": "646001",
      "label": "江阳区"
    }, {
      "value": "纳溪区",
      "code": "646300",
      "label": "纳溪区"
    }, {
      "value": "龙马潭区",
      "code": "646601",
      "label": "龙马潭区"
    }, {
      "value": "泸县",
      "code": "646100",
      "label": "泸县"
    }, {
      "value": "合江县",
      "code": "646200",
      "label": "合江县"
    }, {
      "value": "叙永县",
      "code": "646400",
      "label": "叙永县"
    }, {
      "value": "古蔺县",
      "code": "646500",
      "label": "古蔺县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "泸州市"
  }, {
    "value": "德阳市",
    "children": [{
      "value": "旌阳区",
      "code": "618001",
      "label": "旌阳区"
    }, {
      "value": "���江县",
      "code": "618100",
      "label": "���江县"
    }, {
      "value": "罗江县",
      "code": "618500",
      "label": "罗江县"
    }, {
      "value": "广汉市",
      "code": "618300",
      "label": "广汉市"
    }, {
      "value": "什邡市",
      "code": "618400",
      "label": "什邡市"
    }, {
      "value": "绵竹市",
      "code": "618200",
      "label": "绵竹市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "德阳市"
  }, {
    "value": "绵阳市",
    "children": [{
      "value": "涪城区",
      "code": "621001",
      "label": "涪城区"
    }, {
      "value": "游仙区",
      "code": "621003",
      "label": "游仙区"
    }, {
      "value": "三台县",
      "code": "621100",
      "label": "三台县"
    }, {
      "value": "盐亭县",
      "code": "621600",
      "label": "盐亭县"
    }, {
      "value": "安县",
      "code": "622650",
      "label": "安县"
    }, {
      "value": "梓潼县",
      "code": "622151",
      "label": "梓潼县"
    }, {
      "value": "北川羌族自治县",
      "code": "622750",
      "label": "北川羌族自治县"
    }, {
      "value": "平武县",
      "code": "622550",
      "label": "平武县"
    }, {
      "value": "江油市",
      "code": "621700",
      "label": "江油市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "绵阳市"
  }, {
    "value": "广元市",
    "children": [{
      "value": "利州区",
      "code": "628001",
      "label": "利州区"
    }, {
      "value": "元坝区",
      "code": "628021",
      "label": "元坝区"
    }, {
      "value": "朝天区",
      "code": "628011",
      "label": "朝天区"
    }, {
      "value": "旺苍县",
      "code": "628200",
      "label": "旺苍县"
    }, {
      "value": "青川县",
      "code": "628100",
      "label": "青川县"
    }, {
      "value": "剑阁县",
      "code": "628300",
      "label": "剑阁县"
    }, {
      "value": "苍溪县",
      "code": "628400",
      "label": "苍溪县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "广元市"
  }, {
    "value": "遂宁市",
    "children": [{
      "value": "船山区",
      "code": "629013",
      "label": "船山区"
    }, {
      "value": "安居区",
      "code": "629004",
      "label": "安居区"
    }, {
      "value": "蓬溪县",
      "code": "629100",
      "label": "蓬溪县"
    }, {
      "value": "射洪县",
      "code": "629200",
      "label": "射洪县"
    }, {
      "value": "大英县",
      "code": "629300",
      "label": "大英县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "遂宁市"
  }, {
    "value": "内江市",
    "children": [{
      "value": "市中区",
      "code": "641007",
      "label": "市中区"
    }, {
      "value": "东兴区",
      "code": "641100",
      "label": "东兴区"
    }, {
      "value": "威远县",
      "code": "642450",
      "label": "威远县"
    }, {
      "value": "资中县",
      "code": "641200",
      "label": "资中县"
    }, {
      "value": "隆昌县",
      "code": "642152",
      "label": "隆昌县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "内江市"
  }, {
    "value": "乐山市",
    "children": [{
      "value": "市中区",
      "code": "614001",
      "label": "市中区"
    }, {
      "value": "沙湾区",
      "code": "614900",
      "label": "沙湾区"
    }, {
      "value": "五通桥区",
      "code": "614800",
      "label": "五通桥区"
    }, {
      "value": "金口河区",
      "code": "614700",
      "label": "金口河区"
    }, {
      "value": "犍为县",
      "code": "614400",
      "label": "犍为县"
    }, {
      "value": "井研县",
      "code": "613100",
      "label": "井研县"
    }, {
      "value": "夹江县",
      "code": "614100",
      "label": "夹江县"
    }, {
      "value": "沐川县",
      "code": "614500",
      "label": "沐川县"
    }, {
      "value": "峨边彝族自治县",
      "code": "614300",
      "label": "峨边彝族自治县"
    }, {
      "value": "马边彝族自治县",
      "code": "614600",
      "label": "马边彝族自治县"
    }, {
      "value": "峨眉山市",
      "code": "614200",
      "label": "峨眉山市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "乐山市"
  }, {
    "value": "南充市",
    "children": [{
      "value": "顺庆区",
      "code": "637004",
      "label": "顺庆区"
    }, {
      "value": "高坪区",
      "code": "637100",
      "label": "高坪区"
    }, {
      "value": "嘉陵区",
      "code": "637500",
      "label": "嘉陵区"
    }, {
      "value": "南部县",
      "code": "637300",
      "label": "南部县"
    }, {
      "value": "营山县",
      "code": "637700",
      "label": "营山县"
    }, {
      "value": "蓬安县",
      "code": "637800",
      "label": "蓬安县"
    }, {
      "value": "仪陇县",
      "code": "637600",
      "label": "仪陇县"
    }, {
      "value": "西充县",
      "code": "637200",
      "label": "西充县"
    }, {
      "value": "阆中市",
      "code": "637400",
      "label": "阆中市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "南充市"
  }, {
    "value": "眉山市",
    "children": [{
      "value": "东坡区",
      "code": "620030",
      "label": "东坡区"
    }, {
      "value": "彭山区",
      "code": "620800",
      "label": "彭山区"
    }, {
      "value": "仁寿县",
      "code": "620500",
      "label": "仁寿县"
    }, {
      "value": "洪雅县",
      "code": "620300",
      "label": "洪雅县"
    }, {
      "value": "丹棱县",
      "code": "620200",
      "label": "丹棱县"
    }, {
      "value": "青神县",
      "code": "620400",
      "label": "青神县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "眉山市"
  }, {
    "value": "宜宾市",
    "children": [{
      "value": "翠屏区",
      "code": "644001",
      "label": "翠屏区"
    }, {
      "value": "南溪区",
      "code": "644100",
      "label": "南溪区"
    }, {
      "value": "宜宾县",
      "code": "644600",
      "label": "宜宾县"
    }, {
      "value": "江安县",
      "code": "644200",
      "label": "江安县"
    }, {
      "value": "长宁县",
      "code": "644300",
      "label": "长宁县"
    }, {
      "value": "高县",
      "code": "645150",
      "label": "高县"
    }, {
      "value": "珙县",
      "code": "644500",
      "label": "珙县"
    }, {
      "value": "筠连县",
      "code": "645250",
      "label": "筠连县"
    }, {
      "value": "兴文县",
      "code": "644400",
      "label": "兴文县"
    }, {
      "value": "屏山县",
      "code": "645350",
      "label": "屏山县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "宜宾市"
  }, {
    "value": "广安市",
    "children": [{
      "value": "广安区",
      "code": "638001",
      "label": "广安区"
    }, {
      "value": "前锋区",
      "code": "638019",
      "label": "前锋区"
    }, {
      "value": "岳池县",
      "code": "638300",
      "label": "岳池县"
    }, {
      "value": "武胜县",
      "code": "638400",
      "label": "武胜县"
    }, {
      "value": "邻水县",
      "code": "638501",
      "label": "邻水县"
    }, {
      "value": "华蓥市",
      "code": "638601",
      "label": "华蓥市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "广安市"
  }, {
    "value": "达州市",
    "children": [{
      "value": "通川区",
      "code": "635001",
      "label": "通川区"
    }, {
      "value": "达川区",
      "code": "635711",
      "label": "达川区"
    }, {
      "value": "宣汉县",
      "code": "636150",
      "label": "宣汉县"
    }, {
      "value": "开江县",
      "code": "636250",
      "label": "开江县"
    }, {
      "value": "大竹县",
      "code": "635100",
      "label": "大竹县"
    }, {
      "value": "渠县",
      "code": "635200",
      "label": "渠县"
    }, {
      "value": "万源市",
      "code": "636350",
      "label": "万源市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "达州市"
  }, {
    "value": "雅安市",
    "children": [{
      "value": "雨城区",
      "code": "625004",
      "label": "雨城区"
    }, {
      "value": "名山区",
      "code": "625100",
      "label": "名山区"
    }, {
      "value": "荥经县",
      "code": "625200",
      "label": "荥经县"
    }, {
      "value": "汉源县",
      "code": "625300",
      "label": "汉源县"
    }, {
      "value": "石棉县",
      "code": "625400",
      "label": "石棉县"
    }, {
      "value": "天全县",
      "code": "625500",
      "label": "天全县"
    }, {
      "value": "芦山县",
      "code": "625600",
      "label": "芦山县"
    }, {
      "value": "宝兴县",
      "code": "625700",
      "label": "宝兴县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "雅安市"
  }, {
    "value": "巴中市",
    "children": [{
      "value": "巴州区",
      "code": "636001",
      "label": "巴州区"
    }, {
      "value": "恩阳区",
      "code": "636063",
      "label": "恩阳区"
    }, {
      "value": "通江县",
      "code": "636700",
      "label": "通江县"
    }, {
      "value": "南江县",
      "code": "635600",
      "label": "南江县"
    }, {
      "value": "平昌县",
      "code": "636400",
      "label": "平昌县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "巴中市"
  }, {
    "value": "资阳市",
    "children": [{
      "value": "雁江区",
      "code": "641301",
      "label": "雁江区"
    }, {
      "value": "安岳县",
      "code": "642350",
      "label": "安岳县"
    }, {
      "value": "乐至县",
      "code": "641500",
      "label": "乐至县"
    }, {
      "value": "简阳市",
      "code": "641400",
      "label": "简阳市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "资阳市"
  }, {
    "value": "阿坝藏族羌族自治州",
    "children": [{
      "value": "马尔康市",
      "code": "624001",
      "label": "马尔康市"
    }, {
      "value": "汶川县",
      "code": "623000",
      "label": "汶川县"
    }, {
      "value": "理县",
      "code": "623100",
      "label": "理县"
    }, {
      "value": "茂县",
      "code": "623200",
      "label": "茂县"
    }, {
      "value": "松潘县",
      "code": "623300",
      "label": "松潘县"
    }, {
      "value": "九寨沟县",
      "code": "623400",
      "label": "九寨沟县"
    }, {
      "value": "金川县",
      "code": "624100",
      "label": "金川县"
    }, {
      "value": "小金县",
      "code": "624200",
      "label": "小金县"
    }, {
      "value": "黑水县",
      "code": "623500",
      "label": "黑水县"
    }, {
      "value": "壤塘县",
      "code": "624301",
      "label": "壤塘县"
    }, {
      "value": "阿坝县",
      "code": "624600",
      "label": "阿坝县"
    }, {
      "value": "若尔盖县",
      "code": "624500",
      "label": "若尔盖县"
    }, {
      "value": "红原县",
      "code": "624400",
      "label": "红原县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "阿坝藏族羌族自治州"
  }, {
    "value": "甘孜藏族自治州",
    "children": [{
      "value": "康定市",
      "code": "626001",
      "label": "康定市"
    }, {
      "value": "泸定县",
      "code": "626100",
      "label": "泸定县"
    }, {
      "value": "丹巴县",
      "code": "626300",
      "label": "丹巴县"
    }, {
      "value": "九龙县",
      "code": "616200",
      "label": "九龙县"
    }, {
      "value": "雅江县",
      "code": "627450",
      "label": "雅江县"
    }, {
      "value": "道孚县",
      "code": "626400",
      "label": "道孚县"
    }, {
      "value": "炉霍县",
      "code": "626500",
      "label": "炉霍县"
    }, {
      "value": "甘孜县",
      "code": "626700",
      "label": "甘孜县"
    }, {
      "value": "新龙县",
      "code": "626800",
      "label": "新龙县"
    }, {
      "value": "德格县",
      "code": "627250",
      "label": "德格县"
    }, {
      "value": "白玉县",
      "code": "627150",
      "label": "白玉县"
    }, {
      "value": "石渠县",
      "code": "627351",
      "label": "石渠县"
    }, {
      "value": "色达县",
      "code": "626600",
      "label": "色达县"
    }, {
      "value": "理塘县",
      "code": "627551",
      "label": "理塘县"
    }, {
      "value": "巴塘县",
      "code": "627652",
      "label": "巴塘县"
    }, {
      "value": "乡城县",
      "code": "627850",
      "label": "乡城县"
    }, {
      "value": "稻城县",
      "code": "627751",
      "label": "稻城县"
    }, {
      "value": "得荣县",
      "code": "627951",
      "label": "得荣县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "甘孜藏族自治州"
  }, {
    "value": "凉山彝族自治州",
    "children": [{
      "value": "西昌市",
      "code": "615012",
      "label": "西昌市"
    }, {
      "value": "木里藏族自治县",
      "code": "615800",
      "label": "木里藏族自治县"
    }, {
      "value": "盐源县",
      "code": "615700",
      "label": "盐源县"
    }, {
      "value": "德昌县",
      "code": "615500",
      "label": "德昌县"
    }, {
      "value": "会理县",
      "code": "615100",
      "label": "会理县"
    }, {
      "value": "会东县",
      "code": "615200",
      "label": "会东县"
    }, {
      "value": "宁南县",
      "code": "615400",
      "label": "宁南县"
    }, {
      "value": "普格县",
      "code": "615300",
      "label": "普格县"
    }, {
      "value": "布拖县",
      "code": "615350",
      "label": "布拖县"
    }, {
      "value": "金阳县",
      "code": "616250",
      "label": "金阳县"
    }, {
      "value": "昭觉县",
      "code": "616150",
      "label": "昭觉县"
    }, {
      "value": "喜德县",
      "code": "616750",
      "label": "喜德县"
    }, {
      "value": "冕宁县",
      "code": "615600",
      "label": "冕宁县"
    }, {
      "value": "越西县",
      "code": "616650",
      "label": "越西县"
    }, {
      "value": "甘洛县",
      "code": "616850",
      "label": "甘洛县"
    }, {
      "value": "美姑县",
      "code": "616450",
      "label": "美姑县"
    }, {
      "value": "雷波县",
      "code": "616550",
      "label": "雷波县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "凉山彝族自治州"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "四川省",
  "label": "四川省"
}, {
  "children": [{
    "value": "贵阳市",
    "children": [{
      "value": "南明区",
      "code": "550002",
      "label": "南明区"
    }, {
      "value": "云岩区",
      "code": "550001",
      "label": "云岩区"
    }, {
      "value": "花溪区",
      "code": "550025",
      "label": "花溪区"
    }, {
      "value": "乌当区",
      "code": "550018",
      "label": "乌当区"
    }, {
      "value": "白云区",
      "code": "550014",
      "label": "白云区"
    }, {
      "value": "观山湖区",
      "code": "551401",
      "label": "观山湖区"
    }, {
      "value": "开阳县",
      "code": "550300",
      "label": "开阳县"
    }, {
      "value": "息烽县",
      "code": "551100",
      "label": "息烽县"
    }, {
      "value": "修文县",
      "code": "550200",
      "label": "修文县"
    }, {
      "value": "清镇市",
      "code": "551400",
      "label": "清镇市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "贵阳市"
  }, {
    "value": "六盘水市",
    "children": [{
      "value": "钟山区",
      "code": "553006",
      "label": "钟山区"
    }, {
      "value": "六枝特区",
      "code": "553400",
      "label": "六枝特区"
    }, {
      "value": "水城县",
      "code": "553014",
      "label": "水城县"
    }, {
      "value": "盘县",
      "code": "553500",
      "label": "盘县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "六盘水市"
  }, {
    "value": "遵义市",
    "children": [{
      "value": "红花岗区",
      "code": "563004",
      "label": "红花岗区"
    }, {
      "value": "汇川区",
      "code": "563114",
      "label": "汇川区"
    }, {
      "value": "遵义县",
      "code": "563100",
      "label": "遵义县"
    }, {
      "value": "桐梓县",
      "code": "563200",
      "label": "桐梓县"
    }, {
      "value": "绥阳县",
      "code": "563300",
      "label": "绥阳县"
    }, {
      "value": "正安县",
      "code": "563400",
      "label": "正安县"
    }, {
      "value": "道真仡佬族苗族自治县",
      "code": "563500",
      "label": "道真仡佬族苗族自治县"
    }, {
      "value": "务川仡佬族苗族自治县",
      "code": "564300",
      "label": "务川仡佬族苗族自治县"
    }, {
      "value": "凤冈县",
      "code": "564200",
      "label": "凤冈县"
    }, {
      "value": "湄潭县",
      "code": "564100",
      "label": "湄潭县"
    }, {
      "value": "余庆县",
      "code": "564400",
      "label": "余庆县"
    }, {
      "value": "习水县",
      "code": "564600",
      "label": "习水县"
    }, {
      "value": "赤水市",
      "code": "564700",
      "label": "赤水市"
    }, {
      "value": "仁怀市",
      "code": "564500",
      "label": "仁怀市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "遵义市"
  }, {
    "value": "安顺市",
    "children": [{
      "value": "西秀区",
      "code": "561002",
      "label": "西秀区"
    }, {
      "value": "平坝区",
      "code": "561100",
      "label": "平坝区"
    }, {
      "value": "普定县",
      "code": "562100",
      "label": "普定县"
    }, {
      "value": "镇宁布依族苗族自治县",
      "code": "561200",
      "label": "镇宁布依族苗族自治县"
    }, {
      "value": "关岭布依族苗族自治县",
      "code": "561300",
      "label": "关岭布依族苗族自治县"
    }, {
      "value": "紫云苗族布依族自治县",
      "code": "550800",
      "label": "紫云苗族布依族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "安顺市"
  }, {
    "value": "毕节市",
    "children": [{
      "value": "七星关区",
      "code": "551701",
      "label": "七星关区"
    }, {
      "value": "大方县",
      "code": "551600",
      "label": "大方县"
    }, {
      "value": "黔西县",
      "code": "551500",
      "label": "黔西县"
    }, {
      "value": "金沙县",
      "code": "551800",
      "label": "金沙县"
    }, {
      "value": "织金县",
      "code": "552100",
      "label": "织金县"
    }, {
      "value": "纳雍县",
      "code": "553300",
      "label": "纳雍县"
    }, {
      "value": "威宁彝族回族苗族自治县",
      "code": "553100",
      "label": "威宁彝族回族苗族自治县"
    }, {
      "value": "赫章县",
      "code": "553200",
      "label": "赫章县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "毕节市"
  }, {
    "value": "铜仁市",
    "children": [{
      "value": "碧江区",
      "code": "554301",
      "label": "碧江区"
    }, {
      "value": "万山区",
      "code": "554200",
      "label": "万山区"
    }, {
      "value": "江口县",
      "code": "554400",
      "label": "江口县"
    }, {
      "value": "玉屏侗族自治县",
      "code": "554000",
      "label": "玉屏侗族自治县"
    }, {
      "value": "石阡县",
      "code": "555100",
      "label": "石阡县"
    }, {
      "value": "思南县",
      "code": "565100",
      "label": "思南县"
    }, {
      "value": "印江土家族苗族自治县",
      "code": "555200",
      "label": "印江土家族苗族自治县"
    }, {
      "value": "德江县",
      "code": "565200",
      "label": "德江县"
    }, {
      "value": "沿河土家族自治县",
      "code": "565300",
      "label": "沿河土家族自治县"
    }, {
      "value": "松桃苗族自治县",
      "code": "554100",
      "label": "松桃苗族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "铜仁市"
  }, {
    "value": "黔西南布依族苗族自治州",
    "children": [{
      "value": "兴义市",
      "code": "562401",
      "label": "兴义市"
    }, {
      "value": "兴仁县",
      "code": "562300",
      "label": "兴仁县"
    }, {
      "value": "普安县",
      "code": "561500",
      "label": "普安县"
    }, {
      "value": "晴隆县",
      "code": "561400",
      "label": "晴隆县"
    }, {
      "value": "贞丰县",
      "code": "562200",
      "label": "贞丰县"
    }, {
      "value": "望谟县",
      "code": "552300",
      "label": "望谟县"
    }, {
      "value": "册亨县",
      "code": "552200",
      "label": "册亨县"
    }, {
      "value": "安龙县",
      "code": "552400",
      "label": "安龙县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "黔西南布依族苗族自治州"
  }, {
    "value": "黔东南苗族侗族自治州",
    "children": [{
      "value": "凯里市",
      "code": "556003",
      "label": "凯里市"
    }, {
      "value": "黄平县",
      "code": "556100",
      "label": "黄平县"
    }, {
      "value": "施秉县",
      "code": "556200",
      "label": "施秉县"
    }, {
      "value": "三穗县",
      "code": "556500",
      "label": "三穗县"
    }, {
      "value": "镇远县",
      "code": "557700",
      "label": "镇远县"
    }, {
      "value": "岑巩县",
      "code": "557800",
      "label": "岑巩县"
    }, {
      "value": "天柱县",
      "code": "556600",
      "label": "天柱县"
    }, {
      "value": "锦屏县",
      "code": "556700",
      "label": "锦屏县"
    }, {
      "value": "剑河县",
      "code": "556400",
      "label": "剑河县"
    }, {
      "value": "台江县",
      "code": "556300",
      "label": "台江县"
    }, {
      "value": "黎平县",
      "code": "557300",
      "label": "黎平县"
    }, {
      "value": "榕江县",
      "code": "557200",
      "label": "榕江县"
    }, {
      "value": "从江县",
      "code": "557400",
      "label": "从江县"
    }, {
      "value": "雷山县",
      "code": "557100",
      "label": "雷山县"
    }, {
      "value": "麻江县",
      "code": "557600",
      "label": "麻江县"
    }, {
      "value": "丹寨县",
      "code": "557500",
      "label": "丹寨县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "黔东南苗族侗族自治州"
  }, {
    "value": "黔南布依族苗族自治州",
    "children": [{
      "value": "都匀市",
      "code": "558001",
      "label": "都匀市"
    }, {
      "value": "福泉市",
      "code": "550500",
      "label": "福泉市"
    }, {
      "value": "荔波县",
      "code": "558400",
      "label": "荔波县"
    }, {
      "value": "贵定县",
      "code": "551300",
      "label": "贵定县"
    }, {
      "value": "瓮安县",
      "code": "550400",
      "label": "瓮安县"
    }, {
      "value": "独山县",
      "code": "558200",
      "label": "独山县"
    }, {
      "value": "平塘县",
      "code": "558300",
      "label": "平塘县"
    }, {
      "value": "罗甸县",
      "code": "550100",
      "label": "罗甸县"
    }, {
      "value": "长顺县",
      "code": "550700",
      "label": "长顺县"
    }, {
      "value": "龙里县",
      "code": "551200",
      "label": "龙里县"
    }, {
      "value": "惠水县",
      "code": "550600",
      "label": "惠水县"
    }, {
      "value": "三都水族自治��",
      "code": "558100",
      "label": "三都水族自治��"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "黔南布依族苗族自治州"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "贵州省",
  "label": "贵州省"
}, {
  "children": [{
    "value": "昆明市",
    "children": [{
      "value": "五华区",
      "code": "650021",
      "label": "五华区"
    }, {
      "value": "盘龙区",
      "code": "650051",
      "label": "盘龙区"
    }, {
      "value": "官渡区",
      "code": "650011",
      "label": "官渡区"
    }, {
      "value": "西山区",
      "code": "650034",
      "label": "西山区"
    }, {
      "value": "东川区",
      "code": "654100",
      "label": "东川区"
    }, {
      "value": "呈贡区",
      "code": "650500",
      "label": "呈贡区"
    }, {
      "value": "晋宁县",
      "code": "650600",
      "label": "晋宁县"
    }, {
      "value": "富民县",
      "code": "650400",
      "label": "富民县"
    }, {
      "value": "宜良县",
      "code": "652100",
      "label": "宜良县"
    }, {
      "value": "石林彝族自治县",
      "code": "652200",
      "label": "石林彝族自治县"
    }, {
      "value": "嵩明县",
      "code": "651700",
      "label": "嵩明县"
    }, {
      "value": "禄劝彝族苗族自治县",
      "code": "651500",
      "label": "禄劝彝族苗族自治县"
    }, {
      "value": "寻甸回族彝族自治县",
      "code": "655200",
      "label": "寻甸回族彝族自治县"
    }, {
      "value": "安宁市",
      "code": "650300",
      "label": "安宁市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "昆明市"
  }, {
    "value": "曲靖市",
    "children": [{
      "value": "麒麟区",
      "code": "655002",
      "label": "麒麟区"
    }, {
      "value": "马龙县",
      "code": "655100",
      "label": "马龙县"
    }, {
      "value": "陆良县",
      "code": "655600",
      "label": "陆良县"
    }, {
      "value": "师宗县",
      "code": "655700",
      "label": "师宗县"
    }, {
      "value": "罗平县",
      "code": "655800",
      "label": "罗平县"
    }, {
      "value": "富源县",
      "code": "655501",
      "label": "富源县"
    }, {
      "value": "会泽县",
      "code": "654200",
      "label": "会泽县"
    }, {
      "value": "沾益县",
      "code": "655038",
      "label": "沾益县"
    }, {
      "value": "宣威市",
      "code": "655400",
      "label": "宣威市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "曲靖市"
  }, {
    "value": "玉溪市",
    "children": [{
      "value": "红塔区",
      "code": "653101",
      "label": "红塔区"
    }, {
      "value": "江川区",
      "code": "652600",
      "label": "江川区"
    }, {
      "value": "澄江县",
      "code": "652500",
      "label": "澄江县"
    }, {
      "value": "通海县",
      "code": "652700",
      "label": "通海县"
    }, {
      "value": "华宁县",
      "code": "652800",
      "label": "华宁县"
    }, {
      "value": "易门县",
      "code": "651100",
      "label": "易门县"
    }, {
      "value": "峨山彝族自治县",
      "code": "653200",
      "label": "峨山彝族自治县"
    }, {
      "value": "新平彝族傣族自治县",
      "code": "653400",
      "label": "新平彝族傣族自治县"
    }, {
      "value": "元江哈尼族彝族傣族自治县",
      "code": "653300",
      "label": "元江哈尼族彝族傣族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "玉溪市"
  }, {
    "value": "保山市",
    "children": [{
      "value": "隆阳区",
      "code": "678001",
      "label": "隆阳区"
    }, {
      "value": "施甸县",
      "code": "678200",
      "label": "施甸县"
    }, {
      "value": "龙陵县",
      "code": "678300",
      "label": "龙陵县"
    }, {
      "value": "昌宁县",
      "code": "678100",
      "label": "昌宁县"
    }, {
      "value": "腾冲市",
      "code": "679100",
      "label": "腾冲市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "保山市"
  }, {
    "value": "昭通市",
    "children": [{
      "value": "昭阳区",
      "code": "657001",
      "label": "昭阳区"
    }, {
      "value": "鲁甸县",
      "code": "657100",
      "label": "鲁甸县"
    }, {
      "value": "巧家县",
      "code": "654600",
      "label": "巧家县"
    }, {
      "value": "盐津县",
      "code": "657500",
      "label": "盐津县"
    }, {
      "value": "大关县",
      "code": "657400",
      "label": "大关县"
    }, {
      "value": "永善县",
      "code": "657300",
      "label": "永善县"
    }, {
      "value": "绥江县",
      "code": "657700",
      "label": "绥江县"
    }, {
      "value": "镇雄县",
      "code": "657200",
      "label": "镇雄县"
    }, {
      "value": "彝良县",
      "code": "657600",
      "label": "彝良县"
    }, {
      "value": "威信县",
      "code": "657900",
      "label": "威信县"
    }, {
      "value": "水富县",
      "code": "657800",
      "label": "水富县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "昭通市"
  }, {
    "value": "丽江市",
    "children": [{
      "value": "古城区",
      "code": "674102",
      "label": "古城区"
    }, {
      "value": "玉龙纳西族自治县",
      "code": "674108",
      "label": "玉龙纳西族自治县"
    }, {
      "value": "永胜县",
      "code": "674200",
      "label": "永胜县"
    }, {
      "value": "华坪县",
      "code": "674800",
      "label": "华坪县"
    }, {
      "value": "宁蒗彝族自治县",
      "code": "674300",
      "label": "宁蒗彝族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "丽江市"
  }, {
    "value": "普洱市",
    "children": [{
      "value": "思茅区",
      "code": "665001",
      "label": "思茅区"
    }, {
      "value": "宁洱哈尼族彝族自治县",
      "code": "665101",
      "label": "宁洱哈尼族彝族自治县"
    }, {
      "value": "墨江哈尼族自治县",
      "code": "654800",
      "label": "墨江哈尼族自治县"
    }, {
      "value": "景东彝族自治县",
      "code": "676200",
      "label": "景东彝族自治县"
    }, {
      "value": "景谷傣族彝族自治县",
      "code": "666400",
      "label": "景谷傣族彝族自治县"
    }, {
      "value": "镇沅彝族哈尼族拉祜族自治县",
      "code": "666500",
      "label": "镇沅彝族哈尼族拉祜族自治县"
    }, {
      "value": "江城哈尼族彝族自治县",
      "code": "665900",
      "label": "江城哈尼族彝族自治县"
    }, {
      "value": "孟连傣族拉祜族佤族自治县",
      "code": "665800",
      "label": "孟连傣族拉祜族佤族自治县"
    }, {
      "value": "澜沧拉祜族自治县",
      "code": "665600",
      "label": "澜沧拉祜族自治县"
    }, {
      "value": "西盟佤族自治县",
      "code": "665700",
      "label": "西盟佤族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "普洱市"
  }, {
    "value": "临沧市",
    "children": [{
      "value": "临翔区",
      "code": "677001",
      "label": "临翔区"
    }, {
      "value": "凤庆县",
      "code": "675900",
      "label": "凤庆县"
    }, {
      "value": "云县",
      "code": "675800",
      "label": "云县"
    }, {
      "value": "永德县",
      "code": "677600",
      "label": "永德县"
    }, {
      "value": "镇康县",
      "code": "677700",
      "label": "镇康县"
    }, {
      "value": "双江拉祜族佤族布朗族傣族自治县",
      "code": "677300",
      "label": "双江拉祜族佤族布朗族傣族自治县"
    }, {
      "value": "耿马傣族佤族自治县",
      "code": "677500",
      "label": "耿马傣族佤族自治县"
    }, {
      "value": "沧源佤族自治县",
      "code": "677400",
      "label": "沧源佤族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "临沧市"
  }, {
    "value": "楚雄彝族自治州",
    "children": [{
      "value": "楚雄市",
      "code": "675002",
      "label": "楚雄市"
    }, {
      "value": "双柏县",
      "code": "675100",
      "label": "双柏县"
    }, {
      "value": "牟定县",
      "code": "675500",
      "label": "牟定县"
    }, {
      "value": "南华县",
      "code": "675200",
      "label": "南华县"
    }, {
      "value": "姚安县",
      "code": "675300",
      "label": "姚安县"
    }, {
      "value": "大姚县",
      "code": "675400",
      "label": "大姚县"
    }, {
      "value": "永仁县",
      "code": "651400",
      "label": "永仁县"
    }, {
      "value": "元谋县",
      "code": "651300",
      "label": "元谋县"
    }, {
      "value": "武定县",
      "code": "651600",
      "label": "武定县"
    }, {
      "value": "禄丰县",
      "code": "651200",
      "label": "禄丰县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "楚雄彝族自治州"
  }, {
    "value": "红河哈尼族彝族自治州",
    "children": [{
      "value": "个旧市",
      "code": "661000",
      "label": "个旧市"
    }, {
      "value": "开远市",
      "code": "661600",
      "label": "开远市"
    }, {
      "value": "蒙自市",
      "code": "661100",
      "label": "蒙自市"
    }, {
      "value": "弥勒市",
      "code": "652300",
      "label": "弥勒市"
    }, {
      "value": "屏边苗族自治县",
      "code": "661200",
      "label": "屏边苗族自治县"
    }, {
      "value": "建水县",
      "code": "654300",
      "label": "建水县"
    }, {
      "value": "石屏县",
      "code": "662200",
      "label": "石屏县"
    }, {
      "value": "泸西县",
      "code": "652400",
      "label": "泸西县"
    }, {
      "value": "元阳县",
      "code": "662400",
      "label": "元阳县"
    }, {
      "value": "红河县",
      "code": "654400",
      "label": "红河县"
    }, {
      "value": "金平苗族瑶族傣族自治县",
      "code": "661500",
      "label": "金平苗族瑶族傣族自治县"
    }, {
      "value": "绿春县",
      "code": "662500",
      "label": "绿春县"
    }, {
      "value": "河口瑶族自治县",
      "code": "661300",
      "label": "河口瑶族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "红河哈尼族彝族自治州"
  }, {
    "value": "文山壮族苗族自治州",
    "children": [{
      "value": "文山市",
      "code": "663001",
      "label": "文山市"
    }, {
      "value": "砚山县",
      "code": "663100",
      "label": "砚山县"
    }, {
      "value": "西畴县",
      "code": "663500",
      "label": "西畴县"
    }, {
      "value": "麻栗坡县",
      "code": "663600",
      "label": "麻栗坡县"
    }, {
      "value": "马关县",
      "code": "663700",
      "label": "马关县"
    }, {
      "value": "丘北县",
      "code": "663200",
      "label": "丘北县"
    }, {
      "value": "广南县",
      "code": "663300",
      "label": "广南县"
    }, {
      "value": "富宁县",
      "code": "663400",
      "label": "富宁县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "文山壮族苗族自治州"
  }, {
    "value": "西双版纳傣族自治州",
    "children": [{
      "value": "景洪市",
      "code": "666101",
      "label": "景洪市"
    }, {
      "value": "勐海县",
      "code": "666200",
      "label": "勐海县"
    }, {
      "value": "勐腊县",
      "code": "666300",
      "label": "勐腊县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "西双版纳傣族自治州"
  }, {
    "value": "大理白族自治州",
    "children": [{
      "value": "大理市",
      "code": "671001",
      "label": "大理市"
    }, {
      "value": "漾濞彝族自治县",
      "code": "672500",
      "label": "漾濞彝族自治县"
    }, {
      "value": "祥云县",
      "code": "672100",
      "label": "祥云县"
    }, {
      "value": "宾川县",
      "code": "671600",
      "label": "宾川县"
    }, {
      "value": "弥渡县",
      "code": "675600",
      "label": "弥渡县"
    }, {
      "value": "南涧彝族自治县",
      "code": "675700",
      "label": "南涧彝族自治县"
    }, {
      "value": "巍山彝族回族自治县",
      "code": "672400",
      "label": "巍山彝族回族自治县"
    }, {
      "value": "永平县",
      "code": "672600",
      "label": "永平县"
    }, {
      "value": "云龙县",
      "code": "672700",
      "label": "云龙县"
    }, {
      "value": "洱源县",
      "code": "671200",
      "label": "洱源县"
    }, {
      "value": "剑川县",
      "code": "671300",
      "label": "剑川县"
    }, {
      "value": "鹤庆县",
      "code": "671500",
      "label": "鹤庆县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "大理白族自治州"
  }, {
    "value": "德宏傣族景颇族自治州",
    "children": [{
      "value": "瑞丽市",
      "code": "678599",
      "label": "瑞丽市"
    }, {
      "value": "芒市",
      "code": "678401",
      "label": "芒市"
    }, {
      "value": "梁河县",
      "code": "679200",
      "label": "梁河县"
    }, {
      "value": "盈江县",
      "code": "679300",
      "label": "盈江县"
    }, {
      "value": "陇川县",
      "code": "678700",
      "label": "陇川县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "德宏傣族景颇族自治州"
  }, {
    "value": "怒江傈僳族自治州",
    "children": [{
      "value": "泸水县",
      "code": "673199",
      "label": "泸水县"
    }, {
      "value": "福贡县",
      "code": "673400",
      "label": "福贡县"
    }, {
      "value": "贡山独龙族怒族自治县",
      "code": "673500",
      "label": "贡山独龙族怒族自治县"
    }, {
      "value": "兰坪白族普米族自治县",
      "code": "671400",
      "label": "兰坪白族普米族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "怒江傈僳族自治州"
  }, {
    "value": "迪庆藏族自治州",
    "children": [{
      "value": "香格里拉市",
      "code": "674401",
      "label": "香格里拉市"
    }, {
      "value": "德钦县",
      "code": "674500",
      "label": "德钦县"
    }, {
      "value": "维西傈僳族自治县",
      "code": "674600",
      "label": "维西傈僳族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "迪庆藏族自治州"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "云南省",
  "label": "云南省"
}, {
  "children": [{
    "value": "拉萨市",
    "children": [{
      "value": "城关区",
      "code": "850012",
      "label": "城关区"
    }, {
      "value": "堆龙德庆区",
      "code": "851400",
      "label": "堆龙德庆区"
    }, {
      "value": "林周县",
      "code": "851611",
      "label": "林周县"
    }, {
      "value": "当雄县",
      "code": "851500",
      "label": "当雄县"
    }, {
      "value": "尼木县",
      "code": "851311",
      "label": "尼木县"
    }, {
      "value": "曲水县",
      "code": "850600",
      "label": "曲水县"
    }, {
      "value": "达孜县",
      "code": "850100",
      "label": "达孜县"
    }, {
      "value": "墨竹工卡县",
      "code": "850200",
      "label": "墨竹工卡县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "拉萨市"
  }, {
    "value": "日喀则市",
    "children": [{
      "value": "桑珠孜区",
      "code": "857003",
      "label": "桑珠孜区"
    }, {
      "value": "南木林县",
      "code": "857100",
      "label": "南木林县"
    }, {
      "value": "江孜县",
      "code": "857400",
      "label": "江孜县"
    }, {
      "value": "定日县",
      "code": "858200",
      "label": "定日县"
    }, {
      "value": "萨迦县",
      "code": "857800",
      "label": "萨迦县"
    }, {
      "value": "拉孜县",
      "code": "858100",
      "label": "拉孜县"
    }, {
      "value": "昂仁县",
      "code": "858500",
      "label": "昂仁县"
    }, {
      "value": "谢通门县",
      "code": "858900",
      "label": "谢通门县"
    }, {
      "value": "白朗县",
      "code": "857300",
      "label": "白朗县"
    }, {
      "value": "仁布县",
      "code": "857200",
      "label": "仁布县"
    }, {
      "value": "康马县",
      "code": "857500",
      "label": "康马县"
    }, {
      "value": "定结县",
      "code": "857900",
      "label": "定结县"
    }, {
      "value": "仲巴县",
      "code": "858800",
      "label": "仲巴县"
    }, {
      "value": "亚东县",
      "code": "857600",
      "label": "亚东县"
    }, {
      "value": "吉隆县",
      "code": "858700",
      "label": "吉隆县"
    }, {
      "value": "聂拉木县",
      "code": "858300",
      "label": "聂拉木县"
    }, {
      "value": "萨嘎县",
      "code": "858600",
      "label": "萨嘎县"
    }, {
      "value": "岗巴县",
      "code": "857700",
      "label": "岗巴县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "日喀则市"
  }, {
    "value": "昌都市",
    "children": [{
      "value": "卡若区",
      "code": "854071",
      "label": "卡若区"
    }, {
      "value": "江达县",
      "code": "854100",
      "label": "江达县"
    }, {
      "value": "贡觉县",
      "code": "854200",
      "label": "贡觉县"
    }, {
      "value": "类乌齐县",
      "code": "855600",
      "label": "类乌齐县"
    }, {
      "value": "丁青县",
      "code": "855700",
      "label": "丁青县"
    }, {
      "value": "察雅县",
      "code": "854300",
      "label": "察雅县"
    }, {
      "value": "八宿县",
      "code": "854600",
      "label": "八宿县"
    }, {
      "value": "左贡县",
      "code": "854400",
      "label": "左贡县"
    }, {
      "value": "芒康县",
      "code": "854500",
      "label": "芒康县"
    }, {
      "value": "洛隆县",
      "code": "855400",
      "label": "洛隆县"
    }, {
      "value": "边坝县",
      "code": "855500",
      "label": "边坝县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "昌都市"
  }, {
    "value": "林芝市",
    "children": [{
      "value": "巴宜区",
      "code": "860018",
      "label": "巴宜区"
    }, {
      "value": "工布江达县",
      "code": "860200",
      "label": "工布江达县"
    }, {
      "value": "米林县",
      "code": "860500",
      "label": "米林县"
    }, {
      "value": "墨脱县",
      "code": "860700",
      "label": "墨脱县"
    }, {
      "value": "波密县",
      "code": "860300",
      "label": "波密县"
    }, {
      "value": "察隅县",
      "code": "860600",
      "label": "察隅县"
    }, {
      "value": "朗县",
      "code": "860400",
      "label": "朗县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "林芝市"
  }, {
    "value": "山南地区",
    "children": [{
      "value": "乃东县",
      "code": "856100",
      "label": "乃东县"
    }, {
      "value": "扎囊县",
      "code": "850800",
      "label": "扎囊县"
    }, {
      "value": "贡嘎县",
      "code": "850700",
      "label": "贡嘎县"
    }, {
      "value": "桑日县",
      "code": "856200",
      "label": "桑日县"
    }, {
      "value": "琼结县",
      "code": "856800",
      "label": "琼结县"
    }, {
      "value": "曲松县",
      "code": "856300",
      "label": "曲松县"
    }, {
      "value": "措美县",
      "code": "856900",
      "label": "措美县"
    }, {
      "value": "洛扎县",
      "code": "851200",
      "label": "洛扎县"
    }, {
      "value": "加查县",
      "code": "856400",
      "label": "加查县"
    }, {
      "value": "隆子县",
      "code": "856600",
      "label": "隆子县"
    }, {
      "value": "错那县",
      "code": "856700",
      "label": "错那县"
    }, {
      "value": "浪卡子县",
      "code": "851100",
      "label": "浪卡子县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "山南地区"
  }, {
    "value": "那曲地区",
    "children": [{
      "value": "那曲县",
      "code": "852014",
      "label": "那曲县"
    }, {
      "value": "嘉黎县",
      "code": "852400",
      "label": "嘉黎县"
    }, {
      "value": "比如县",
      "code": "852300",
      "label": "比如县"
    }, {
      "value": "聂荣县",
      "code": "853500",
      "label": "聂荣县"
    }, {
      "value": "安多县",
      "code": "853400",
      "label": "安多县"
    }, {
      "value": "申扎县",
      "code": "853100",
      "label": "申扎县"
    }, {
      "value": "索县",
      "code": "852200",
      "label": "索县"
    }, {
      "value": "班戈县",
      "code": "852500",
      "label": "班戈县"
    }, {
      "value": "巴青县",
      "code": "852100",
      "label": "巴青县"
    }, {
      "value": "尼玛县",
      "code": "853200",
      "label": "尼玛县"
    }, {
      "value": "双湖县",
      "code": "853312",
      "label": "双湖县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "那曲地区"
  }, {
    "value": "阿里地区",
    "children": [{
      "value": "普兰县",
      "code": "859500",
      "label": "普兰县"
    }, {
      "value": "札达县",
      "code": "859600",
      "label": "札达县"
    }, {
      "value": "噶尔县",
      "code": "859401",
      "label": "噶尔县"
    }, {
      "value": "日土县",
      "code": "859700",
      "label": "日土县"
    }, {
      "value": "革吉县",
      "code": "859100",
      "label": "革吉县"
    }, {
      "value": "改则县",
      "code": "859200",
      "label": "改则县"
    }, {
      "value": "措勤县",
      "code": "859300",
      "label": "措勤县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "阿里地区"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "西藏自治区",
  "label": "西藏自治区"
}, {
  "children": [{
    "value": "西安市",
    "children": [{
      "value": "新城区",
      "code": "710005",
      "label": "新城区"
    }, {
      "value": "碑林区",
      "code": "710001",
      "label": "碑林区"
    }, {
      "value": "莲湖区",
      "code": "710007",
      "label": "莲湖区"
    }, {
      "value": "灞桥区",
      "code": "710024",
      "label": "灞桥区"
    }, {
      "value": "未央区",
      "code": "710018",
      "label": "未央区"
    }, {
      "value": "雁塔区",
      "code": "710063",
      "label": "雁塔区"
    }, {
      "value": "阎良区",
      "code": "710089",
      "label": "阎良区"
    }, {
      "value": "临潼区",
      "code": "710600",
      "label": "临潼区"
    }, {
      "value": "长安区",
      "code": "710100",
      "label": "长安区"
    }, {
      "value": "高陵区",
      "code": "710200",
      "label": "高陵区"
    }, {
      "value": "蓝田县",
      "code": "710500",
      "label": "蓝田县"
    }, {
      "value": "周至县",
      "code": "710400",
      "label": "周至县"
    }, {
      "value": "户县",
      "code": "710300",
      "label": "户县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "西安市"
  }, {
    "value": "铜川市",
    "children": [{
      "value": "王益区",
      "code": "727001",
      "label": "王益区"
    }, {
      "value": "印台区",
      "code": "727002",
      "label": "印台区"
    }, {
      "value": "耀州区",
      "code": "727100",
      "label": "耀州区"
    }, {
      "value": "宜君县",
      "code": "727200",
      "label": "宜君县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "铜川市"
  }, {
    "value": "宝鸡市",
    "children": [{
      "value": "渭滨区",
      "code": "721006",
      "label": "渭滨区"
    }, {
      "value": "金台区",
      "code": "721001",
      "label": "金台区"
    }, {
      "value": "陈仓区",
      "code": "721300",
      "label": "陈仓区"
    }, {
      "value": "凤翔县",
      "code": "721400",
      "label": "凤翔县"
    }, {
      "value": "岐山县",
      "code": "722400",
      "label": "岐山县"
    }, {
      "value": "扶风县",
      "code": "722200",
      "label": "扶风县"
    }, {
      "value": "眉县",
      "code": "722300",
      "label": "眉县"
    }, {
      "value": "陇县",
      "code": "721200",
      "label": "陇县"
    }, {
      "value": "千阳县",
      "code": "721100",
      "label": "千阳县"
    }, {
      "value": "麟游县",
      "code": "721500",
      "label": "麟游县"
    }, {
      "value": "凤县",
      "code": "721700",
      "label": "凤县"
    }, {
      "value": "太白县",
      "code": "721600",
      "label": "太白县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "宝鸡市"
  }, {
    "value": "咸阳市",
    "children": [{
      "value": "秦都区",
      "code": "712021",
      "label": "秦都区"
    }, {
      "value": "杨陵区",
      "code": "712100",
      "label": "杨陵区"
    }, {
      "value": "渭城区",
      "code": "712034",
      "label": "渭城区"
    }, {
      "value": "三原县",
      "code": "713800",
      "label": "三原县"
    }, {
      "value": "泾阳县",
      "code": "713700",
      "label": "泾阳县"
    }, {
      "value": "乾县",
      "code": "713300",
      "label": "乾县"
    }, {
      "value": "礼泉县",
      "code": "713200",
      "label": "礼泉县"
    }, {
      "value": "永寿县",
      "code": "713400",
      "label": "永寿县"
    }, {
      "value": "彬县",
      "code": "713500",
      "label": "彬县"
    }, {
      "value": "长武县",
      "code": "713600",
      "label": "长武县"
    }, {
      "value": "旬邑县",
      "code": "711300",
      "label": "旬邑县"
    }, {
      "value": "淳化县",
      "code": "711200",
      "label": "淳化县"
    }, {
      "value": "武功县",
      "code": "712200",
      "label": "武功县"
    }, {
      "value": "兴平市",
      "code": "713100",
      "label": "兴平市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "咸阳市"
  }, {
    "value": "渭南市",
    "children": [{
      "value": "临渭区",
      "code": "714001",
      "label": "临渭区"
    }, {
      "value": "华州区",
      "code": "714100",
      "label": "华州区"
    }, {
      "value": "潼关县",
      "code": "714300",
      "label": "潼关县"
    }, {
      "value": "大荔县",
      "code": "715100",
      "label": "大荔县"
    }, {
      "value": "合阳县",
      "code": "715300",
      "label": "合阳县"
    }, {
      "value": "澄城县",
      "code": "041520",
      "label": "澄城县"
    }, {
      "value": "蒲城县",
      "code": "715500",
      "label": "蒲城县"
    }, {
      "value": "白水县",
      "code": "715600",
      "label": "白水县"
    }, {
      "value": "富平县",
      "code": "711700",
      "label": "富平县"
    }, {
      "value": "韩城市",
      "code": "715400",
      "label": "韩城市"
    }, {
      "value": "华阴市",
      "code": "714200",
      "label": "华阴市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "渭南市"
  }, {
    "value": "延安市",
    "children": [{
      "value": "宝塔区",
      "code": "716001",
      "label": "宝塔区"
    }, {
      "value": "延长县",
      "code": "717100",
      "label": "延长县"
    }, {
      "value": "延川县",
      "code": "717200",
      "label": "延川县"
    }, {
      "value": "子长县",
      "code": "717300",
      "label": "子长县"
    }, {
      "value": "安塞县",
      "code": "717400",
      "label": "安塞县"
    }, {
      "value": "志丹县",
      "code": "717500",
      "label": "志丹县"
    }, {
      "value": "吴起县",
      "code": "717600",
      "label": "吴起县"
    }, {
      "value": "甘泉县",
      "code": "716100",
      "label": "甘泉县"
    }, {
      "value": "富县",
      "code": "727500",
      "label": "富县"
    }, {
      "value": "洛川县",
      "code": "727400",
      "label": "洛川县"
    }, {
      "value": "宜川县",
      "code": "716200",
      "label": "宜川县"
    }, {
      "value": "黄龙县",
      "code": "715700",
      "label": "黄龙县"
    }, {
      "value": "黄陵县",
      "code": "727300",
      "label": "黄陵县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "延安市"
  }, {
    "value": "汉中市",
    "children": [{
      "value": "汉台区",
      "code": "723002",
      "label": "汉台区"
    }, {
      "value": "南郑县",
      "code": "723100",
      "label": "南郑县"
    }, {
      "value": "城固县",
      "code": "723200",
      "label": "城固县"
    }, {
      "value": "洋县",
      "code": "723300",
      "label": "洋县"
    }, {
      "value": "西乡县",
      "code": "723500",
      "label": "西乡县"
    }, {
      "value": "勉县",
      "code": "724200",
      "label": "勉县"
    }, {
      "value": "宁强县",
      "code": "724400",
      "label": "宁强县"
    }, {
      "value": "略阳县",
      "code": "724300",
      "label": "略阳县"
    }, {
      "value": "镇巴县",
      "code": "723600",
      "label": "镇巴县"
    }, {
      "value": "留坝县",
      "code": "724100",
      "label": "留坝县"
    }, {
      "value": "佛坪县",
      "code": "723400",
      "label": "佛坪县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "汉中市"
  }, {
    "value": "榆林市",
    "children": [{
      "value": "榆阳区",
      "code": "719001",
      "label": "榆阳区"
    }, {
      "value": "横山区",
      "code": "719101",
      "label": "横山区"
    }, {
      "value": "神木县",
      "code": "719300",
      "label": "神木县"
    }, {
      "value": "府谷县",
      "code": "719400",
      "label": "府谷县"
    }, {
      "value": "靖边县",
      "code": "718500",
      "label": "靖边县"
    }, {
      "value": "定边县",
      "code": "718600",
      "label": "定边县"
    }, {
      "value": "绥德县",
      "code": "718000",
      "label": "绥德县"
    }, {
      "value": "米脂县",
      "code": "718100",
      "label": "米脂县"
    }, {
      "value": "佳县",
      "code": "719201",
      "label": "佳县"
    }, {
      "value": "吴堡县",
      "code": "718200",
      "label": "吴堡县"
    }, {
      "value": "清涧县",
      "code": "718300",
      "label": "清涧县"
    }, {
      "value": "子洲县",
      "code": "718400",
      "label": "子洲县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "榆林市"
  }, {
    "value": "安康市",
    "children": [{
      "value": "汉滨区",
      "code": "725001",
      "label": "汉滨区"
    }, {
      "value": "汉阴县",
      "code": "725100",
      "label": "汉阴县"
    }, {
      "value": "石泉县",
      "code": "725200",
      "label": "石泉县"
    }, {
      "value": "宁陕县",
      "code": "711600",
      "label": "宁陕县"
    }, {
      "value": "紫阳县",
      "code": "725300",
      "label": "紫阳县"
    }, {
      "value": "岚皋县",
      "code": "725400",
      "label": "岚皋县"
    }, {
      "value": "平利县",
      "code": "725500",
      "label": "平利县"
    }, {
      "value": "镇坪县",
      "code": "725600",
      "label": "镇坪县"
    }, {
      "value": "旬阳县",
      "code": "725700",
      "label": "旬阳县"
    }, {
      "value": "白河县",
      "code": "725800",
      "label": "白河县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "安康市"
  }, {
    "value": "商洛市",
    "children": [{
      "value": "商州区",
      "code": "726001",
      "label": "商州区"
    }, {
      "value": "洛南县",
      "code": "726100",
      "label": "洛南县"
    }, {
      "value": "丹凤县",
      "code": "726200",
      "label": "丹凤县"
    }, {
      "value": "商南县",
      "code": "726300",
      "label": "商南县"
    }, {
      "value": "山阳县",
      "code": "726400",
      "label": "山阳县"
    }, {
      "value": "镇安县",
      "code": "711500",
      "label": "镇安县"
    }, {
      "value": "柞水县",
      "code": "711400",
      "label": "柞水县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "商洛市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "陕西省",
  "label": "陕西省"
}, {
  "children": [{
    "value": "兰州市",
    "children": [{
      "value": "城关区",
      "code": "730010",
      "label": "城关区"
    }, {
      "value": "七里河区",
      "code": "730050",
      "label": "七里河区"
    }, {
      "value": "西固区",
      "code": "730060",
      "label": "西固区"
    }, {
      "value": "安宁区",
      "code": "730070",
      "label": "安宁区"
    }, {
      "value": "红古区",
      "code": "730080",
      "label": "红古区"
    }, {
      "value": "永登县",
      "code": "730087",
      "label": "永登县"
    }, {
      "value": "皋兰县",
      "code": "730200",
      "label": "皋兰县"
    }, {
      "value": "榆中县",
      "code": "730100",
      "label": "榆中县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "兰州市"
  }, {
    "value": "嘉峪关市",
    "label": "嘉峪关市"
  }, {
    "value": "金昌市",
    "children": [{
      "value": "金川区",
      "code": "737101",
      "label": "金川区"
    }, {
      "value": "永昌县",
      "code": "737109",
      "label": "永昌县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "金昌市"
  }, {
    "value": "白银市",
    "children": [{
      "value": "白银区",
      "code": "730910",
      "label": "白银区"
    }, {
      "value": "平川区",
      "code": "730913",
      "label": "平川区"
    }, {
      "value": "靖远县",
      "code": "730600",
      "label": "靖远县"
    }, {
      "value": "会宁县",
      "code": "730700",
      "label": "会宁县"
    }, {
      "value": "景泰县",
      "code": "730400",
      "label": "景泰县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "白银市"
  }, {
    "value": "天水市",
    "children": [{
      "value": "秦州区",
      "code": "741001",
      "label": "秦州区"
    }, {
      "value": "麦积区",
      "code": "741022",
      "label": "麦积区"
    }, {
      "value": "清水县",
      "code": "741400",
      "label": "清水县"
    }, {
      "value": "秦安县",
      "code": "741600",
      "label": "秦安县"
    }, {
      "value": "甘谷县",
      "code": "741200",
      "label": "甘谷县"
    }, {
      "value": "武山县",
      "code": "741300",
      "label": "武山县"
    }, {
      "value": "张家川回族自治县",
      "code": "741500",
      "label": "张家川回族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "天水市"
  }, {
    "value": "武威市",
    "children": [{
      "value": "凉州区",
      "code": "733001",
      "label": "凉州区"
    }, {
      "value": "民勤县",
      "code": "733300",
      "label": "民勤县"
    }, {
      "value": "古浪县",
      "code": "733100",
      "label": "古浪县"
    }, {
      "value": "天祝藏族自治县",
      "code": "733013",
      "label": "天祝藏族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "武威市"
  }, {
    "value": "张掖市",
    "children": [{
      "value": "甘州区",
      "code": "734012",
      "label": "甘州区"
    }, {
      "value": "肃南裕固族自治县",
      "code": "734028",
      "label": "肃南裕固族自治县"
    }, {
      "value": "民乐县",
      "code": "734500",
      "label": "民乐县"
    }, {
      "value": "临泽县",
      "code": "734200",
      "label": "临泽县"
    }, {
      "value": "高台县",
      "code": "734300",
      "label": "高台县"
    }, {
      "value": "山丹县",
      "code": "734100",
      "label": "山丹县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "张掖市"
  }, {
    "value": "平凉市",
    "children": [{
      "value": "崆峒区",
      "code": "744018",
      "label": "崆峒区"
    }, {
      "value": "泾川县",
      "code": "744304",
      "label": "泾川县"
    }, {
      "value": "灵台县",
      "code": "744400",
      "label": "灵台县"
    }, {
      "value": "崇信县",
      "code": "744200",
      "label": "崇信县"
    }, {
      "value": "华亭县",
      "code": "744100",
      "label": "华亭县"
    }, {
      "value": "庄浪县",
      "code": "744600",
      "label": "庄浪县"
    }, {
      "value": "静宁县",
      "code": "743400",
      "label": "静宁县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "平凉市"
  }, {
    "value": "酒泉市",
    "children": [{
      "value": "肃州区",
      "code": "735001",
      "label": "肃州区"
    }, {
      "value": "金塔县",
      "code": "735300",
      "label": "金塔县"
    }, {
      "value": "瓜州县",
      "code": "736099",
      "label": "瓜州县"
    }, {
      "value": "肃北蒙古族自治县",
      "code": "736300",
      "label": "肃北蒙古族自治县"
    }, {
      "value": "阿克塞哈萨克族自治县",
      "code": "736400",
      "label": "阿克塞哈萨克族自治县"
    }, {
      "value": "玉门市",
      "code": "735200",
      "label": "玉门市"
    }, {
      "value": "敦煌市",
      "code": "736200",
      "label": "敦煌市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "酒泉市"
  }, {
    "value": "庆阳市",
    "children": [{
      "value": "西峰区",
      "code": "745002",
      "label": "西峰区"
    }, {
      "value": "庆城县",
      "code": "745100",
      "label": "庆城县"
    }, {
      "value": "环县",
      "code": "745700",
      "label": "环县"
    }, {
      "value": "华池县",
      "code": "745600",
      "label": "华池县"
    }, {
      "value": "合水县",
      "code": "745400",
      "label": "合水县"
    }, {
      "value": "正宁县",
      "code": "745300",
      "label": "正宁县"
    }, {
      "value": "宁县",
      "code": "745200",
      "label": "宁县"
    }, {
      "value": "镇原县",
      "code": "744500",
      "label": "镇原县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "庆阳市"
  }, {
    "value": "定西市",
    "children": [{
      "value": "安定区",
      "code": "743007",
      "label": "安定区"
    }, {
      "value": "通渭县",
      "code": "743300",
      "label": "通渭县"
    }, {
      "value": "陇西县",
      "code": "748100",
      "label": "陇西县"
    }, {
      "value": "渭源县",
      "code": "748200",
      "label": "渭源县"
    }, {
      "value": "临洮县",
      "code": "730500",
      "label": "临洮县"
    }, {
      "value": "漳县",
      "code": "748300",
      "label": "漳县"
    }, {
      "value": "岷县",
      "code": "748400",
      "label": "岷县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "定西市"
  }, {
    "value": "陇南市",
    "children": [{
      "value": "武都区",
      "code": "746000",
      "label": "武都区"
    }, {
      "value": "成县",
      "code": "742504",
      "label": "成县"
    }, {
      "value": "文县",
      "code": "746400",
      "label": "文县"
    }, {
      "value": "宕昌县",
      "code": "748500",
      "label": "宕昌县"
    }, {
      "value": "康县",
      "code": "746500",
      "label": "康县"
    }, {
      "value": "西和县",
      "code": "742100",
      "label": "西和县"
    }, {
      "value": "礼县",
      "code": "742200",
      "label": "礼县"
    }, {
      "value": "徽县",
      "code": "742300",
      "label": "徽县"
    }, {
      "value": "两当县",
      "code": "742400",
      "label": "两当县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "陇南市"
  }, {
    "value": "临夏回族自治州",
    "children": [{
      "value": "临夏市",
      "code": "730405",
      "label": "临夏市"
    }, {
      "value": "临夏县",
      "code": "731800",
      "label": "临夏县"
    }, {
      "value": "康乐县",
      "code": "731500",
      "label": "康乐县"
    }, {
      "value": "永靖县",
      "code": "731600",
      "label": "永靖县"
    }, {
      "value": "广河县",
      "code": "731300",
      "label": "广河县"
    }, {
      "value": "和政县",
      "code": "731200",
      "label": "和政县"
    }, {
      "value": "东乡族自治县",
      "code": "731400",
      "label": "东乡族自治县"
    }, {
      "value": "积石山保安族东乡族撒拉族自治县",
      "code": "731503",
      "label": "积石山保安族东乡族撒拉族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "临夏回族自治州"
  }, {
    "value": "甘南藏族自治州",
    "children": [{
      "value": "合作市",
      "code": "747001",
      "label": "合作市"
    }, {
      "value": "临潭县",
      "code": "747500",
      "label": "临潭县"
    }, {
      "value": "卓尼县",
      "code": "747600",
      "label": "卓尼县"
    }, {
      "value": "舟曲县",
      "code": "746300",
      "label": "舟曲县"
    }, {
      "value": "迭部县",
      "code": "747400",
      "label": "迭部县"
    }, {
      "value": "玛曲县",
      "code": "747300",
      "label": "玛曲县"
    }, {
      "value": "碌曲县",
      "code": "747200",
      "label": "碌曲县"
    }, {
      "value": "夏河县",
      "code": "747100",
      "label": "夏河县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "甘南藏族自治州"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "甘肃省",
  "label": "甘肃省"
}, {
  "children": [{
    "value": "西宁市",
    "children": [{
      "value": "城东区",
      "code": "810006",
      "label": "城东区"
    }, {
      "value": "城中区",
      "code": "810002",
      "label": "城中区"
    }, {
      "value": "城西区",
      "code": "810001",
      "label": "城西区"
    }, {
      "value": "城北区",
      "code": "810003",
      "label": "城北区"
    }, {
      "value": "大通回族土族自治县",
      "code": "810100",
      "label": "大通回族土族自治县"
    }, {
      "value": "湟中县",
      "code": "810011",
      "label": "湟中县"
    }, {
      "value": "湟源县",
      "code": "812100",
      "label": "湟源县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "西宁市"
  }, {
    "value": "海东市",
    "children": [{
      "value": "乐都区",
      "code": "810700",
      "label": "乐都区"
    }, {
      "value": "平安区",
      "code": "810699",
      "label": "平安区"
    }, {
      "value": "民和回族土族自治县",
      "code": "810800",
      "label": "民和回族土族自治县"
    }, {
      "value": "互助土族自治县",
      "code": "810500",
      "label": "互助土族自治县"
    }, {
      "value": "化隆回族自治县",
      "code": "810900",
      "label": "化隆回族自治县"
    }, {
      "value": "循化撒拉族自治县",
      "code": "811100",
      "label": "循化撒拉族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "海东市"
  }, {
    "value": "海北藏族自治州",
    "children": [{
      "value": "门源回族自治县",
      "code": "810300",
      "label": "门源回族自治县"
    }, {
      "value": "祁连县",
      "code": "810400",
      "label": "祁连县"
    }, {
      "value": "海晏县",
      "code": "810299",
      "label": "海晏县"
    }, {
      "value": "刚察县",
      "code": "812300",
      "label": "刚察县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "海北藏族自治州"
  }, {
    "value": "黄南藏族自治州",
    "children": [{
      "value": "同仁县",
      "code": "811301",
      "label": "同仁县"
    }, {
      "value": "尖扎县",
      "code": "811200",
      "label": "尖扎县"
    }, {
      "value": "泽库县",
      "code": "811400",
      "label": "泽库县"
    }, {
      "value": "河南蒙古族自治县",
      "code": "811500",
      "label": "河南蒙古族自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "黄南藏族自治州"
  }, {
    "value": "海南藏族自治州",
    "children": [{
      "value": "共和县",
      "code": "811899",
      "label": "共和县"
    }, {
      "value": "同德县",
      "code": "813200",
      "label": "同德县"
    }, {
      "value": "贵德县",
      "code": "811700",
      "label": "贵德县"
    }, {
      "value": "兴海县",
      "code": "813300",
      "label": "兴海县"
    }, {
      "value": "贵南县",
      "code": "813100",
      "label": "贵南县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "海南藏族自治州"
  }, {
    "value": "果洛藏族自治州",
    "children": [{
      "value": "玛沁县",
      "code": "814000",
      "label": "玛沁县"
    }, {
      "value": "班玛县",
      "code": "814300",
      "label": "班玛县"
    }, {
      "value": "甘德县",
      "code": "814100",
      "label": "甘德县"
    }, {
      "value": "达日县",
      "code": "814200",
      "label": "达日县"
    }, {
      "value": "久治县",
      "code": "624700",
      "label": "久治县"
    }, {
      "value": "玛多县",
      "code": "813500",
      "label": "玛多县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "果洛藏族自治州"
  }, {
    "value": "玉树藏族自治州",
    "children": [{
      "value": "玉树市",
      "code": "815002",
      "label": "玉树市"
    }, {
      "value": "杂多县",
      "code": "815300",
      "label": "杂多县"
    }, {
      "value": "称多县",
      "code": "815100",
      "label": "称多县"
    }, {
      "value": "治多县",
      "code": "815400",
      "label": "治多县"
    }, {
      "value": "囊谦县",
      "code": "815200",
      "label": "囊谦县"
    }, {
      "value": "曲麻莱县",
      "code": "815500",
      "label": "曲麻莱县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "玉树藏族自治州"
  }, {
    "value": "海西蒙古族藏族自治州",
    "children": [{
      "value": "格尔木市",
      "code": "816000",
      "label": "格尔木市"
    }, {
      "value": "德令哈市",
      "code": "817001",
      "label": "德令哈市"
    }, {
      "value": "乌兰县",
      "code": "817100",
      "label": "乌兰县"
    }, {
      "value": "都兰县",
      "code": "816100",
      "label": "都兰县"
    }, {
      "value": "天峻县",
      "code": "817200",
      "label": "天峻县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "海西蒙古族藏族自治州"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "青海省",
  "label": "青海省"
}, {
  "children": [{
    "value": "银川市",
    "children": [{
      "value": "兴庆区",
      "code": "750001",
      "label": "兴庆区"
    }, {
      "value": "西夏区",
      "code": "750013",
      "label": "西夏区"
    }, {
      "value": "金凤区",
      "code": "750016",
      "label": "金凤区"
    }, {
      "value": "永宁县",
      "code": "750100",
      "label": "永宁县"
    }, {
      "value": "贺兰县",
      "code": "750200",
      "label": "贺兰县"
    }, {
      "value": "灵武市",
      "code": "750403",
      "label": "灵武市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "银川市"
  }, {
    "value": "石嘴山市",
    "children": [{
      "value": "大武口区",
      "code": "753001",
      "label": "大武口区"
    }, {
      "value": "惠农区",
      "code": "753204",
      "label": "惠农区"
    }, {
      "value": "平罗县",
      "code": "753400",
      "label": "平罗县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "石嘴山市"
  }, {
    "value": "吴忠市",
    "children": [{
      "value": "利通区",
      "code": "751101",
      "label": "利通区"
    }, {
      "value": "红寺堡区",
      "code": "751999",
      "label": "红寺堡区"
    }, {
      "value": "盐池县",
      "code": "751500",
      "label": "盐池县"
    }, {
      "value": "同心县",
      "code": "751300",
      "label": "同心县"
    }, {
      "value": "青铜峡市",
      "code": "751600",
      "label": "青铜峡市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "吴忠市"
  }, {
    "value": "固原市",
    "children": [{
      "value": "原州区",
      "code": "756001",
      "label": "原州区"
    }, {
      "value": "西吉县",
      "code": "756200",
      "label": "西吉县"
    }, {
      "value": "隆德县",
      "code": "756300",
      "label": "隆德县"
    }, {
      "value": "泾源县",
      "code": "756400",
      "label": "泾源县"
    }, {
      "value": "彭阳县",
      "code": "756500",
      "label": "彭阳县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "固原市"
  }, {
    "value": "中卫市",
    "children": [{
      "value": "沙坡头区",
      "code": "755001",
      "label": "沙坡头区"
    }, {
      "value": "中宁县",
      "code": "755100",
      "label": "中宁县"
    }, {
      "value": "海原县",
      "code": "755200",
      "label": "海原县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "中卫市"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "宁夏回族自治区",
  "label": "宁夏回族自治区"
}, {
  "children": [{
    "value": "乌鲁木齐市",
    "children": [{
      "value": "天山区",
      "code": "830001",
      "label": "天山区"
    }, {
      "value": "沙依巴克区",
      "code": "830006",
      "label": "沙依巴克区"
    }, {
      "value": "新市区",
      "code": "830010",
      "label": "新市区"
    }, {
      "value": "水磨沟区",
      "code": "830017",
      "label": "水磨沟区"
    }, {
      "value": "头屯河区",
      "code": "830068",
      "label": "头屯河区"
    }, {
      "value": "达坂城区",
      "code": "830023",
      "label": "达坂城区"
    }, {
      "value": "米东区",
      "code": "830019",
      "label": "米东区"
    }, {
      "value": "乌鲁木齐县",
      "code": "830025",
      "label": "乌鲁木齐县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "乌鲁木齐市"
  }, {
    "value": "克拉玛依市",
    "children": [{
      "value": "独山子区",
      "code": "833699",
      "label": "独山子区"
    }, {
      "value": "克拉玛依区",
      "code": "834002",
      "label": "克拉玛依区"
    }, {
      "value": "白碱滩区",
      "code": "834007",
      "label": "白碱滩区"
    }, {
      "value": "乌尔禾区",
      "code": "834011",
      "label": "乌尔禾区"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "克拉玛依市"
  }, {
    "value": "吐鲁番市",
    "children": [{
      "value": "高昌区",
      "code": "838001",
      "label": "高昌区"
    }, {
      "value": "鄯善县",
      "code": "838200",
      "label": "鄯善县"
    }, {
      "value": "托克逊县",
      "code": "830024",
      "label": "托克逊县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "吐鲁番市"
  }, {
    "value": "哈密地区",
    "children": [{
      "value": "哈密市",
      "code": "839001",
      "label": "哈密市"
    }, {
      "value": "巴里坤哈萨克自治县",
      "code": "839200",
      "label": "巴里坤哈萨克自治县"
    }, {
      "value": "伊吾县",
      "code": "839300",
      "label": "伊吾县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "哈密地区"
  }, {
    "value": "昌吉回族自治州",
    "children": [{
      "value": "昌吉市",
      "code": "831101",
      "label": "昌吉市"
    }, {
      "value": "阜康市",
      "code": "831500",
      "label": "阜康市"
    }, {
      "value": "呼图壁县",
      "code": "831200",
      "label": "呼图壁县"
    }, {
      "value": "玛纳斯县",
      "code": "832200",
      "label": "玛纳斯县"
    }, {
      "value": "奇台县",
      "code": "831800",
      "label": "奇台县"
    }, {
      "value": "吉木萨尔县",
      "code": "831700",
      "label": "吉木萨尔县"
    }, {
      "value": "木垒哈萨克自治县",
      "code": "831900",
      "label": "木垒哈萨克自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "昌吉回族自治州"
  }, {
    "value": "博尔塔拉蒙古自治州",
    "children": [{
      "value": "博乐市",
      "code": "833403",
      "label": "博乐市"
    }, {
      "value": "阿拉山口市",
      "code": "833418",
      "label": "阿拉山口市"
    }, {
      "value": "精河县",
      "code": "833301",
      "label": "精河县"
    }, {
      "value": "温泉县",
      "code": "833500",
      "label": "温泉县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "博尔塔拉蒙古自治州"
  }, {
    "value": "巴音郭楞蒙古自治州",
    "children": [{
      "value": "库尔勒市",
      "code": "841001",
      "label": "库尔勒市"
    }, {
      "value": "轮台县",
      "code": "841600",
      "label": "轮台县"
    }, {
      "value": "尉犁县",
      "code": "841500",
      "label": "尉犁县"
    }, {
      "value": "若羌县",
      "code": "841800",
      "label": "若羌县"
    }, {
      "value": "且末县",
      "code": "841900",
      "label": "且末县"
    }, {
      "value": "焉耆回族自治县",
      "code": "841100",
      "label": "焉耆回族自治县"
    }, {
      "value": "和静县",
      "code": "841300",
      "label": "和静县"
    }, {
      "value": "和硕县",
      "code": "841200",
      "label": "和硕县"
    }, {
      "value": "博湖县",
      "code": "841400",
      "label": "博湖县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "巴音郭楞蒙古自治州"
  }, {
    "value": "阿克苏地区",
    "children": [{
      "value": "阿克苏市",
      "code": "843001",
      "label": "阿克苏市"
    }, {
      "value": "温宿县",
      "code": "843015",
      "label": "温宿县"
    }, {
      "value": "库车县",
      "code": "842000",
      "label": "库车县"
    }, {
      "value": "沙雅县",
      "code": "842200",
      "label": "沙雅县"
    }, {
      "value": "新和县",
      "code": "842100",
      "label": "新和县"
    }, {
      "value": "拜城县",
      "code": "842300",
      "label": "拜城县"
    }, {
      "value": "乌什县",
      "code": "843400",
      "label": "乌什县"
    }, {
      "value": "阿瓦提县",
      "code": "843011",
      "label": "阿瓦提县"
    }, {
      "value": "柯坪县",
      "code": "843600",
      "label": "柯坪县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "阿克苏地区"
  }, {
    "value": "克孜勒苏柯尔克孜自治州",
    "children": [{
      "value": "阿图什市",
      "code": "845351",
      "label": "阿图什市"
    }, {
      "value": "阿克陶县",
      "code": "845550",
      "label": "阿克陶县"
    }, {
      "value": "阿合奇县",
      "code": "843500",
      "label": "阿合奇县"
    }, {
      "value": "乌恰县",
      "code": "845450",
      "label": "乌恰县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "克孜勒苏柯尔克孜自治州"
  }, {
    "value": "喀什地区",
    "children": [{
      "value": "喀什市",
      "code": "844099",
      "label": "喀什市"
    }, {
      "value": "疏附县",
      "code": "844100",
      "label": "疏附县"
    }, {
      "value": "疏勒县",
      "code": "844004",
      "label": "疏勒县"
    }, {
      "value": "英吉沙县",
      "code": "844500",
      "label": "英吉沙县"
    }, {
      "value": "泽普县",
      "code": "844800",
      "label": "泽普县"
    }, {
      "value": "莎车县",
      "code": "844700",
      "label": "莎车县"
    }, {
      "value": "叶城县",
      "code": "844900",
      "label": "叶城县"
    }, {
      "value": "麦盖提县",
      "code": "844600",
      "label": "麦盖提县"
    }, {
      "value": "岳普湖县",
      "code": "844400",
      "label": "岳普湖县"
    }, {
      "value": "伽师县",
      "code": "844300",
      "label": "伽师县"
    }, {
      "value": "巴楚县",
      "code": "843800",
      "label": "巴楚县"
    }, {
      "value": "塔什库尔干塔吉克自治县",
      "code": "845250",
      "label": "塔什库尔干塔吉克自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "喀什地区"
  }, {
    "value": "和田地区",
    "children": [{
      "value": "和田市",
      "code": "848000",
      "label": "和田市"
    }, {
      "value": "和田县",
      "code": "848002",
      "label": "和田县"
    }, {
      "value": "墨玉县",
      "code": "848100",
      "label": "墨玉县"
    }, {
      "value": "皮山县",
      "code": "845150",
      "label": "皮山县"
    }, {
      "value": "洛浦县",
      "code": "848200",
      "label": "洛浦县"
    }, {
      "value": "策勒县",
      "code": "848300",
      "label": "策勒县"
    }, {
      "value": "于田县",
      "code": "848400",
      "label": "于田县"
    }, {
      "value": "民丰县",
      "code": "848500",
      "label": "民丰县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "和田地区"
  }, {
    "value": "伊犁哈萨克自治州",
    "children": [{
      "value": "伊宁市",
      "code": "835001",
      "label": "伊宁市"
    }, {
      "value": "奎屯市",
      "code": "833200",
      "label": "奎屯市"
    }, {
      "value": "霍尔果斯市",
      "code": "835216",
      "label": "霍尔果斯市"
    }, {
      "value": "伊宁县",
      "code": "835100",
      "label": "伊宁县"
    }, {
      "value": "察布查尔锡伯自治县",
      "code": "835300",
      "label": "察布查尔锡伯自治县"
    }, {
      "value": "霍城县",
      "code": "835200",
      "label": "霍城县"
    }, {
      "value": "巩留县",
      "code": "835400",
      "label": "巩留县"
    }, {
      "value": "新源县",
      "code": "835800",
      "label": "新源县"
    }, {
      "value": "昭苏县",
      "code": "835600",
      "label": "昭苏县"
    }, {
      "value": "特克斯县",
      "code": "835500",
      "label": "特克斯县"
    }, {
      "value": "尼勒克县",
      "code": "835700",
      "label": "尼勒克县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "伊犁哈萨克自治州"
  }, {
    "value": "塔城地区",
    "children": [{
      "value": "塔城市",
      "code": "834300",
      "label": "塔城市"
    }, {
      "value": "乌苏市",
      "code": "833001",
      "label": "乌苏市"
    }, {
      "value": "额敏县",
      "code": "834600",
      "label": "额敏县"
    }, {
      "value": "沙湾县",
      "code": "832100",
      "label": "沙湾县"
    }, {
      "value": "托里县",
      "code": "834500",
      "label": "托里县"
    }, {
      "value": "裕民县",
      "code": "834800",
      "label": "裕民县"
    }, {
      "value": "和布克赛尔蒙古自治县",
      "code": "834400",
      "label": "和布克赛尔蒙古自治县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "塔城地区"
  }, {
    "value": "阿勒泰地区",
    "children": [{
      "value": "阿勒泰市",
      "code": "836007",
      "label": "阿勒泰市"
    }, {
      "value": "布尔津县",
      "code": "836600",
      "label": "布尔津县"
    }, {
      "value": "富蕴县",
      "code": "836100",
      "label": "富蕴县"
    }, {
      "value": "福海县",
      "code": "836400",
      "label": "福海县"
    }, {
      "value": "哈巴河县",
      "code": "836700",
      "label": "哈巴河县"
    }, {
      "value": "青河县",
      "code": "836200",
      "label": "青河县"
    }, {
      "value": "吉木乃县",
      "code": "836800",
      "label": "吉木乃县"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "阿勒泰地区"
  }, {
    "value": "自治区直辖县级行政区划",
    "children": [{
      "value": "石河子市",
      "code": "832000",
      "label": "石河子市"
    }, {
      "value": "阿拉尔市",
      "code": "843300",
      "label": "阿拉尔市"
    }, {
      "value": "图木舒克市",
      "code": "843999",
      "label": "图木舒克市"
    }, {
      "value": "五家渠市",
      "code": "831300",
      "label": "五家渠市"
    }, {
      "value": "北屯市",
      "code": "836002",
      "label": "北屯市"
    }, {
      "value": "铁门关市",
      "code": "841007",
      "label": "铁门关市"
    }, {
      "value": "双河市",
      "code": "833408",
      "label": "双河市"
    }, {
      "value": "可克达拉市",
      "code": "835219",
      "label": "可克达拉市"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }],
    "label": "自治区直辖县级行政区划"
  }, {
    "value": "不详",
    "label": "不详",
    "children": [{
      "value": "不详",
      "code": "",
      "label": "不详"
    }, {
      "value": "不详",
      "code": "",
      "label": "不详"
    }]
  }],
  "value": "新疆维吾尔自治区",
  "label": "新疆维吾尔自治区"
}, {
  "value": "台湾省",
  "label": "台湾省"
}, {
  "value": "香港特别行政区",
  "label": "香港特别行政区"
}, {
  "value": "澳门特别行政区",
  "label": "澳门特别行政区"
}];
export default regionData;


//////////////////
// WEBPACK FOOTER
// ./src/components/preEntry/citySelectData/zt-cityselect-data.js
// module id = 992
// module chunks = 2